// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "رمز عبور خود را فراموش کرده‌اید؟",
   "forgot-password-description":
      "ایمیل خود را در پایین وارد کنید تا کد تایید را دریافت کرده و رمز عبور خود را بازیابی کنید",
   email: "ایمیل",
   cancel: "لغو",
   submit: "ارسال",
   "menu-section-stakeholders": "ذینفعان",
   "menu-section-setup": "تنظیم",
   "menu-section-implementation": "اجرا",
   "menu-section-support": "پشتیبانی",
   "menu-item-experts": "کارشناسان",
   "menu-item-approvers": "تأییدکنندگان",
   "menu-item-organizations": "سازمان‌ها",
   "menu-item-requests": "درخواست‌ها",
   "menu-item-assessments": "ارزیابی‌ها",
   "menu-item-modules": "ماژول‌ها",
   "menu-item-targets": "اهداف",
   "menu-item-workspaces": "فضاهای کاری",
   "menu-item-tickets": "تکت‌ها",
   "menu-section-organization-management": "مدیریت سازمان",
   "menu-section-my-account": "حساب من",
   "menu-item-profile": "پروفایل",
   "menu-item-team": "تیم",
   "menu-item-help-desk": "میز کمک",

   name: "نام",
   country: "کشور",
   "phone-number": "شماره تلفن",
   expertise: "تخصص",
   "disabled-reason": "دلیل غیرفعال شدن",
   "not-applicable": "قابل اجرا نیست",
   export: "صادرات",
   "status-pending": "در انتظار",
   "status-rejected": "رد شده",
   "status-active": "فعال",
   "status-disabled": "غیرفعال",

   "experts-management-title": "کارشناسان",
   "experts-request-tab": "درخواست کارشناس",
   "experts-approved-tab": "کارشناسان تایید شده",
   "experts-deleted-button": "کارشناسان حذف شده",
   "experts-status-deactivated": "غیرفعال",

   "filter-search-label": "به دنبال چه چیزی هستید؟",
   "search-placeholder": "جستجو",
   "search-by-name-placeholder": "جستجو بر اساس نام",
   "search-task-by-name-placeholder": "جستجوی یک وظیفه بر اساس نام آن",
   "search-module-by-name-placeholder": "جستجوی یک ماژول بر اساس نام آن",
   "search-workspace-by-name-placeholder": "جستجوی یک فضای کاری بر اساس نام آن",
   "search-assessment-by-name-placeholder": "جستجوی یک ارزیابی بر اساس نام آن",
   "search-expert-by-name-placeholder": "جستجوی یک کارشناس بر اساس نام آن",
   "search-request-by-name-placeholder": "جستجوی درخواست بر اساس نام سازمان درخواست‌کننده",
   "search-request-by-email-placeholder": "جستجوی درخواست بر اساس ایمیل سازمان درخواست‌کننده",
   "search-request-by-name-or-email-placeholder": "جستجو بر اساس نام یا ایمیل",
   "search-invoice-by-name-placeholder": "جستجوی یک فاکتور بر اساس نام آن",
   "search-organization-by-name-placeholder": "جستجوی یک سازمان بر اساس نام آن",
   "filter-by-type-placeholder": "فلتر بر اساس نوع",
   "filter-by-start-date-placeholder": "فلتر بر اساس تاریخ شروع",
   "filter-by-end-date-placeholder": "فلتر بر اساس تاریخ ختم",
   "filter-by-year-placeholder": "فلتر بر اساس سال",
   "filter-tasks-by-assigned-member-placeholder": "فلتر وظایف بر اساس عضو تعیین‌شده",
   "filter-tasks-by-status-placeholder": "فلتر وظایف بر اساس وضعیت",
   "filter-workspace-request-by-status-placeholder": "فلتر درخواست فضای کاری بر اساس وضعیت",
   "filter-workspace-by-country-placeholder": "فلتر فضاهای کاری بر اساس کشور",
   "filter-experts-by-country-placeholder": "فلتر کارشناسان بر اساس کشور",
   "filter-by-submission-date-placeholder": "فلتر بر اساس تاریخ ارسال",
   "filter-by-assessments-placeholder": "فلتر بر اساس ارزیابی‌ها",
   "filter-by-assessment-placeholder": "فلتر بر اساس ارزیابی",
   "filter-by-workspace-placeholder": "فلتر بر اساس فضای کاری",
   "filter-by-score-placeholder": "فلتر بر اساس امتیاز",
   "filter-by-country-placeholder": "فلتر بر اساس کشور",
   "filter-by-operating-countries-placeholder": "فلتر بر اساس کشورهای فعالیت",
   "filter-by-sectors-placeholder": "فلتر بر اساس بخش‌ها",
   "export-organizations-button": "صادرات سازمان‌ها",
   "filter-by-module-placeholder": "فلتر بر اساس ماژول",
   "filter-by-round-placeholder": "فلتر بر اساس دور",
   "filter-by-section-placeholder": "فلتر بر اساس بخش",
   "filter-by-owner-placeholder": "فلتر بر اساس مالک",
   "search-by-its-name-placeholder": "جستجو بر اساس نام",
   "guided-assessment": "ارزیابی رهنمایی‌شده",
   "self-assessment": "خودارزیابی",
   "clear-all-button": "پاک کردن همه",
   "filters-button": "فلترها",
   workspace: "فضای کاری",
   assessment: "ارزیابی",
   score: "امتیاز",
   city: "شهر",
   "operating-countries": "کشورهای فعالیت",
   sectors: "بخش‌ها",
   type: "نوع",
   organizations: "سازمان‌ها",
   "select-workspace-placeholder": "فضای کاری را انتخاب کنید",
   "select-assessment-placeholder": "ارزیابی را انتخاب کنید",
   "select-score-range-placeholder": "محدوده امتیاز را انتخاب کنید",
   "select-country-placeholder": "کشور را انتخاب کنید",
   "select-base-city-placeholder": "شهر اصلی خود را انتخاب کنید",
   "select-sectors-placeholder": "بخش‌ها را انتخاب کنید",
   "select-type-placeholder": "نوع را انتخاب کنید",

   "toast-oops-title": "خطا! یک مشکل رخ داده است!",
   "toast-request-accepted-success-title": "درخواست با موفقیت پذیرفته شد!",
   "toast-request-accepted-success-description":
      "این درخواست با موفقیت پذیرفته شد، پاسخ به کاربر درخواست‌کننده اطلاع داده خواهد شد.",
   "toast-request-accept-error-description":
      "در پذیرفتن این درخواست مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "toast-request-rejected-success-title": "درخواست با موفقیت رد شد!",
   "toast-request-rejected-success-description":
      "این درخواست با موفقیت رد شد، پاسخ به کاربر درخواست‌کننده اطلاع داده خواهد شد.",
   "toast-request-reject-error-description":
      "در رد کردن این درخواست مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "toast-requests-accepted-success-title": "درخواست‌ها با موفقیت پذیرفته شدند!",
   "toast-requests-accepted-success-description":
      "درخواست‌ها با موفقیت پذیرفته شدند، پاسخ به کاربران درخواست‌کننده اطلاع داده خواهد شد.",
   "toast-requests-accept-error-description":
      "در پذیرفتن این درخواست‌ها مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "toast-requests-rejected-success-title": "درخواست‌ها با موفقیت رد شدند!",
   "toast-requests-rejected-success-description":
      "درخواست‌ها با موفقیت رد شدند، پاسخ به کاربران درخواست‌کننده اطلاع داده خواهد شد.",
   "toast-requests-reject-error-description":
      "در رد کردن این درخواست‌ها مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "approve-all-button": "پذیرفتن همه",
   "reject-all-button": "رد کردن همه",

   "search-target-placeholder": "جستجوی یک هدف بر اساس نام ارزیابی یا ماژول",
   "show-active-rounds-checkbox": "نمایش دوره‌های فعال",

   "general-score-column": "امتیاز عمومی",
   "submissions-column": "ارسال‌ها",
   "tasks-column": "وظایف",
   "areas-complete-text": "ساحه تکمیل شده",
   "organizations-progress-summary-title": "خلاصه پیشرفت سازمان‌ها",
   "export-progress-summary-button": "صادرات خلاصه پیشرفت",
   "select-module-performance-label": "ماژول را انتخاب کنید تا عملکرد سازمان‌ها را ببینید",
   "all-modules-placeholder": "همه ماژول‌ها",

   "registration-request-tab": "درخواست ثبت‌نام",
   "workspace-request-tab": "درخواست فضای کاری",
   "assessment-request-tab": "درخواست ارزیابی",
   "status-approved": "تایید شده",
   "requesting-user-column": "کاربر درخواست‌کننده",
   "request-date-column": "تاریخ درخواست",
   "approval-date-column": "تاریخ تایید",
   "processed-by-column": "پردازش شده توسط",
   "workspace-name-column": "نام فضای کاری",
   "assessment-name-column": "نام ارزیابی",
   "consultant-name-column": "نام مشاور",
   "rejection-date-column": "تاریخ رد",
   "accept-request-title": "پذیرفتن درخواست",
   "accept-request-button": "پذیرفتن درخواست",
   "accept-request-description": "شما در حال پذیرفتن این درخواست هستید. این عمل قابل بازگشت نیست.",
   "reject-request": "رد کردن درخواست",
   "reject-request-description": "شما در حال رد کردن این درخواست هستید. این عمل قابل بازگشت نیست.",
   "confirm-continue-text": "آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
   "reject-button": "رد کردن",
   "approve-button": "تایید",
   "organization-request-title": "درخواست سازمان",
   "foundation-label": "تاریخ تاسیس",
   "address-label": "آدرس",
   "organization-sectors-label": "بخش‌های سازمان",
   "organization-type-label": "نوع سازمان",
   "organization-size-label": "اندازه سازمان",
   "organization-name-label": "نام سازمان",
   "organization-description-label": "توضیحات سازمان",

   "organization-deleted-success-title": "سازمان با موفقیت حذف شد!",
   "organization-deleted-success-description": "این سازمان با موفقیت حذف شد.",
   "organization-delete-error-description": "در حذف این سازمان مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "organization-restored-success-title": "سازمان با موفقیت بازیابی شد!",
   "organization-restored-success-description": "این سازمان با موفقیت بازیابی شد.",
   "organization-restore-error-description":
      "در غیرفعال کردن این سازمان مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "organization-restore-failed-error-description":
      "در بازیابی این سازمان مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "organization-disabled-success-title": "سازمان با موفقیت غیرفعال شد!",
   "organization-disabled-success-description": "این سازمان با موفقیت غیرفعال شد.",
   "disable-organization-title": "غیرفعال کردن سازمان",
   "disable-organization-description-text":
      "شما در حال غیرفعال کردن این سازمان هستید. این سازمان تا زمانی که دوباره فعال شود، به لیست سازمان‌های غیرفعال منتقل خواهد شد.",
   "reason-for-disabling-label": "دلیل غیرفعال کردن",
   "disable-organization-reason-placeholder": "لطفاً دلیل غیرفعال کردن این سازمان را وارد کنید",
   "disable-button": "غیرفعال کردن",
   "restore-organization-title": "بازیابی سازمان",
   "registration-date-column": "تاریخ ثبت",
   "organization-list-title": "لیست سازمان‌ها",
   "enroll-organizations-button": "ثبت‌نام در یک فضای کاری دیگر",
   "registered-organizations-label": "سازمان‌های ثبت‌شده",
   "average-score-label": "میانگین امتیاز",
   "registered-as-of-text": "ثبت شده از",
   "social-networks-title": "شبکه‌های اجتماعی",
   "offices-title": "دفاتر",
   "ongoing-projects-label": "پروژه‌های جاری",
   "members-label": "اعضا",
   "representative-label": "نماینده",
   "representative-name-label": "نام نماینده",
   "representative-title-label": "عنوان نماینده",
   "representative-location-label": "موقعیت نماینده",
   "representative-phone-label": "شماره تلفن نماینده",
   "representative-skype-label": "اسکایپ نماینده",
   "representative-email-label": "ایمیل نماینده",

   "workspace-required-validation": "فضای کاری الزامی است",
   "organizations-enrolled-success-title": "سازمان‌ها با موفقیت ثبت‌نام شدند!",
   "organizations-enrolled-success-description":
      "این سازمان‌ها با موفقیت در فضای کاری انتخابی شما ثبت‌نام شدند.",
   "organizations-enroll-error-description":
      "در ثبت‌نام این سازمان‌ها مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "enroll-organization-modal-title": "ثبت‌نام سازمان در یک فضای کاری دیگر",
   "select-workspace-to-enroll-label": "فضای کاری را برای ثبت‌نام سازمان‌ها انتخاب کنید",
   "confirm-button": "تأیید",
   "delete-button": "حذف",
   "delete-organization-title": "حذف سازمان",
   "delete-organization-description": "شما در حال حذف این سازمان هستید. این عمل قابل بازگشت نیست.",

   "update-successful-message": "به‌روزرسانی موفقیت‌آمیز بود",
   "max-50-symbols-validation": "حداکثر ۵۰ حرف",
   "min-3-symbols-validation": "حداقل ۳ حرف",
   "invalid-email-validation": "ایمیل نامعتبر",
   "required-validation": "الزامی",
   "edit-organization-details-title": "ویرایش جزئیات سازمان",
   "project-number-title": "شماره پروژه",
   "ongoing-project-number-label": "شماره پروژه‌های جاری",
   "social-label": "شبکه‌های اجتماعی",
   "website-label": "وب‌سایت",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "بازگشت",
   "update-button": "به‌روزرسانی",

   "representative-removed-success-title": "جزئیات نماینده با موفقیت حذف شد!",
   "representative-removed-success-description": "اطلاعات جزئیات نماینده شما حذف شد.",
   "representative-remove-error-description":
      "در حذف اطلاعات جزئیات نماینده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "profile-status-changed-title": "وضعیت پروفایل شما تغییر کرد!",
   "profile-status-changed-description": "وضعیت پروفایل شما با موفقیت تغییر کرد.",
   "profile-status-change-error-description":
      "در تغییر وضعیت پروفایل مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "go-back-to-organizations-link": "بازگشت به سازمان‌ها",
   "print-profile-button": "چاپ پروفایل",
   "make-profile-public-button": "پروفایل را عمومی کن",
   "make-profile-private-button": "پروفایل را خصوصی کن",
   "complete-profile-reminder-title": "فراموش نکنید پروفایل خود را تکمیل کنید!",
   "complete-profile-reminder-description":
      "با تکمیل پروفایل و عمومی کردن آن، دیده‌شدن خود را در جامعه افزایش دهید.",
   "complete-profile-now-button": "اکنون پروفایل را تکمیل کنید",
   "profile-status-label": "وضعیت پروفایل",
   "private-status": "خصوصی",
   "public-status": "عمومی",
   "organization-email-label": "ایمیل سازمان",
   "base-country-label": "کشور پایه",
   "zip-code-label": "کد پستی",
   "about-label": "درباره",
   "foundation-date-label": "تاریخ تأسیس",
   "organizations-size-label": "اندازه سازمان‌ها",
   "countries-where-operate-label": "کشورهایی که سازمان در آن‌ها فعالیت می‌کند",
   "sector-that-works-label": "بخشی که سازمان در آن فعالیت می‌کند",
   "representative-details-title": "جزئیات نماینده",
   "delete-all-representative-info-button": "حذف تمام اطلاعات نماینده",
   "add-representative-details-button": "افزودن جزئیات نماینده",
   "no-information-available-text": "اطلاعاتی موجود نیست",
   "location-label": "موقعیت",
   "edit-representative-details-button": "ویرایش جزئیات نماینده",
   "assessments-scores-title": "نتایج ارزیابی‌ها",
   "assessments-scores-description": "نتایج این سازمان را در ارزیابی‌های تکمیل‌شده بررسی کنید.",
   "select-self-assessment-placeholder": "ارزیابی خودی را انتخاب کنید",
   "no-self-assessment-yet-title": "هنوز ارزیابی خودی وجود ندارد",
   "no-self-assessment-yet-description": "این سازمان هنوز ارزیابی خودی را تکمیل نکرده است",
   "select-guided-assessment-placeholder": "ارزیابی هدایت‌شده را انتخاب کنید",
   "no-guided-assessment-yet-title": "هنوز ارزیابی هدایت‌شده‌ای وجود ندارد",
   "no-guided-assessment-yet-description": "این سازمان هنوز ارزیابی هدایت‌شده را تکمیل نکرده است",
   "team-member-list-title": "لیست اعضای تیم",
   "team-member-list-description":
      "اعضای تیم خود را اضافه کنید و برای تقویت سازمان خود همکاری کنید. این بخش فقط برای شما قابل مشاهده است. حتی اگر پروفایل شما عمومی باشد، هیچ‌کس دیگری نمی‌تواند اعضایی را که اضافه می‌کنید ببیند.",
   "latest-round-label": "آخرین دور",
   "size-label": "اندازه",
   "select-number-placeholder": "عدد را انتخاب کنید",
   "select-date-placeholder": "تاریخی را انتخاب کنید",

   "profile-updated-success-title": "پروفایل با موفقیت به‌روزرسانی شد!",
   "profile-updated-success-description": "اطلاعات پروفایل شما به درستی به‌روزرسانی شد.",
   "profile-update-error-description":
      "در به‌روزرسانی اطلاعات پروفایل شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "international-name-required-validation": "نام بین‌المللی الزامی است",
   "date-of-establishment-required-validation": "تاریخ تأسیس الزامی است",
   "address-required-validation": "آدرس الزامی است",
   "zip-code-required-validation": "کد پستی الزامی است",
   "email-required-validation": "ایمیل الزامی است",
   "invalid-phone-number-validation": "شماره تلفن نامعتبر",
   "phone-number-required-validation": "شماره تلفن الزامی است",
   "at-least-one-sector-required-validation": "حداقل یک بخش الزامی است",
   "organization-size-required-validation": "اندازه سازمان الزامی است",
   "at-least-one-country-required-validation": "حداقل یک کشور الزامی است",
   "base-country-required-validation": "کشور پایه الزامی است",
   "city-required-validation": "شهر الزامی است",
   "edit-profile-title": "ویرایش پروفایل",
   "organization-details-tab": "جزئیات سازمان",
   "international-name-placeholder": "نام بین‌المللی",
   "description-placeholder": "توضیحات",
   "foundation-year-label": "سال تأسیس",
   "select-organization-size-placeholder": "اندازه سازمان را انتخاب کنید",
   "countries-where-operates-label": "کشورهایی که سازمان در آن‌ها فعالیت می‌کند",
   "select-operating-countries-placeholder": "کشورهای فعالیت را انتخاب کنید",
   "working-sector-label": "بخش کاری",
   "select-sectors-alt-placeholder": "بخش‌ها را انتخاب کنید",
   "contact-information-tab": "اطلاعات تماس",
   "organizations-email-label": "ایمیل سازمان",
   "select-base-country-placeholder": "کشور پایه را انتخاب کنید",
   "select-a-city-placeholder": "شهری را انتخاب کنید",
   "save-changes-button": "ذخیره تغییرات",

   // Profile information page (account profile edit forms)
   "name-label": "نام",
   "city-label": "شهر",
   "birthdate-label": "تاریخ تولد",
   "select-your-prefix": "انتخاب کنید",
   "area-of-expertise-colon-label": "ساحه تخصص:",
   "years-suffix-label": "سال",
   "professional-details-title": "جزئیات مسلکی",
   "enter-current-password-placeholder": "رمز عبور فعلی خود را وارد کنید",
   "enter-new-password-placeholder": "رمز عبور جدید خود را وارد کنید",
   "enter-new-password-again-placeholder": "رمز عبور جدید خود را دوباره وارد کنید",
   "enter-your-email-placeholder": "ایمیل خود را وارد کنید",

   // Login information page (LoginInfo.js)
   "account-information-label": "معلومات حساب",
   "email-label": "ایمیل",
   "current-password-label": "رمز عبور فعلی",
   "new-password-label": "رمز عبور جدید",
   "password-hint-intro-text": "برای محافظت از حساب تان، رمز عبور تان باید حد اقل شامل موارد ذیل باشد:",
   "password-hint-length": "حد اقل ۸ حرف",
   "password-hint-uppercase": "یک حرف بزرگ",
   "password-hint-lowercase": "یک حرف کوچک",
   "password-hint-number": "یک عدد",
   "password-hint-special": "یک نشانه خاص",
   "change-password-here-text": "شما می‌توانید رمز عبور خود را اینجا تغییر دهید",
   "email-changed-success-title": "ایمیل با موفقیت تغییر کرد!",
   "email-changed-success-description": "ایمیل شما به درستی به‌روزرسانی شد.",
   "email-update-error-description": "مشکلی در تغییر ایمیل شما رخ داد، لطفاً دوباره تلاش کنید.",
   "password-changed-success-title": "رمز عبور با موفقیت تغییر کرد!",
   "password-changed-success-description": "رمز عبور شما به درستی به‌روزرسانی شد.",
   "password-update-error-description": "مشکلی در تغییر رمز عبور شما رخ داد، لطفاً دوباره تلاش کنید.",
   "current-password-required-validation": "رمز عبور فعلی الزامی است",
   "new-password-required-validation": "رمز عبور جدید الزامی است",
   "confirm-new-password-required-validation": "تایید رمز عبور جدید الزامی است",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "مدیریت حساب",
   "deactivate-account-title": "غیرفعال کردن حساب",
   "deactivate-account-description":
      "شما می‌توانید حساب تان را اینجا غیرفعال کنید. این کار حساب تان را به صورت موقت غیرقابل استفاده می‌سازد. با آنهم، این عمل کاملاً قابل بازگشت است، و",
   "deactivate-account-explanation": "شما می‌توانید حساب تان را در هر زمان با ورود دوباره فعال سازید.",
   "delete-account-title": "حذف حساب",
   "delete-account-description": "حذف حساب تان تمام معلومات تان را به صورت دایمی از سیستم ما پاک می‌کند.",
   "delete-account-explanation":
      "این عمل غیرقابل بازگشت است، به این معنی که پس از حذف حساب تان، شما نمی‌توانید هیچ کدام از معلومات یا محتوای تان را بازیابی کنید.",
   "delete-account-explanation-2": "اگر مطمئن هستید که می‌خواهید ادامه دهید،",
   "delete-account-explanation-3":
      "لطفاً توجه داشته باشید که شما دسترسی به تمام خدمات و معلومات مرتبط با حساب تان را از دست خواهید داد.",
   "delete-account-modal-title": "حساب تان را حذف کنید",
   "deactivate-account-modal-title": "حساب تان را غیرفعال کنید",
   "delete-account-modal-description": "متأسفیم که شما را از دست می‌دهیم، اما به تصمیم تان احترام می‌گذاریم!",
   "deactivate-account-modal-description": "به فکر یک وقفه هستید؟ غیرفعال کردن حساب همیشه یک گزینه است.",
   "confirm-account-deletion-title": "تایید حذف حساب",
   "confirm-account-deactivation-title": "تایید غیرفعال سازی حساب",
   "confirm-delete-account-description": "شما در حال حذف دایمی حساب و معلومات تان هستید.",
   "confirm-deactivate-account-description": "شما در حال غیرفعال کردن حساب تان هستید.",
   "confirm-action-other-desc": "آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
   "delete-reason-1": "من دیگر به این خدمت نیاز ندارم.",
   "delete-reason-2": "من خدمت دیگری یافتم که با نیازهایم بهتر مطابقت دارد.",
   "delete-reason-3": "تجربه بدی داشتم.",
   "delete-reason-4": "من در مورد محرمیت معلوماتم نگران هستم.",
   "deactivate-reason-1": "من به یک وقفه کوتاه نیاز دارم.",
   "deactivate-reason-2": "من در حال حاضر خیلی مصروف هستم که از پلتفرم استفاده کنم.",
   "deactivate-reason-3": "من با مسایل شخصی سر و کار دارم.",
   "deactivate-reason-4": "می‌خواهم فعلاً روی اولویت‌های دیگر تمرکز کنم.",
   "other-please-specify-label": "دیگر (لطفاً مشخص کنید)",
   "enter-your-answer-placeholder": "پاسخ تان را اینجا وارد کنید",
   "delete-account-feedback-prompt": "ما دوست داریم نظر شما را بشنویم. آیا می‌توانید بگویید چرا به فکر حذف حساب تان هستید؟",
   "deactivate-account-feedback-prompt":
      "ما دوست داریم نظر شما را بشنویم. آیا می‌توانید بگویید چرا به فکر غیرفعال کردن حساب تان هستید؟",
   "delete-account-followup-question":
      "از اینکه با ما بودید متشکریم. آیا کاری بود که می‌توانستیم انجام دهیم تا تجربه تان بهتر شود؟",
   "deactivate-account-followup-question":
      "ما همیشه به دنبال بهبود هستیم. اگر پیشنهاد یا نظری دارید، از شنیدن آن خوشحال می‌شویم",
   "delete-account-error-description": "مشکلی در حذف حساب تان رخ داد، لطفاً دوباره تلاش کنید.",
   "deactivate-account-error-description": "مشکلی در غیرفعال کردن حساب تان رخ داد، لطفاً دوباره تلاش کنید.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "پلان مناسب برای خود را انتخاب کنید",
   "billed-annually-text": "محاسبه سالانه",
   "workspaces-suffix-label": "ساحات کاری",
   "members-suffix-label": "اعضا",
   "data-storage-limit-suffix-label": "حد ذخیره معلومات",
   "see-all-plan-details-link": "دیدن تمام جزئیات پلان",
   "plan-selected-label": "پلان انتخاب شد",
   "select-this-plan-button": "این پلان را انتخاب کنید",
   "view-billing-portal-button": "دیدن پورتال محاسبه",
   "checkout-button": "تسویه حساب",
   "active-subscription-error-description": "کاربر در حال حاضر یک اشتراک فعال دارد. لطفاً یک پلان دیگر انتخاب کنید.",
   "payment-billing-error-description": "مشکلی در محاسبه این پرداخت رخ داد، لطفاً دوباره تلاش کنید.",
   "purchase-successful-title": "خرید موفقانه انجام شد!",
   "payment-processed-success-text": "پرداخت شما با موفقیت پردازش شد.",
   "thank-you-for-purchase-text": "از خرید شما تشکر می‌کنیم!",
   "go-back-to-payment-info-text": "بازگشت به معلومات پرداخت",
   "purchase-failed-title": "خرید ناکام شد",
   "purchase-failed-description":
      "متأسفانه، تلاش اخیر شما برای خرید موفق نبود. ممکن است مشکلی در پردازش پرداخت یا در معلومات ارائه شده وجود داشته باشد. لطفاً معلومات پرداخت خود را بررسی کرده و دوباره تلاش کنید.",
   "apologize-inconvenience-text": "بابت این ناراحتی معذرت می‌خواهیم و از صبر شما قدردانی می‌کنیم.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "حد اقل 3 حرف",
   "max-50-symbols-validation": "حد اکثر 50 حرف",
   "invalid-organization-email-validation": "ایمیل موسسه نامعتبر است",
   "organization-address-required-validation": "آدرس موسسه الزامی است",
   "operating-countries-required-validation": "کشورهای فعالیت الزامی است",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "عملیات حساب",
   "account-deactivated-notice-text": "حساب تان به درخواست تان با موفقیت غیرفعال شد.",
   "account-deleted-notice-text": "حساب تان به درخواست تان با موفقیت حذف شد.",
   "positive-experience-farewell-text":
      "ما باور داریم که تجربه خوبی با ما داشته‌اید، و می‌خواهیم بدانید که هر زمان تصمیم به بازگشت بگیرید، همیشه از شما استقبال خواهد شد.",
   "kaporg-best-regards-text": "با احترام، تیم KAPorg.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "ویرایش تصویر پروفایل",
   "change-profile-picture-button": "تغییر تصویر پروفایل",
   "delete-profile-picture-button": "حذف تصویر پروفایل",
   "profile-picture-updated-success-title": "تصویر پروفایل با موفقیت به‌روزرسانی شد!",
   "profile-picture-updated-success-description": "تصویر پروفایل شما به درستی به‌روزرسانی شد.",
   "profile-picture-update-error-description": "مشکلی در به‌روزرسانی تصویر پروفایل تان رخ داد، لطفاً دوباره تلاش کنید.",
   "profile-picture-deleted-success-title": "تصویر پروفایل با موفقیت حذف شد!",
   "profile-picture-deleted-success-description": "تصویر پروفایل شما حذف شده است.",
   "profile-picture-delete-error-description": "مشکلی در حذف تصویر پروفایل تان رخ داد، لطفاً دوباره تلاش کنید.",

   "name-required-validation": "نام الزامی است",
   "gender-required-validation": "جنسیت الزامی است",
   "role-required-validation": "نقش الزامی است",
   "team-member-added-success-title": "عضو تیم با موفقیت اضافه شد!",
   "team-member-added-success-description": "این عضو با موفقیت به پایگاه داده تیم شما اضافه شد.",
   "team-member-add-error-description":
      "در افزودن این عضو به پایگاه داده تیم شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "add-new-member-title": "افزودن عضو جدید",
   "gender-label": "جنسیت",
   "select-gender-placeholder": "جنسیت را انتخاب کنید",
   "role-label": "نقش",
   "select-role-placeholder": "نقش را انتخاب کنید",
   "make-my-profile-public-button": "پروفایل من را عمومی کن",
   "make-my-profile-private-button": "پروفایل من را خصوصی کن",
   "make-profile-public-title": "پروفایل را عمومی کن",
   "make-profile-private-title": "پروفایل را خصوصی کن",
   "profile-visibility-notice-public":
      "با عمومی کردن سازمان‌های ملی خود، اهداکنندگان و کارشناسان می‌توانند اطلاعات و نتایج شما را ببینند. بنابراین، توصیه می‌کنیم قبل از عمومی کردن، از تکمیل بودن تمام اطلاعات خود اطمینان حاصل کنید.",
   "profile-visibility-notice-private":
      "با خصوصی کردن سازمان‌های ملی خود، اهداکنندگان و کارشناسان می‌توانند اطلاعات و نتایج شما را ببینند. بنابراین، توصیه می‌کنیم قبل از خصوصی کردن، از تکمیل بودن تمام اطلاعات خود اطمینان حاصل کنید.",
   "delete-member-title": "حذف عضو",
   "delete-member-description": "شما در حال حذف این عضو هستید. این عمل قابل بازگشت نیست.",
   "delete-all-representative-details-title": "حذف تمام جزئیات نماینده",
   "delete-representative-info-description-1": "شما در حال حذف تمام اطلاعات نماینده خود هستید.",
   "delete-representative-info-description-2": "در صورت تمایل می‌توانید بعداً دوباره آن را اضافه کنید.",
   "delete-representative-info-description-3":
      "به یاد داشته باشید که داشتن یک پروفایل کامل برای دیده‌شدن بهتر و فرصت‌های ارتباطی در جامعه بسیار مهم است.",
   "organizations-management-title": "مدیریت سازمان‌ها",

   "representative-updated-success-title": "جزئیات نماینده با موفقیت به‌روزرسانی شد!",
   "representative-updated-success-description": "اطلاعات جزئیات نماینده شما به درستی به‌روزرسانی شد.",
   "representative-update-error-description":
      "در به‌روزرسانی اطلاعات جزئیات نماینده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "edit-representative-detail-title": "ویرایش جزئیات نماینده",
   "full-name-label": "نام کامل",
   "phone-label": "تلفن",
   "edit-representative-button": "ویرایش نماینده",
   "representative-added-success-title": "جزئیات نماینده با موفقیت اضافه شد!",
   "representative-added-success-description": "اطلاعات جزئیات نماینده شما به درستی اضافه شد.",
   "representative-add-error-description":
      "در افزودن اطلاعات جزئیات نماینده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "create-representative-detail-title": "ایجاد جزئیات نماینده جدید",

   "team-member-removed-success-title": "عضو تیم با موفقیت حذف شد!",
   "team-member-removed-success-description": "این عضو با موفقیت از پایگاه داده تیم شما حذف شد.",
   "team-member-remove-error-description":
      "در حذف این عضو از پایگاه داده تیم شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "fullname-column": "نام کامل",
   "member-search-label": "به دنبال کدام عضو می‌گردید؟",
   "search-member-by-name-placeholder": "جستجوی عضو بر اساس نام",
   "add-member-button": "افزودن عضو",
   "new-member-button": "عضو جدید",
   "birthdate-label": "تاریخ تولد",
   "email-field-label": "ایمیل",
   "name": "نام",
   "email": "ایمیل",
   "cancel": "لغو",
   "no-assessments-listed-text": "هیچ ارزیابی فهرست نشده است",
   "remaining-months-days-text": "{months} ماه، {days} روز",
   "more-actions-label": "اقدامات بیشتر",
   "sort-ascending-alt": "مرتب‌سازی صعودی",
   "sort-descending-alt": "مرتب‌سازی نزولی",
   "error-unauthorized-text": "متأسفیم، شما اجازه دسترسی به این صفحه را ندارید.",
   "error-page-not-found-text": "متأسفیم، صفحه‌ای که بازدید کردید وجود ندارد.",
   "error-oops-title": "اوه...",
   "back-home-button": "بازگشت به صفحه اصلی",
   "error-something-wrong-text": "به نظر می‌رسد مشکلی پیش آمده است. در حال رفع آن هستیم",

   "requests-management-title": "مدیریت درخواست‌ها",
   "archived-assessments-link": "ارزیابی‌های بایگانی‌شده",
   "deleted-assessments-link": "ارزیابی‌های حذف‌شده",
   "add-new-assessment-button": "ارزیابی جدید",
   "assessment-list-title": "ارزیابی‌ها",
   "archive-button": "بایگانی",
   "archive-assessment-title": "بایگانی ارزیابی",
   "delete-assessment-title": "حذف ارزیابی",
   "archive-assessment-description": "شما در حال بایگانی کردن این ارزیابی هستید.",
   "delete-assessment-description": "شما در حال حذف این ارزیابی هستید.",

   "start-date-after-previous-end-validation": "تاریخ شروع باید بزرگتر از تاریخ پایان دور قبلی باشد",
   "end-date-after-start-validation": "تاریخ پایان باید بزرگتر از تاریخ شروع باشد",
   "assessment-name-empty-validation": "نام ارزیابی نمی‌تواند خالی باشد",
   "submission-round-label-empty-validation": "برچسب دور ارسال نمی‌تواند خالی باشد",
   "date-fields-required-validation": "فیلدهای تاریخ الزامی است",
   "start-date-required-validation": "تاریخ شروع الزامی است",
   "end-date-required-validation": "تاریخ پایان الزامی است",
   "assessment-created-success-title": "ارزیابی با موفقیت ایجاد شد!",
   "assessment-created-success-description": "یک ارزیابی جدید ایجاد و به پایگاه داده شما اضافه شد.",
   "assessment-create-error-description": "در ایجاد این ارزیابی مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "assessment-details-title": "جزئیات ارزیابی",
   "assessment-name-label": "نام ارزیابی",
   "enter-assessment-name-placeholder": "نام ارزیابی را وارد کنید",
   "assessment-type-label": "نوع ارزیابی",
   "submission-round-label-field": "برچسب دور ارسال",
   "enter-submission-round-placeholder": "دور ارسال را وارد کنید",
   "start-date-label": "تاریخ شروع",
   "end-date-label": "تاریخ پایان",
   "add-new-submission-round-button": "افزودن دور ارسال جدید",
   "dynamic-range-label": "دامنه پویا",
   "select-score-range-description": "دامنه متغیرهای نمره ارزیابی خود را انتخاب کنید (تا ۵)",
   "score-variables-label": "متغیرهای نمره",
   "from-label": "از",
   "to-label": "تا",
   "score-label-field": "برچسب نمره",
   "score-description-field": "توضیحات نمره",
   "enter-label-description-placeholder": "توضیحی برای برچسب وارد کنید",
   "add-assessment-button": "افزودن ارزیابی",
   "assessment-assigned-success-title": "ارزیابی با موفقیت تخصیص داده شد!",
   "assessment-assigned-success-description":
      "این ارزیابی با موفقیت به اعضای تیم شما تخصیص داده شد. آن‌ها از این اقدام مطلع خواهند شد.",
   "assessment-assign-error-description":
      "در تخصیص این ارزیابی به اعضای تیم شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "assign-assessment-to-team-title": "تخصیص ارزیابی به تیم",
   "project-management-label": "مدیریت پروژه",

   "assessment-updated-success-title": "ارزیابی با موفقیت به‌روزرسانی شد!",
   "assessment-updated-success-description": "این ارزیابی به درستی به‌روزرسانی شد.",
   "assessment-update-error-description":
      "در به‌روزرسانی این ارزیابی مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "edit-assessment-title": "ویرایش ارزیابی",
   "edit-assessment-of-team-title": "ویرایش ارزیابی این تیم",
   "select-project-management-placeholder": "مدیریت پروژه را انتخاب کنید",
   "module-assigned-success-title": "ماژول با موفقیت تخصیص داده شد!",
   "module-assigned-success-description":
      "این ماژول با موفقیت به اعضای کارکنان شما تخصیص داده شد. آن‌ها از این اقدام مطلع خواهند شد.",
   "module-unassigned-success-title": "لغو تخصیص ماژول با موفقیت انجام شد!",
   "module-unassigned-success-description": "تخصیص این ماژول توسط عضو کارکنان با موفقیت لغو شد.",
   "module-assign-error-description":
      "در تخصیص این ماژول به اعضای کارکنان شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "assign-module-to-members-title": "تخصیص ماژول به اعضا",
   "module-name-label": "نام ماژول",
   "members-to-assign-label": "اعضایی که این ماژول باید به آن‌ها تخصیص یابد",
   "unassign-button": "لغو تخصیص",
   "assign-module-button": "تخصیص ماژول",
   "member-required-validation": "عضو الزامی است",

   "comparison-created-success-title": "نسخه مقایسه جدید ایجاد شد!",
   "comparison-created-success-description": "نسخه مقایسه جدید با موفقیت ایجاد شد و آماده بررسی است.",
   "comparison-create-error-description":
      "در ایجاد این نسخه مقایسه مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "duplicate-for-comparison-title": "کپی برای مقایسه",
   "duplicate-comparison-description-1":
      "این یک نسخه از ارزیابی ایجاد کرده و هر دو نسخه را برای مقایسه نتایج پیوند می‌دهد.",
   "duplicate-comparison-description-2":
      "پس از کپی شدن، ارزیابی‌ها و هر ماژول مرتبط قابل ویرایش نیستند.",
   "current-assessment-label": "ارزیابی فعلی",
   "new-comparison-version-label": "نسخه مقایسه جدید",
   "comparison-suffix-label": "مقایسه",
   "duplicate-comparison-note":
      "توجه: در صورت نیاز، می‌توانید پیوند را بعداً حذف کنید تا آن‌ها را جداگانه ویرایش کنید، اما مقایسه دیگر در دسترس نخواهد بود.",
   "duplicate-button": "کپی",
   "assessments-unlinked-success-title": "ارزیابی‌ها لغو پیوند شدند!",
   "assessments-unlinked-success-description":
      "ارزیابی‌ها با موفقیت لغو پیوند شدند و اکنون می‌توانند به‌طور مستقل ویرایش شوند.",
   "assessments-unlink-error-description": "در لغو پیوند ارزیابی‌ها مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "unlink-assessments-title": "آیا پیوند این ارزیابی‌ها لغو شود؟",
   "unlink-assessments-description":
      "آن‌ها دیگر برای مقایسه متصل نخواهند بود و نمای مقایسه دیگر در دسترس نخواهد بود.",
   "original-assessment-label": "ارزیابی اصلی",
   "duplicated-assessment-label": "ارزیابی کپی‌شده",
   "unlink-assessments-note": "توجه: پس از لغو پیوند، هر ارزیابی می‌تواند به‌طور مستقل ویرایش شود.",
   "unlink-button": "لغو پیوند",
   "expert-name-column": "نام کارشناس",
   "years-of-experience-column": "سال‌های تجربه",
   "expert-cv-column": "رزومه کارشناس",
   "cv-link-text": "لینک رزومه",
   "no-cv-available-text": "رزومه‌ای موجود نیست",
   "areas-of-expertise-column": "حوزه‌های تخصص",
   "select-expert-request-access-title": "یک کارشناس را انتخاب کرده و درخواست دسترسی دهید",
   "first-choose-expert-subtitle": "ابتدا یک کارشناس انتخاب کنید",
   "choose-expert-guide-hint": "یک کارشناس را برای هدایت ارزیابی خود انتخاب کنید",
   "request-access-button": "درخواست دسترسی",
   "go-back-experts-list-link": "بازگشت به لیست کارشناسان",
   "no-description-available-text": "توضیحاتی موجود نیست",
   "no-expertise-listed-text": "تخصصی ذکر نشده است",
   "nationality-label": "ملیت",
   "no-nationality-listed-text": "ملیتی ذکر نشده است",
   "country-of-residence-label": "کشور اقامت",
   "no-country-of-residence-text": "کشور اقامتی وجود ندارد",
   "no-operating-countries-listed-text": "کشورهای فعالیتی ذکر نشده است",
   "linkedin-profile-label": "پروفایل لینکدین",
   "no-linkedin-profile-text": "پروفایل لینکدین ارائه نشده است",
   "no-phone-number-listed-text": "شماره تلفنی ذکر نشده است",
   "highest-degree-label": "بالاترین مدرک تحصیلی کسب‌شده",
   "no-highest-degree-listed-text": "بالاترین مدرک تحصیلی ذکر نشده است",
   "fields-of-study-label": "رشته‌های تحصیلی",
   "no-study-fields-listed-text": "رشته تحصیلی ذکر نشده است",
   "educational-institution-label": "مؤسسه آموزشی",
   "no-educational-institution-listed-text": "مؤسسه آموزشی ذکر نشده است",
   "languages-label": "زبان‌ها",
   "no-languages-listed-text": "زبانی ذکر نشده است",
   "cv-label": "رزومه",
   "no-cv-listed-text": "رزومه‌ای ذکر نشده است",
   "certification-training-label": "گواهینامه یا آموزش خاص",
   "no-certification-listed-text": "گواهینامه یا آموزش خاصی ذکر نشده است",

   "archived-assessments-list-title": "لیست ارزیابی‌های آرشیف شده",
   "deleted-assessments-title": "ارزیابی‌های حذف شده",
   "delete-permanently-button": "حذف دایمی",
   "unarchive-assessments-button": "لغو آرشیف ارزیابی‌ها",
   "restore-assessments-button": "بازیابی ارزیابی‌ها",
   "deleted-assessments-description":
      "در اینجا می‌توانید ارزیابی‌های حذف شده را مشاهده و بازیابی کنید. هر ارزیابی که ظرف ۶۰ روز بازیابی نشود به طور دایمی حذف خواهد شد.",
   "delete-assessment-permanently-title": "حذف دایمی ارزیابی",
   "delete-assessments-permanently-title": "حذف دایمی ارزیابی‌ها",
   "delete-selected-assessment-permanently-description":
      "شما در حال حذف دایمی ارزیابی انتخاب شده هستید.",
   "delete-selected-assessments-permanently-description":
      "شما در حال حذف دایمی ارزیابی‌های انتخاب شده هستید.",
   "action-cannot-be-undone-confirm-text":
      "این عملیه قابل بازگشت نیست. آیا مطمین هستید که می‌خواهید ادامه دهید؟",

   "request-sent-success-title": "درخواست موفقانه ارسال شد!",
   "request-sent-success-description":
      "درخواست شما به ادمین ارسال شد. به محض پاسخ به درخواست، ایمیلی حاوی پاسخ دریافت خواهید کرد.",
   "request-send-error-description": "در ارسال درخواست شما مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "request-rejected-title": "افسوس! به نظر می‌رسد درخواست شما رد شده است",
   "request-rejected-description-line1":
      "در حال حاضر شما نمی‌توانید به این ارزیابی دسترسی داشته باشید زیرا درخواست شما رد شده است.",
   "request-rejected-description-line2": "اما نگران نباشید! می‌توانید دوباره درخواست دسترسی بدهید.",
   "request-pending-title": "شما قبلاً برای این ارزیابی درخواست دسترسی داده‌اید!",
   "request-pending-description-line1":
      "درخواست شما به ادمین این ارزیابی ارسال شد. به محض پاسخ به درخواست، ایمیلی حاوی پاسخ دریافت خواهید کرد.",
   "request-pending-description-line2": "ما در اسرع وقت با شما تماس خواهیم گرفت.",
   "request-access-title": "درخواست دسترسی برای این ارزیابی",
   "request-access-description-part1": "این ارزیابی رهنمایی شده را فعال کنید تا",
   "request-access-description-part2": "ما بتوانیم کارشناسان خود را",
   "request-access-description-part3": "از ساحه کاری شما تعیین کنیم تا",
   "request-access-description-part4": "شما را مستقیماً در جریان پروسه ارزیابی حمایت کنند",
   "request-access-description-part5":
      "و به شما کمک کنیم راه‌هایی برای ایجاد شراکت‌های بهتر و تضمین بودجه برای برنامه‌های آینده کشف کنید.",

   "guided-assessments-title": "ارزیابی‌های رهنمایی شده",
   "assessments-list-title": "لیست ارزیابی‌ها",
   "organizations-name-column": "نام سازمان",
   "assessment-column": "ارزیابی",
   "status-column": "وضعیت",
   "not-started-status": "شروع نشده",
   "in-progress-status": "در حال جریان",
   "completed-status": "تکمیل شده",

   "success-title": "موفقیت",
   "module-submitted-success-description": "ماژول با موفقیت ارسال شد",
   "no-submission-rounds-text": "هیچ دور ارسالی وجود ندارد",
   "submission-rounds-title": "دورهای ارسال",
   "round-target-label": "هدف",
   "module-submitted-modal-title": "شما این ماژول را با موفقیت ارسال کردید!",
   "next-round-active-description":
      "لطفاً وقتی دور ارسال بعدی فعال شد، دوباره به این ارزیابی مراجعه کنید.",
   "remaining-time-current-round-label": "زمان باقی‌مانده دور فعلی",
   "start-label": "شروع",
   "end-label": "پایان",
   "linked-modules-title": "ماژول‌های مرتبط",
   "no-linked-modules-text": "هیچ ماژول مرتبطی وجود ندارد",
   "finished-status": "تکمیل شده",
   "completed-text": "تکمیل شده",

   "assigned-to-label": "تعیین شده به",
   "assign-member-button": "تعیین عضو",
   "submitted-at-label": "ارسال شده در",
   "edit-assignment-button": "ویرایش تعیینات",
   "assign-to-team-button": "تعیین به تیم",
   "assessment-assigned-to-label": "ارزیابی تعیین شده به:",
   "expert-modules-description":
      "این‌ها ماژول‌هایی اند که کارشناس انتخاب شده به آن‌ها پاسخ خواهد داد. به محض اینکه کارشناس ماژول‌ها را ارسال کند، شما می‌توانید نتایج و پاسخ‌ها را در بخش نتایج مشاهده کنید.",

   "no-self-assessments-yet-title": "به نظر می‌رسد این ساحه کاری هنوز ارزیابی خودی ندارد!",
   "no-guided-assessments-yet-title": "به نظر می‌رسد این ساحه کاری هنوز ارزیابی رهنمایی شده ندارد!",
   "work-on-guided-assessments-instead-description":
      "اما نگران نباشید، می‌توانید به جای آن روی ارزیابی‌های رهنمایی شده کار کنید.",
   "work-on-self-assessments-instead-description":
      "اما نگران نباشید، می‌توانید به جای آن روی ارزیابی‌های خودی کار کنید.",

   "name-column": "نام",
   "type-column": "نوعیت",
   "created-by-column": "ایجاد شده توسط",
   "created-date-column": "تاریخ ایجاد",
   "edit-action": "ویرایش",
   "founded-label": "تأسیس",
   "areas-label": "ساحات",
   "staff-label": "کارمندان",
   "contact-label": "تماس",
   "online-label": "آنلاین",
   "unlink-assessment-action": "قطع ارتباط ارزیابی",
   "edit-assessment-alt": "ویرایش ارزیابی",
   "archive-assessment-alt": "آرشیف ارزیابی",
   "delete-assessment-alt": "حذف ارزیابی",
   "unlink-assessment-alt": "قطع ارتباط ارزیابی",

   "assessment-deleted-success-title": "ارزیابی با موفقیت حذف شد!",
   "assessment-deleted-success-description": "این ارزیابی با موفقیت از پایگاه داده شما حذف شد.",
   "assessment-delete-error-description":
      "در حذف این ارزیابی مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "assessments-deleted-success-title": "ارزیابی‌ها با موفقیت حذف شدند!",
   "assessments-deleted-success-description":
      "این ارزیابی‌ها با موفقیت از پایگاه داده شما حذف شدند.",
   "assessments-delete-error-description":
      "در حذف این ارزیابی‌ها مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "assessment-restored-success-title": "ارزیابی با موفقیت بازیابی شد!",
   "assessment-restored-success-description": "این ارزیابی با موفقیت بازیابی شد.",
   "assessment-unarchive-error-description":
      "در لغو آرشیف این ارزیابی مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "assessments-unarchived-success-title": "آرشیف ارزیابی‌ها با موفقیت لغو شد!",
   "assessments-unarchived-success-description": "آرشیف این ارزیابی‌ها با موفقیت لغو شد.",
   "assessments-unarchive-error-description":
      "در لغو آرشیف این ارزیابی‌ها مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "assessment-archived-success-title": "ارزیابی با موفقیت آرشیف شد!",
   "assessment-archived-success-description": "این ارزیابی با موفقیت آرشیف شد.",
   "assessment-archive-error-description":
      "در افزودن این ارزیابی به آرشیف مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "assessment-trashed-success-title": "ارزیابی با موفقیت به سطل زباله افزوده شد!",
   "assessment-trashed-success-description": "این ارزیابی با موفقیت به سطل زباله افزوده شد.",
   "assessment-trash-error-description":
      "در افزودن این ارزیابی به سطل زباله مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",

   "assessment-modules-title": "ماژول‌های ارزیابی",
   "module-name-column": "نام ماژول",
   "go-to-module-button": "رفتن به ماژول",

   "consultant-organization-list-title": "لیست سازمان‌های مشاور",
   "country-column": "کشور",
   "progress-column": "پیشرفت",
   "submitted-status": "ارسال شده",
   "go-to-assessment-button": "رفتن به ارزیابی",

   "module-submitted-toast": "ماژول با موفقیت ارسال شد.",
   "no-permission-submit-module-warning": "شما اجازه ارسال یک ماژول را ندارید!",
   "submit-button": "ارسال",
   "module-submitted-text": "این ماژول ارسال شده است.",

   "choose-consultant-guide-title": "یک مشاور برای رهنمایی ارزیابی خود انتخاب کنید",
   "consultant-profile-title": "پروفایل مشاور",
   "consultant-label": "مشاور",
   "experience-title": "تجربه",
   "education-title": "تحصیلات",
   "school-label": "مکتب",
   "skills-title": "مهارت‌ها",
   "select-this-consultant-button": "این مشاور را انتخاب کنید",
   "enrolled-guided-assessment-success-title": "شما با موفقیت در ارزیابی رهنمایی شده ثبت‌نام شدید!",
   "consultant-contact-soon-description-part1": "مشاور",
   "consultant-contact-soon-description-part2":
      "به زودی با شما تماس خواهد گرفت تا ارزیابی‌های شما را آغاز کند.",
   "go-to-assessments-button": "رفتن به ارزیابی‌ها",

   "improve-score-help-title":
      "اگر می‌خواهید امتیاز خود را بهبود بخشید و سازمان خود را بیشتر رشد دهید، تیم KAPorg اینجاست تا به شما کمک کند!",
   "request-guided-assessment-description-part1":
      "اکنون یک ارزیابی رهنمایی شده درخواست کنید تا بتوانیم کارشناسان خود را از ساحه کاری شما تعیین کنیم تا مستقیماً شما را در جریان پروسه ارزیابی حمایت کنند و به شما کمک کنیم راه‌هایی برای ایجاد شراکت‌های بهتر و تضمین بودجه برای برنامه‌های آینده کشف کنید.",
   "request-guided-assessment-description-part2":
      "اکنون درخواست دهید و ما در اسرع وقت با شما تماس خواهیم گرفت.",
   "request-assessment-code-button": "درخواست کد ارزیابی",
   "have-assessment-code-button": "من یک کد ارزیابی دارم",
   "assessment-code-title": "کد ارزیابی",
   "enter-assessment-code-description":
      "برای دسترسی به ارزیابی خود، لطفاً کد ارزیابی خود را در زیر تایپ کنید",
   "enter-code-here-label": "کد خود را اینجا وارد کنید",
   "please-enter-code-error": "لطفاً کد را وارد کنید",
   "assessment-list-label": "لیست ارزیابی‌ها",
   "select-an-assessment-placeholder": "-یک ارزیابی انتخاب کنید-",
   "select-assessment-error": "شما باید یک ارزیابی انتخاب کنید",
   "submit-request-button": "ارسال درخواست",
   "request-assessment-code-title": "درخواست کد ارزیابی",
   "request-assessment-code-description":
      "لطفاً ارزیابی خود را درخواست کنید و ما با شما تماس خواهیم گرفت. به محض پذیرفته شدن درخواست، ایمیلی حاوی کد دریافت خواهید کرد.",
   "select-assessment-from-list-description": "یک ارزیابی از لیست زیر انتخاب کنید",
   "code-valid-select-consultant-toast": "کد شما معتبر بود و اکنون می‌توانید مشاور را انتخاب کنید",

   "my-modules-tab": "ماژول‌های من",
   "template-library-tab": "کتابخانه قالب‌ها",

   "module-deleted-success-title": "ماژول با موفقیت حذف شد!",
   "module-deleted-success-description": "این ماژول با موفقیت از پایگاه داده شما حذف شد.",
   "module-delete-error-description":
      "در حذف این ماژول مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "module-cannot-be-deleted-error": "این ماژول قابل حذف نیست",
   "preview-action": "نمایش",
   "download-action": "دانلود",
   "turn-into-template-action": "تبدیل به الگو",
   "preview-template-alt": "نمایش الگو",
   "edit-module-alt": "ویرایش ماژول",
   "download-module-alt": "دانلود ماژول",
   "turn-into-template-alt": "تبدیل به الگو",
   "delete-module-alt": "حذف ماژول",
   "title-column": "عنوان",
   "deleted-modules-button": "ماژول‌های حذف شده",
   "add-module-button": "ماژول جدید",
   "add-module-modal-button": "افزودن ماژول",
   "add-new-module-title": "افزودن ماژول جدید",
   "add-new-assessment-title": "افزودن ارزیابی جدید",
   "survey-status-editing": "در حال ویرایش",
   "survey-status-archived": "آرشیف شده",
   "survey-status-deployed": "منتشر شده",
   "survey-status-locked": "قفل شده",

   "how-start-title": "چگونه می‌خواهید شروع کنید؟",
   "create-form-title": "ایجاد فورم",
   "create-form-description":
      "با یک ساختار خالی شروع کنید و در حین کار بخش‌ها و سوالات را اضافه کنید.",
   "import-form-title": "وارد کردن فورم",
   "import-form-description": "یک فایل حاوی بخش‌ها و سوالات از پیش تعریف شده را بارگذاری کنید.",
   "use-template-title": "استفاده از یک الگو",
   "use-template-description":
      "با یک فورم که قبلاً در سیستم ذخیره شده شروع کنید و آن را به آسانی مطابق نیازهای خود تنظیم کنید.",
   "continue-button": "ادامه",

   "module-details-title": "جزئیات ماژول",
   "enter-module-name-placeholder": "نام ماژول را وارد کنید",
   "enter-module-description-placeholder": "توضیحات ماژول را وارد کنید",
   "default-language-label": "زبان پیش‌فرض",
   "select-default-language-module-placeholder": "زبان پیش‌فرض ماژول را انتخاب کنید",
   "select-assessment-label": "ارزیابی را انتخاب کنید",
   "select-assessment-module-placeholder": "ارزیابی ماژول را انتخاب کنید",

   "delete-module-title": "حذف ماژول",
   "delete-template-title": "حذف الگو",
   "delete-module-confirm-description": "شما در حال حذف این ماژول هستید. این عملیه قابل بازگشت نیست.",
   "delete-template-confirm-description": "شما در حال حذف این الگو هستید. این عملیه قابل بازگشت نیست.",

   "module-restored-success-title": "ماژول با موفقیت بازیابی شد!",
   "module-restored-success-description": "این ماژول با موفقیت بازیابی شد.",
   "module-restore-error-description":
      "در بازیابی این ماژول مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "deleted-modules-list-title": "لیست ماژول‌های حذف شده",
   "restore-modules-button": "بازیابی ماژول‌ها",
   "deleted-modules-description":
      "در اینجا می‌توانید ماژول‌های حذف شده را مشاهده و بازیابی کنید. هر ماژولی که ظرف ۶۰ روز بازیابی نشود به طور دایمی حذف خواهد شد.",

   "module-name-required-validation": "نام ماژول الزامی است",
   "upload-module-file-label": "بارگذاری فایل ماژول",
   "drag-drop-file-text": "فایل را اینجا بکشید و رها کنید، یا",
   "click-to-select-file-text": "برای انتخاب فایل کلیک کنید",
   "max-file-size-text": "حداکثر اندازه فایل: 20 مگابایت",

   "module-create-error-description": "در ایجاد این ماژول مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "make-module-template-label": "این ماژول را به یک الگو تبدیل کنید",

   "not-a-xlsx-file-error": "فایل xlsx نیست",
   "upload-valid-xlsx-error": "لطفاً یک فایل xlsx معتبر را قبل از ارسال بارگذاری کنید.",
   "error-title": "خطا",
   "survey-imported-success-description": "ماژول با موفقیت وارد شد",
   "survey-import-failed-error": "وارد کردن ماژول ناکام شد.",
   "copy-file-name-tooltip": "کاپی نام فایل",
   "copied-tooltip": "کاپی شد!",
   "module-must-have-right-format-text": "ماژول شما باید فرمت درست را داشته باشد تا به درستی وارد شود.",
   "download-format-link": "دانلود فرمت",
   "enter-description-placeholder": "توضیحات را وارد کنید",

   "min-3-characters-validation": "حداقل 3 حرف",
   "language-required-validation": "زبان الزامی است",
   "assessment-required-validation": "ارزیابی الزامی است",
   "new-module-suffix": "ماژول جدید",

   "edit-module-title": "ویرایش ماژول",
   "module-description-label": "توضیحات ماژول",

   "template-deleted-success-title": "الگو با موفقیت حذف شد!",
   "template-deleted-success-description": "این الگو با موفقیت از پایگاه داده شما حذف شد.",
   "template-delete-error-description": "در حذف این الگو مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "edit-template-alt": "ویرایش الگو",
   "download-template-alt": "دانلود الگو",
   "duplicate-template-alt": "تکثیر الگو",
   "delete-template-alt": "حذف الگو",
   "copy-action": "کاپی",
   "module-title-column": "عنوان ماژول",
   "created-on-column": "تاریخ ایجاد",
   "last-updated-column": "آخرین به‌روزرسانی",

   "copy-suffix-label": "کاپی",
   "template-duplicated-success-title": "الگو با موفقیت تکثیر شد!",
   "template-duplicated-success-description":
      "الگوی شما با موفقیت تکثیر شد. اکنون می‌توانید نسخه جدید را ویرایش و سفارشی کنید.",
   "template-duplicate-error-description": "در تکثیر این الگو مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "copy-template-title": "کاپی الگو",
   "copy-template-description":
      "شما در حال ایجاد یک الگوی قابل استفاده مجدد بر اساس ساختار این ماژول هستید. می‌توانید از این الگو برای ایجاد سریع ماژول‌های جدید استفاده کنید.",
   "template-name-label": "نام الگو",
   "template-name-required-validation": "نام الگو الزامی است",
   "enter-template-name-placeholder": "نام الگو را وارد کنید",
   "description-optional-label": "(اختیاری)",
   "template-description-hint-placeholder": "یک یادداشت کوتاه تا تیم شما بداند چه زمانی از این الگو استفاده کند",

   "no-templates-found-title": "هیچ الگویی یافت نشد",
   "no-templates-found-description":
      "در حال حاضر هیچ الگویی موجود نیست. بعداً دوباره تلاش کنید یا یکی جدید ایجاد کنید!",
   "sections-label": "بخش‌ها:",
   "use-template-button": "استفاده از الگو",

   "template-created-success-title": "الگو با موفقیت ایجاد شد!",
   "template-created-success-description":
      "الگوی جدید شما از ساختار این ماژول ایجاد شده است. اکنون می‌توانید آن را ویرایش کنید یا از آن برای ایجاد سریع ماژول‌های جدید استفاده کنید.",
   "template-create-error-description": "در ایجاد این الگو مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "convert-module-to-template-title": "تبدیل ماژول به الگو",
   "module-label": "ماژول",
   "structure-logic-copied-note": "یادداشت: فقط ساختار و منطق کاپی خواهد شد، پاسخ‌ها شامل نخواهند شد.",
   "create-template-button": "ایجاد الگو",

   "fetch-drafts-error": "دریافت پیش‌نویس‌ها ناکام شد",
   "module-saved-draft-success": "ماژول با موفقیت به عنوان پیش‌نویس ذخیره شد",
   "save-draft-error": "ذخیره پیش‌نویس ناکام شد",
   "reject-module-error": "رد کردن ماژول ناکام شد",
   "submit-module-error": "ارسال ماژول ناکام شد",
   "preview-other-modules-text": "نمایش سایر ماژول‌ها در این ارزیابی",
   "my-saved-drafts-button": "پیش‌نویس‌های ذخیره شده من",
   "save-as-draft-button": "ذخیره به عنوان پیش‌نویس",
   "processing-text": "در حال پردازش...",
   "submit-module-button": "ارسال ماژول",
   "reject-module-button": "رد ماژول",
   "approve-module-button": "تایید ماژول",

   "change-status-button": "تغییر وضعیت",
   "change-module-status-editing-title": "تغییر وضعیت ماژول به در حال ویرایش",
   "change-module-status-editing-confirm-description":
      "شما در حال تغییر وضعیت ماژول به در حال ویرایش هستید.",

   "language-label": "زبان",
   "select-language-placeholder": "زبان را انتخاب کنید",
   "print-module-button": "چاپ ماژول",

   "save-as-draft-title": "ذخیره به عنوان پیش‌نویس",
   "save-draft-description":
      "برای ذخیره پیش‌نویس این ماژول، یک نام به آن اختصاص دهید تا بعداً بتوانید آن را بررسی کنید. پیش‌نویس‌هایی که ذخیره می‌کنید در پایگاه داده ما نگهداری می‌شوند.",
   "save-draft-button": "ذخیره پیش‌نویس",

   "start-new-draft-button": "شروع یک پیش‌نویس جدید",
   "my-saved-draft-title": "پیش‌نویس ذخیره شده من",
   "unsubmitted-drafts-description": "شما پیش‌نویس‌های ارسال نشده برای این ماژول دارید.",
   "continue-draft-or-new-question": "می‌خواهید با یک پیش‌نویس ادامه دهید یا یکی جدید شروع کنید؟",
   "my-draft-label": "پیش‌نویس من",
   "no-drafts-found-text": "هیچ پیش‌نویسی یافت نشد. یک پیش‌نویس جدید شروع کنید.",

   "submit-module-confirm-description-part1":
      "شما در حال ارسال این ماژول هستید. به محض ادامه، پاسخ‌های شما برای بررسی و تایید به مدیر پروژه ارسال خواهد شد.",
   "submit-module-confirm-description-part2":
      "لطفاً اطمینان حاصل کنید که تمام پاسخ‌های شما دقیق هستند، زیرا پس از ارسال قادر به ایجاد هیچ تغییری نخواهید بود.",

   "approve-request-confirm-description":
      "شما در حال تایید این درخواست هستید. این عملیه قابل بازگشت نیست.",
   "feedback-required-validation": "بازخورد الزامی است",
   "reject-module-description-part1":
      "لطفاً بازخورد مفصلی درباره اینکه چرا این ماژول رد می‌شود ارائه دهید.",
   "reject-module-description-part2":
      "این به عنوان راهنمایی برای عضو مسئول تیم برای انجام اصلاحات لازم عمل خواهد کرد.",
   "why-rejecting-module-label": "چرا این ماژول را رد می‌کنید؟",
   "enter-rejection-reason-placeholder": "لطفاً دلیل رد را وارد کنید",

   "module-status-label": "وضعیت ماژول:",
   "survey-status-published": "منتشر شده",
   "edit-module-details-tooltip": "ویرایش جزئیات ماژول",
   "page-preparing-text": "صفحه در حال آماده‌سازی است...",

   "add-section-to-module-tooltip": "افزودن بخش به ماژول",
   "add-inner-section-tooltip": "افزودن بخش داخلی",

   "question-type-section": "بخش",
   "question-type-select-one": "یکی را انتخاب کنید",
   "question-type-text": "متن",
   "question-type-file-upload": "بارگذاری فایل",
   "question-type-date": "تاریخ",
   "question-type-phone-number": "شماره تلفن",
   "question-type-rating": "امتیازدهی",
   "question-type-ranking": "رتبه‌بندی",
   "question-type-select-multiple": "چندتا را انتخاب کنید",
   "question-type-note": "یادداشت",
   "question-type-date-time": "تاریخ و زمان",
   "question-type-time": "زمان",
   "question-type-number": "عدد",
   "question-type-acknowledge": "تایید",
   "question-type-matrix": "ماتریکس",
   "type-section-label-placeholder": "لطفاً برچسب بخش را بنویسید",
   "type-question-label-placeholder": "لطفاً برچسب سوال را بنویسید",

   "option-placeholder": "گزینه",
   "enter-note-text-above": "لطفاً متن یادداشت را در بالا وارد کنید.",
   "calculate-question-coming-soon": "سوال محاسبه - به زودی...",
   "file-upload-caps-label": "بارگذاری فایل",
   "items-to-be-ranked-label": "موارد برای رتبه‌بندی",
   "text-question-type-label": "نوعیت سوال: متن",
   "question-displayed-as-table-text": "این سوال به صورت جدول نمایش داده خواهد شد",
   "row-questions-title": "سوالات ردیف",
   "columns-questions-title": "سوالات ستون",
   "allow-numbers-range-only-text": "فقط اجازه اعداد از یک محدوده",
   "gps-question-coming-soon": "سوال GPS - به زودی...",
   "type-label-optional-placeholder": "یک برچسب بنویسید (اختیاری)",
   "optional-placeholder": "اختیاری",
   "reverse-answers-order-button": "معکوس کردن ترتیب پاسخ‌ها",
   "type-answer-choice-placeholder": "یک گزینه پاسخ بنویسید",
   "label-text": "برچسب",
   "select-an-option-placeholder": "یک گزینه انتخاب کنید",
   "select-a-scale-placeholder": "یک مقیاس انتخاب کنید",
   "enter-bulk-action-placeholder": "یک عملیات دسته‌جمعی وارد کنید",
   "to-divider-label": "تا",
   "collect-date-info-text": "جمع‌آوری معلومات تاریخ",
   "collect-time-info-text": "جمع‌آوری معلومات زمان",
   "collect-phone-number-info-text": "جمع‌آوری معلومات شماره تلفن",
   "type-a-question-placeholder": "یک سوال بنویسید",
   "min-label": "حداقل:",
   "max-label": "حداکثر:",
   "max-options-chosen-text": "حداکثر تعداد گزینه‌هایی که می‌توان انتخاب کرد",
   "all-options-label": "همه",
   "answer-genius-label": "نابغه پاسخ",
   "add-choices-button": "افزودن گزینه‌ها",
   "bulk-actions-label": "عملیات دسته‌جمعی",
   "enter-each-answer-choice-line-text": "هر گزینه پاسخ را در یک خط جداگانه وارد کنید.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "پاسخ الزامی",
   "delete-question-confirm-title": "آیا مطمئن هستید که می‌خواهید این سؤال را حذف کنید؟",
   "delete-section-confirm-title": "آیا مطمئن هستید که می‌خواهید این بخش را حذف کنید؟",
   "this-action-cannot-be-undone-text": "این عملیات قابل بازگشت نیست",
   "yes-confirm-button": "بله",
   "no-confirm-button": "خیر",
   "add-new-question-button": "افزودن سؤال جدید",
   "add-new-inner-section-button": "افزودن بخش داخلی جدید",
   "add-new-section-button": "افزودن بخش جدید",

   // Skip logic (admin/survey v2)
   "show-logic-button": "نمایش منطق",
   "display-condition-prefix-text": "نمایش",
   "question-word-label": "سؤال",
   "when-following-conditions-apply-text": "زمانی که شرایط زیر برآورده شوند:",
   "add-another-condition-button": "افزودن شرط دیگر",
   "should-match-all-the-criteria-placeholder-text": "باید با همه معیارها مطابقت داشته باشد",
   "should-match-all-of-these-criteria-text": "باید با همه این معیارها مطابقت داشته باشد",
   "should-match-any-of-these-criteria-text": "باید با هر یک از این معیارها مطابقت داشته باشد",
   "operator-was-not-answered-label": "پاسخ داده نشده",
   "operator-was-answered-label": "پاسخ داده شده",
   "operator-equals-label": "برابر است با (=)",
   "operator-not-equals-label": "برابر نیست با (!=)",
   "operator-greater-than-label": "بزرگتر از (>)",
   "operator-less-than-label": "کوچکتر از (<)",
   "operator-greater-than-or-equal-label": "بزرگتر یا مساوی با (>=)",
   "operator-less-than-or-equal-label": "کوچکتر یا مساوی با (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "این فیلد الزامی است",
   "type-your-answer-here-placeholder": "پاسخ خود را اینجا بنویسید",
   "you-must-select-text": "باید انتخاب کنید",
   "you-must-enter-date-and-time-text": "باید تاریخ و زمان را وارد کنید",
   "you-must-enter-a-number-text": "باید یک عدد وارد کنید",
   "drag-drop-files-text": "فایل‌ها را اینجا بکشید و رها کنید، یا برای انتخاب فایل کلیک کنید",
   "uploaded-file-label": "فایل بارگذاری شده:",
   "you-must-upload-file-text": "باید یک فایل بارگذاری کنید",
   "all-rankings-must-be-selected-text": "باید همه رتبه‌بندی‌ها انتخاب شوند",
   "please-specify-placeholder": "لطفاً مشخص کنید",
   "you-can-select-up-to-text": "می‌توانید تا",
   "choices-suffix-text": "گزینه انتخاب کنید.",
   "you-must-select-at-least-one-text": "باید حداقل یک مورد را انتخاب کنید",
   "you-must-select-one-text": "باید یک مورد را انتخاب کنید",
   "you-must-select-a-time-text": "باید یک زمان را انتخاب کنید",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "هنوز هیچ ارسالی برای این ماژول انجام نشده است.",
   "approval-successful-title": "موفقیت‌آمیز",
   "submission-approved-successfully-text": "ارسال با موفقیت تأیید شد",
   "fetch-submission-answers-error": "دریافت پاسخ‌های ارسال ناموفق بود",
   "approve-without-review-button": "تأیید بدون بازبینی",
   "send-for-approval-button": "ارسال برای تأیید",
   "approve-module-pending-approver-description":
      "شما در حال تأیید این ماژول هستید. پس از ادامه، این ماژول برای بازبینی نهایی به تأییدکننده ارسال خواهد شد پیش از اینکه وضعیت آن به این صورت علامت‌گذاری شود:",
   "approve-module-final-description-part1":
      "شما در حال ارائه تأیید نهایی برای این ماژول هستید. پس از ادامه، وضعیت آن به این صورت علامت‌گذاری خواهد شد:",
   "approve-module-final-description-part2":
      "و نتایج آن برای تحلیل در دسترس خواهد بود. این عملیات قابل بازگشت نیست. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
   "send-to-approver-for-review-label": "ارسال به تأییدکننده برای بازبینی نهایی",
   "approver-review-recommended-hint": "توصیه‌شده - رد کردن این گزینه، ماژول را فوراً نهایی می‌کند.",
   "skipping-approver-review-warning-text":
      "شما بازبینی تأییدکننده را نادیده می‌گیرید. این ماژول بدون بررسی دوم به پایان خواهد رسید.",
   "enter-detailed-feedback-placeholder": "لطفاً بازخورد دقیق خود را اینجا وارد کنید",

   // Approver management (admin/approver)
   "department-team-label": "بخش/تیم",
   "enter-approver-name-placeholder": "نام تأییدکننده را وارد کنید",
   "enter-approver-email-placeholder": "ایمیل تأییدکننده را وارد کنید",
   "enter-approver-department-placeholder": "بخش تأییدکننده را وارد کنید",
   "approver-added-success-title": "تأییدکننده با موفقیت افزوده شد!",
   "approver-added-success-description": "این تأییدکننده اکنون می‌تواند به ارزیابی‌ها اختصاص یابد.",
   "approver-updated-success-title": "تأییدکننده با موفقیت به‌روزرسانی شد!",
   "approver-updated-success-description": "جزئیات این تأییدکننده به‌روزرسانی شده است.",
   "approver-add-error-description": "در افزودن این تأییدکننده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "approver-update-error-description": "در به‌روزرسانی این تأییدکننده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "approver-delete-error-description": "در حذف این تأییدکننده مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "approver-deleted-success-title": "تأییدکننده با موفقیت حذف شد!",
   "approver-deleted-success-description": "این تأییدکننده حذف شده است.",
   "delete-approver-title": "حذف تأییدکننده",
   "delete-approver-confirm-text": "شما در حال حذف این تأییدکننده هستید.",
   "add-approver-title": "افزودن تأییدکننده",
   "edit-approver-title": "ویرایش تأییدکننده",
   "add-approver-button": "افزودن تأییدکننده",
   "approvers-title": "تأییدکنندگان",
   "search-approver-by-name-placeholder": "جستجوی تأییدکننده با نام آن",
   "filter-approvers-by-department-placeholder": "فیلتر تأییدکنندگان بر اساس بخش",

   // Approver submissions (approver-facing pages)
   "no-data-text": "داده‌ای وجود ندارد",
   "submitted-by-column": "ارسال‌شده توسط",
   "pending-modules-title": "ماژول‌های در انتظار",
   "approved-modules-title": "ماژول‌های تأییدشده",
   "rejected-modules-title": "ماژول‌های ردشده",
   "filter-tasks-by-submission-date-placeholder": "فیلتر وظایف بر اساس تاریخ ارسال",
   "module-approvals-title": "تأییدهای ماژول",
   "pending-modules-review-description":
      "این فهرست ماژول‌هایی است که در انتظار بازبینی شما هستند. برای ادامه، لطفاً روی هر ماژول کلیک کنید تا بتوانید آن را بپذیرید یا رد کنید.",
   "the-approver-label": "تأییدکننده",
   "approver-label": "تأییدکننده",
   "select-an-approver-placeholder": "یک تأییدکننده انتخاب کنید",
   "go-to-revise-module-button": "برو به بازبینی ماژول",
   "rejected-module-information-title": "اطلاعات ماژول ردشده",
   "feedback-from-label-prefix": "بازخورد از",
   "the-project-manager-label": "مدیر پروژه",
   "awaiting-approver-status": "در انتظار تأییدکننده",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "عنوان ماژول",
   "enter-module-title-placeholder": "عنوان ماژول را وارد کنید",
   "module-description-label": "توضیحات ماژول",
   "assigned-assessment-label": "ارزیابی اختصاص‌یافته",
   "survey-updated-success-title": "نظرسنجی با موفقیت به‌روزرسانی شد!",
   "module-updated-success-description": "این ماژول به‌درستی به‌روزرسانی شد.",
   "edit-module-error-description": "در ویرایش این ماژول مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "form-builder-tab-label": "سازنده فرم",
   "logic-builder-tab-label": "سازنده منطق",
   "translate-questions-tab-label": "ترجمه سؤالات",
   "score-questions-tab-label": "امتیازدهی سؤالات",
   "stay-here-button": "همینجا بمانید",
   "change-tab-button": "تغییر برگه",
   "unsaved-progress-title": "پیشرفت ذخیره‌نشده",
   "unsaved-changes-tab-text": "شما تغییرات ذخیره‌نشده‌ای در این برگه دارید.",
   "confirm-proceed-without-saving-part1": "آیا مطمئن هستید که می‌خواهید ادامه دهید",
   "confirm-proceed-without-saving-part2": "بدون ذخیره پیشرفت؟",
   "module-status-changed-success-title": "وضعیت ماژول با موفقیت تغییر یافت!",
   "module-status-changed-success-description": "وضعیت این ماژول به‌درستی تغییر یافت.",
   "problem-occurred-title": "مشکلی رخ داد!",
   "change-status-error-description":
      "در تغییر وضعیت این ماژول مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "publish-module-button": "انتشار ماژول",
   "change-status-to-editing-button": "تغییر وضعیت به ویرایش",
   "changes-saved-success-description": "تغییرات با موفقیت ذخیره شد",
   "save-progress-button": "ذخیره پیشرفت",
   "skip-logic-saved-success-description": "منطق پرش با موفقیت افزوده شد",
   "score-points-saved-success-description": "امتیازهای نمره با موفقیت افزوده شد",
   "total-module-score-label": "امتیاز کل ماژول:",
   "points-suffix": "امتیاز",
   "answers-column-label": "پاسخ‌ها",
   "score-column-label": "امتیاز",
   "input-score-placeholder": "امتیاز را وارد کنید",
   "max-score-label": "حداکثر امتیاز:",
   "date-answer-label": "پاسخ تاریخ",
   "time-answer-label": "پاسخ زمان",
   "answer-keywords-label": "کلیدواژه‌های پاسخ",
   "section-score-label": "امتیاز بخش:",
   "number-range-hint-prefix": "محدوده این سؤال است",
   "number-range-hint-value": "۱ تا ۵۰",
   "number-range-hint-suffix": ". لطفاً گزینه‌های پاسخ صحیح را برای امتیازدهی انتخاب کنید:",
   "select-right-answer-choices-placeholder": "گزینه‌های پاسخ صحیح را انتخاب کنید",
   "single-number-option-label": "یک عدد",
   "range-option-label": "محدوده",
   "enter-range-correct-answers-label": "محدوده پاسخ‌های صحیح را وارد کنید",
   "to-connector-label": "تا",
   "enter-correct-number-label": "عدد صحیح را وارد کنید",
   "input-number-placeholder": "عدد را وارد کنید",
   "ranking-score-instructions-text":
      "لطفاً گزینه‌ها را به ترتیب صحیح مرتب کنید، سپس به هر یک امتیاز دهید",
   "input-phone-number-placeholder": "شماره تلفن را وارد کنید",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "ماژول اصلی",
   "main-module-description-text": "این‌ها سؤالات ماژول اصلی شما هستند",
   "default-language-placeholder": "زبان پیش‌فرض",
   "translate-module-title": "ترجمه ماژول",
   "write-translation-here-text": "ترجمه هر سؤال را اینجا بنویسید",
   "translate-to-label": "ترجمه به",
   "select-a-language-placeholder": "--یک زبان انتخاب کنید--",
   "select-language-first-error": "لطفاً ابتدا یک زبان انتخاب کنید",
   "translation-saved-success-description": "ترجمه با موفقیت ذخیره شد",
   "save-translation-button": "ذخیره ترجمه",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "ماژول الزامی است",
   "at-least-one-section-required-validation": "حداقل یک بخش الزامی است",
   "resource-type-required-validation": "نوع منبع الزامی است",
   "at-least-one-attachment-required-validation": "حداقل یک پیوست الزامی است",
   "description-required-validation": "توضیحات الزامی است",
   "tagged-topics-required-validation": "موضوعات برچسب‌گذاری‌شده الزامی هستند",
   "invalid-url-format-validation": "قالب URL نامعتبر است",
   "link-url-required-validation": "آدرس لینک الزامی است",
   "agree-to-terms-required-validation": "باید با شرایط موافقت کنید",
   "section-required-validation": "بخش الزامی است",
   "resources-added-success-title": "منابع با موفقیت افزوده شدند!",
   "resources-added-success-description": "این منابع ایجاد و به پایگاه داده شما افزوده شدند.",
   "upload-resource-matching-type-error": "لطفاً منبعی را بارگذاری کنید که با نوع انتخاب‌شده مطابقت داشته باشد.",
   "resources-updated-success-title": "منابع با موفقیت به‌روزرسانی شدند!",
   "resources-updated-success-description": "این منابع با موفقیت به‌روزرسانی شدند.",
   "add-new-resource-title": "منبع جدید",
   "edit-resource-title": "ویرایش منبع",
   "resource-upload-shared-repository-notice":
      "هر منبعی که در پلتفرم بارگذاری کنید در مخزن مشترک KAPorg منتشر خواهد شد و برای دیگر کاربران جهت دانلود و اشتراک‌گذاری در دسترس قرار می‌گیرد و از پشتیبانی جامعه حمایت می‌کند.",
   "select-module-link-resource-label": "ماژولی را که می‌خواهید این منبع را به آن پیوند دهید انتخاب کنید",
   "all-modules-in-assessment-placeholder": "همه ماژول‌های این ارزیابی",
   "select-section-link-resource-label":
      "بخش ماژولی را که می‌خواهید این منبع را به آن پیوند دهید انتخاب کنید",
   "all-sections-of-module-placeholder": "همه بخش‌های ماژول",
   "resource-information-title": "اطلاعات منبع",
   "select-resource-type-label": "نوع منبع را انتخاب کنید",
   "before-upload-select-type-hint": "پیش از بارگذاری منبع باید نوع آن را انتخاب کنید",
   "paste-link-here-label": "لینک را اینجا الصاق کنید",
   "enter-link-url-placeholder": "آدرس لینک را وارد کنید",
   "upload-file-here-label": "فایل را اینجا بارگذاری کنید",
   "drag-drop-file-here-prefix": "فایل را اینجا بکشید و رها کنید، یا",
   "click-to-select-file-text": "برای انتخاب فایل کلیک کنید",
   "max-file-size-text": "حداکثر حجم فایل: ۲۰ مگابایت",
   "enter-resource-description-label": "توضیحات منبع را وارد کنید",
   "tagged-topics-label": "موضوعات برچسب‌گذاری‌شده",
   "enter-tagged-topics-placeholder": "موضوعاتی که این منبع می‌تواند با آن‌ها مرتبط باشد را وارد کنید",
   "upload-rights-confirmation-text":
      "با بارگذاری این محتوا، تأیید می‌کنم که حقوق و اجازه‌های لازم برای این کار را دارم.",
   "add-resource-button": "افزودن منبع",
   "expert-name-column": "نام کارشناس",
   "operating-countries-column": "کشورهای عملیاتی",
   "years-of-experience-column": "سال‌های تجربه",
   "expert-cv-column": "رزومه کارشناس",
   "areas-of-expertise-column": "زمینه‌های تخصص",
   "assign-experts-to-assessment-title": "اختصاص کارشناسان به این ارزیابی",
   "select-expert-assign-assessment-text": "کارشناسی را که می‌خواهید به این ارزیابی اختصاص دهید انتخاب کنید.",
   "search-resource-by-name-placeholder": "جستجوی منبع با نام آن",
   "assign-expert-to-assessment-button": "اختصاص کارشناس به این ارزیابی",
   "expert-assigned-success-title": "کارشناس با موفقیت اختصاص یافت!",
   "expert-assigned-success-description": "این کارشناس اختصاص یافته و به پایگاه داده برنامه اقدام شما افزوده شده است.",
   "assign-expert-error-description":
      "در اختصاص این کارشناس به برنامه اقدام شما مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "expert-removed-success-title": "کارشناس با موفقیت حذف شد!",
   "expert-removed-success-description": "این کارشناس از پایگاه داده برنامه اقدام شما حذف شده است.",
   "remove-expert-from-assessment-button": "حذف کارشناس از این ارزیابی",
   "email-label-colon": "ایمیل:",
   "description-label-colon": "توضیحات:",
   "no-description-available-text": "توضیحی موجود نیست",
   "no-expertise-listed-text": "تخصصی ذکر نشده است",
   "field-of-study-label": "زمینه تحصیلی",
   "no-field-of-study-listed-text": "زمینه تحصیلی ذکر نشده است",
   "no-operating-countries-listed-text": "کشور عملیاتی ذکر نشده است",
   "languages-label": "زبان‌ها",
   "no-languages-listed-text": "زبانی ذکر نشده است",
   "linkedin-profile-label": "پروفایل لینکدین",
   "no-linkedin-profile-text": "پروفایل لینکدینی ارائه نشده است",
   "delete-collection-title": "حذف مجموعه",
   "delete-collection-confirm-text": "شما در حال حذف این مجموعه هستید. این عملیات قابل بازگشت نیست.",
   "delete-resource-title": "حذف منبع",
   "delete-resource-confirm-text": "شما در حال حذف این منبع هستید. این عملیات قابل بازگشت نیست.",
   "collection-deleted-success-title": "مجموعه با موفقیت حذف شد!",
   "collection-deleted-success-description": "این مجموعه با موفقیت از پایگاه داده شما حذف شد.",
   "resource-deleted-success-title": "منبع با موفقیت حذف شد!",
   "resource-deleted-success-description": "این منبع با موفقیت از پایگاه داده شما حذف شد.",
   "delete-resource-error-description": "در حذف این منبع مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "resource-preview-title": "پیش‌نمایش منبع",
   "document-type-label": "سند",
   "video-type-label": "ویدیو",
   "slide-type-label": "اسلاید",
   "tags-and-categories-label": "برچسب‌ها و دسته‌ها",
   "upload-date-label": "تاریخ بارگذاری",
   "description-label": "توضیحات",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "وضعیت:",
   "assign-to-label-colon": "اختصاص به:",
   "deadline-label-colon": "مهلت:",
   "resources-attached-section-text": "منابع پیوست‌شده به این بخش",
   "resource-link-label-colon": "این لینک منبع است:",
   "task-title-required-validation": "عنوان وظیفه الزامی است",
   "deadline-required-validation": "مهلت الزامی است",
   "create-new-task-title": "ایجاد وظیفه جدید",
   "edit-task-title": "ویرایش وظیفه",
   "task-title-label": "عنوان وظیفه",
   "task-title-example-placeholder": "چند بار به کارمندان خود آموزش می‌دهید؟",
   "enter-task-instruction-placeholder":
      "یادداشت یا دستورالعملی وارد کنید که به فرد مسئول در انجام وظیفه کمک کند",
   "assign-task-to-label": "اختصاص وظیفه به",
   "select-member-assign-task-placeholder": "عضوی را برای اختصاص این وظیفه انتخاب کنید",
   "cant-find-member-assign-task-text": "عضو مورد نظر برای اختصاص وظیفه را پیدا نمی‌کنید؟",
   "add-in-organization-management-text": "آن را در مدیریت سازمان اضافه کنید",
   "upload-files-complete-task-label": "فایل‌های لازم برای تکمیل این وظیفه را بارگذاری کنید",
   "can-add-up-to-3-resources-text": "می‌توانید تا ۳ منبع اضافه کنید",
   "deadline-label": "مهلت",
   "resource-link-optional-label": "آیا منبع شما یک لینک است؟ لطفاً آن را اینجا وارد کنید",
   "enter-resource-link-placeholder": "لینک منبع خود را وارد کنید",
   "assign-task-title": "اختصاص وظیفه",
   "assign-task-at-least-one-member-validation": "وظیفه را به حداقل یک عضو اختصاص دهید",
   "deadline-valid-date-validation": "مهلت باید یک تاریخ معتبر باشد",
   "select-deadline-placeholder": "مهلت را انتخاب کنید",
   "task-added-assigned-success-title": "وظیفه با موفقیت افزوده و اختصاص یافت!",
   "task-added-assigned-success-description":
      "این وظیفه با موفقیت اختصاص یافت، عضوی که انتخاب کردید از آن مطلع خواهد شد.",
   "assign-task-error-description": "در اختصاص این وظیفه مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "select-status-title": "وضعیت را انتخاب کنید",
   "task-updated-success-title": "وظیفه با موفقیت به‌روزرسانی شد!",
   "task-updated-success-description": "این وظیفه با موفقیت در پایگاه داده شما به‌روزرسانی شد.",
   "update-task-error-description": "در به‌روزرسانی این وظیفه مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "task-deleted-success-title": "وظیفه با موفقیت حذف شد!",
   "task-deleted-success-description": "این وظیفه با موفقیت از پایگاه داده شما حذف شد.",
   "delete-task-error-description": "در حذف این وظیفه مشکلی پیش آمد، لطفاً دوباره تلاش کنید.",
   "delete-task-title": "حذف وظیفه",
   "delete-task-confirm-text": "شما در حال حذف این وظیفه هستید. این عملیات قابل بازگشت نیست.",
   "rounds-filter-label": "دورها",
   "managers-filter-label": "مدیران",
   "generate-report-button": "ایجاد گزارش",
   "generate-report-title": "ایجاد گزارش",
   "choose-sections-report-text": "بخش‌هایی را که می‌خواهید در گزارش شامل شوند، انتخاب کنید.",
   "include-module-breakdown-label": "شامل کردن تفکیک ماژول",
   "of-label": "از",
   "sections-selected-suffix": "بخش انتخاب شده",
   "generate-button": "ایجاد",
   "report-preview-title": "پیش‌نمایش گزارش",
   "edit-sections-button": "ویرایش بخش‌ها",
   "assessment-report-eyebrow-text": "گزارش ارزیابی",
   "no-sections-data-selected-text": "هیچ بخشی با معلومات انتخاب نشده است.",
   "assessment-report-pdf-heading": "گزارش ارزیابی",
   "exported-on-label": "صادر شده در",
   "page-word": "صفحه",
   "add-review-note-title": "افزودن یادداشت بازبینی",
   "edit-review-note-title": "ویرایش یادداشت بازبینی",
   "note-title-required-validation": "لطفاً عنوان یادداشت را وارد کنید",
   "enter-note-title-placeholder": "عنوان یادداشت را وارد کنید",
   "round-covered-label": "دور تحت پوشش",
   "select-option-required-validation": "لطفاً یک گزینه را انتخاب کنید",
   "note-required-validation": "لطفاً یادداشت‌های خود را وارد کنید",
   "summarize-progress-placeholder": "پیشرفت‌های مهم، تصامیم یا مسائل را خلاصه کنید.",
   "add-note-button": "افزودن یادداشت",
   "staff-members-fetch-error":
      "در دریافت اعضای کارمندان مشکلی پیش آمد، لطفاً صفحه را دوباره بار کنید.",
   "task-priority-fetch-error":
      "در دریافت اولویت وظیفه مشکلی پیش آمد، لطفاً صفحه را دوباره بار کنید.",
   "select-section-add-task-error": "لطفاً یک بخش را برای افزودن این وظیفه انتخاب کنید.",
   "add-task-error-description": "در افزودن این وظیفه مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "add-new-task-title": "افزودن وظیفه جدید",
   "task-name-label": "نام وظیفه",
   "task-name-required-validation": "لطفاً نام وظیفه را وارد کنید",
   "enter-task-name-placeholder": "نام وظیفه را وارد کنید",
   "linked-questions-label": "سوالات مرتبط",
   "select-questions-required-validation": "لطفاً سوالات را انتخاب کنید",
   "linked-questions-helper-text": "سوالاتی را که این وظیفه قرار است بهبود دهد انتخاب کنید",
   "select-questions-placeholder": "سوالات را انتخاب کنید",
   "task-description-required-validation": "لطفاً یک توضیح وارد کنید",
   "enter-task-description-placeholder": "توضیح وظیفه را وارد کنید",
   "select-member-required-validation": "لطفاً یک عضو را انتخاب کنید",
   "select-deadline-required-validation": "لطفاً یک ضرب‌الاجل را انتخاب کنید",
   "priority-label": "اولویت",
   "select-priority-required-validation": "لطفاً اولویت را انتخاب کنید",
   "select-priority-placeholder": "اولویت را انتخاب کنید",
   "resources-label": "منابع",
   "select-resources-placeholder": "منابع مرتبط با این وظیفه را انتخاب کنید",
   "select-resources-required-validation": "لطفاً منابع را انتخاب کنید",
   "search-resource-placeholder": "جستجوی یک منبع",
   "browse-resources-library-text": "مرور کتابخانه منابع",
   "add-task-button": "افزودن وظیفه",
   "confirm-selection-button": "تایید انتخاب",
   "resource-library-title": "کتابخانه منابع",
   "collections-tab-label": "مجموعه‌ها",
   "workspace-breadcrumb-label": "محیط کاری",
   "resources-breadcrumb-label": "منابع",
   "results-breadcrumb-label": "نتایج",
   "action-plan-breadcrumb-label": "پلان عمل",
   "respondents-count-label": "پاسخ‌دهندگان",
   "of-word": "از",
   "copy-tasks-title": "کاپی وظایف",
   "copy-tasks-description-text":
      "تمام وظایف از دور قبلی شما کاپی خواهند شد تا اطمینان حاصل شود که پلان عملیاتی شما با گذشت زمان کامل باقی می‌ماند.",
   "previous-round-label": "دور قبلی:",
   "tasks-copied-label": "وظایف کاپی شده",
   "task-statistics-fetch-error": "در بارگذاری آمار وظایف مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "delete-note-confirm-text":
      "شما در حال حذف این یادداشت بازبینی هستید. این عملیات قابل بازگشت نیست.",
   "delete-view-title": "حذف نمایش",
   "delete-view-confirm-text": "شما در حال حذف این نمایش هستید. این عملیات قابل بازگشت نیست.",
   "rename-view-title": "تغییر نام نمایش",
   "save-button": "ذخیره",
   "select-a-resource-title": "یک منبع انتخاب کنید",
   "set-a-reminder-title": "تنظیم یادآوری",
   "reminder-description-text":
      "انتخاب کنید که چه وقت می‌خواهید برای افزودن یا به‌روزرسانی یادداشت‌های پیشرفت تیم خود یادآوری شوید.",
   "reminder-type-label": "نوع یادآوری",
   "select-reminder-type-required-validation": "لطفاً یک نوع یادآوری را انتخاب کنید",
   "select-day-required-validation": "لطفاً یک روز را انتخاب کنید",
   "select-a-day-placeholder": "یک روز را انتخاب کنید",
   "reminder-repeat-prefix-text": "این نخستین تاریخ یادآوری شما خواهد بود. یادآوری‌های بعدی هر",
   "repeat-interval-week": "هفته",
   "repeat-interval-2-weeks": "2 هفته",
   "repeat-interval-month": "ماه",
   "repeat-interval-3-months": "3 ماه",
   "repeat-interval-year": "سال",
   "reminder-repeat-suffix-text": "در همان روز تکرار می‌شود.",
   "next-reminder-date-label": "تاریخ یادآوری بعدی:",
   "save-reminder-button": "ذخیره یادآوری",
   "my-workspaces-tab": "فضاهای کاری من",
   "all-workspaces-tab": "همه فضاهای کاری",
   "fetch-workspaces-error-description": "در دریافت فضاهای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "archived-workspaces-title": "فضاهای کاری بایگانی شده",
   "deleted-workspaces-button": "فضاهای کاری حذف شده",
   "new-workspace-button": "فضای کاری جدید",
   "remove-action": "حذف",
   "workspace-name-label": "نام فضای کاری",
   "enter-workspace-name-placeholder": "نام فضای کاری خود را وارد کنید",
   "workspace-description-label": "توضیحات فضای کاری",
   "enter-workspace-description-placeholder": "توضیحات فضای کاری را وارد کنید",
   "workspace-countries-label": "کشورهای فضای کاری",
   "select-a-country-placeholder": "یک کشور را انتخاب کنید",
   "workspace-assessment-label": "ارزیابی فضای کاری",
   "select-default-assessment-survey-placeholder": "ارزیابی پیش‌فرض این پرسشنامه را انتخاب کنید",
   "select-default-assessment-module-placeholder": "ارزیابی پیش‌فرض این ماژول را انتخاب کنید",
   "workspace-duplicate-name-validation": "این فضای کاری از قبل وجود دارد. لطفاً نام دیگری را امتحان کنید.",
   "workspace-created-success-title": "فضای کاری با موفقیت ایجاد شد!",
   "workspace-created-success-description": "یک فضای کاری جدید ایجاد شد و به پایگاه داده شما افزوده شد",
   "create-workspace-error-description": "در ایجاد این فضای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "add-new-workspace-title": "افزودن فضای کاری جدید",
   "workspace-updated-success-title": "فضای کاری با موفقیت به‌روزرسانی شد!",
   "workspace-updated-success-description": "این فضای کاری با موفقیت به‌روزرسانی شد.",
   "update-workspace-error-description":
      "در به‌روزرسانی این فضای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "edit-workspace-title": "ویرایش فضای کاری",
   "at-least-one-assessment-required-validation": "حداقل یک ارزیابی الزامی است",
   "workspace-archived-success-title": "فضای کاری با موفقیت بایگانی شد!",
   "workspace-archived-success-description": "این فضای کاری با موفقیت بایگانی شد.",
   "archive-workspace-error-description":
      "در بایگانی کردن این فضای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "archive-workspace-title": "بایگانی فضای کاری",
   "archive-workspace-confirm-text": "شما در حال بایگانی کردن این فضای کاری هستید.",
   "workspace-deleted-success-title": "فضای کاری با موفقیت حذف شد!",
   "workspace-deleted-success-description": "این فضای کاری با موفقیت حذف شد.",
   "delete-workspace-error-description": "در حذف این فضای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "delete-workspace-title": "حذف فضای کاری",
   "delete-workspace-confirm-text": "شما در حال حذف این فضای کاری هستید.",
   "workspace-restored-success-title": "فضای کاری با موفقیت بازیابی شد!",
   "restore-workspace-error-description":
      "در بازیابی این فضای کاری مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "workspace-deleted-permanently-success-description":
      "این فضای کاری با موفقیت از پایگاه داده شما حذف شد.",
   "restore-assessment-error-description": "در بازیابی این ارزیابی مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "restore-workspaces-button": "بازیابی فضاهای کاری",
   "delete-workspace-permanently-title": "حذف همیشگی فضای کاری",
   "delete-workspace-permanently-confirm-text":
      "شما در حال حذف همیشگی این فضای کاری هستید. این عملیات قابل بازگشت نیست.",
   "workspaces-unarchived-success-title": "فضاهای کاری با موفقیت از بایگانی خارج شدند!",
   "workspaces-unarchived-success-description":
      "این فضاهای کاری از بایگانی خارج شده و به پایگاه داده شما افزوده شدند.",
   "unarchive-workspace-error-description":
      "در خارج کردن این فضای کاری از بایگانی مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "workspaces-deleted-success-title": "فضاهای کاری با موفقیت حذف شدند!",
   "workspaces-deleted-success-description": "این فضاهای کاری از پایگاه داده شما حذف شدند.",
   "deleted-workspaces-list-title": "فهرست فضاهای کاری حذف شده",
   "deleted-workspaces-retention-text":
      "در اینجا می‌توانید فضاهای کاری حذف شده را مشاهده و بازیابی کنید. هر فضای کاری که ظرف 60 روز بازیابی نشود، برای همیشه حذف خواهد شد.",
   "request-canceled-success-title": "درخواست با موفقیت لغو شد!",
   "request-canceled-success-description": "درخواست شما لغو شد.",
   "cancel-request-error-description": "در لغو این درخواست مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "cancel-request-button": "لغو درخواست",
   "send-request-success-description":
      "درخواست شما به مدیر ارسال شد. به محض پاسخ به درخواست، یک ایمیل دریافت خواهید کرد.",
   "send-request-error-description": "در ارسال درخواست شما مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "no-workspaces-here-title": "هیچ فضای کاری اینجا نیست!",
   "request-part-workspace-description":
      "اما نگران نباشید، می‌توانید درخواست کنید که بخشی از یک فضای کاری در بخش «همه فضاهای کاری» شوید.",
   "go-to-all-workspaces-button": "برو به همه فضاهای کاری",
   "create-workspaces-tagline-text":
      "فضاهای کاری متناسب برای تقویت رشد و بهینه‌سازی سازمان‌ها ایجاد کنید.",
   "export-workspaces-button": "صدور فضاهای کاری",
   "all-workspaces-consultant-heading": "همه فضاهای کاری",
   "assess-partners-consultant-description":
      "شروع به ارزیابی همکاران/سازمان‌های غیر دولتی محلی کنید و به آنها گزارش مفصلی از عملکرد فعلی شان ارائه دهید.",
   "access-workspace-organization-text": "به یک فضای کاری دسترسی پیدا کنید و به سازمان خود دسترسی داشته باشید.",
   "no-workspace-created-yet-description":
      "به نظر می‌رسد شما تا حالا هیچ فضای کاری ایجاد نکرده‌اید. اما نگران نباشید، می‌توانید آن را همینجا ایجاد کنید.",
   "untitled-label": "بدون عنوان",
   "no-section-label": "بدون بخش",
   "swot-analysis-title": "تحلیل SWOT",
   "swot-analysis-subtitle-text": "نقاط قوت، ضعف، فرصت‌ها و تهدیدها را تحلیل کنید",
   "related-module-label": "ماژول مرتبط",
   "select-module-placeholder": "ماژول را انتخاب کنید",
   "enter-analysis-description-placeholder": "توضیح تحلیل را وارد کنید",
   "swot-strengths-title": "نقاط قوت",
   "swot-weaknesses-title": "نقاط ضعف",
   "swot-opportunities-title": "فرصت‌ها",
   "swot-threats-title": "تهدیدها",
   "related-sections-label": "بخش‌های مرتبط",
   "select-sections-placeholder": "بخش‌ها را انتخاب کنید",
   "analysis-label": "تحلیل",
   "describe-strengths-placeholder": "نقاط قوت را توضیح دهید",
   "describe-weaknesses-placeholder": "نقاط ضعف را توضیح دهید",
   "describe-opportunities-placeholder": "فرصت‌ها را توضیح دهید",
   "describe-threats-placeholder": "تهدیدها را توضیح دهید",
   "add-analysis-button": "افزودن تحلیل",
   "scores-label": "امتیازها",
   "guided-assessment-label": "ارزیابی رهنمایی‌شده",
   "self-assessment-label": "خودارزیابی",
   "highlights-title": "نکات برجسته",
   "highlights-subtitle-text": "یافته‌های کلیدی را برجسته کنید و بر اساس نتایج پیشنهاد ارائه دهید",
   "choose-chart-analyze-label": "نمودار مورد نظر برای تحلیل را انتخاب کنید",
   "select-chart-analyze-text": "نمودار مورد نظر برای تحلیل را انتخاب کنید",
   "change-button": "تغییر",
   "select-a-module-first-placeholder": "ابتدا یک ماژول را انتخاب کنید",
   "add-comparison-label": "افزودن مقایسه",
   "insight-label": "بینش",
   "max-400-characters-validation": "حداکثر 400 حرف",
   "describe-key-points-placeholder":
      "نکات کلیدی را که می‌خواهید از این نمودار برجسته کنید توضیح دهید...",
   "select-chart-to-analyze-title": "یک نمودار برای تحلیل انتخاب کنید",
   "choose-chart-from-list-text": "یکی از نمودارهای موجود را از لیست برای تحلیل انتخاب کنید.",
   "report-title": "گزارش",
   "upload-report-insights-text": "گزارش خود را بار کنید تا بخشی از بینش‌های این ارزیابی شود.",
   "upload-file-here-label": "فایل را اینجا بار کنید",
   "current-file-text": "فایل فعلی",
   "remove-file-aria-label": "حذف فایل",
   "doc-pdf-pptx-text": "DOC، PDF یا PPTX",
   "only-doc-pdf-pptx-error": "فقط فایل‌های DOC، PDF یا PPTX مجاز است.",
   "file-must-be-smaller-than-prefix": "اندازه فایل باید کمتر از",
   "missing-assessment-org-warning": "معلومات ارزیابی یا سازمان موجود نیست.",
   "upload-report-file-warning": "لطفاً یک فایل گزارش بار کنید.",
   "title-required-validation": "عنوان الزامی است",
   "ticket-type-required-validation": "نوع تکت الزامی است",
   "message-required-validation": "پیام الزامی است",
   "ticket-added-success-title": "تکت با موفقیت افزوده شد!",
   "ticket-added-success-description":
      "این تکت با موفقیت به پایگاه داده تاریخچه تکت‌های شما افزوده شد، به زودی کسی به درخواست شما پاسخ خواهد داد.",
   "add-ticket-error-description": "در افزودن این تکت مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "upload-jpg-png-gif-webp-error": "لطفاً فقط فایل‌های JPG، PNG، GIF یا WEBP را بار کنید.",
   "add-new-ticket-title": "افزودن تکت جدید",
   "ticket-type-label": "نوع تکت",
   "select-ticket-type-placeholder": "نوع تکت را انتخاب کنید",
   "summary-label": "خلاصه",
   "enter-title-placeholder": "عنوان را وارد کنید",
   "describe-problem-detail-label": "مشکل را به تفصیل توضیح دهید",
   "type-something-placeholder": "چیزی اینجا بنویسید",
   "attach-evidence-label": "هر مدرکی که مهم می‌دانید ضمیمه کنید",
   "jpg-png-gif-webp-text": "JPG، PNG، GIF و WEBP",
   "add-ticket-button": "افزودن تکت",
   "tickets-deleted-success-title": "تکت‌های انتخاب شده با موفقیت حذف شدند!",
   "tickets-deleted-success-description": "این تکت‌های انتخاب شده با موفقیت از پایگاه داده حذف شدند",
   "delete-tickets-error-description":
      "در حذف این تکت‌های انتخاب شده مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "delete-selected-tickets-title": "حذف تکت‌های انتخاب شده",
   "delete-selected-tickets-confirm-text": "شما در حال حذف این تکت‌های انتخاب شده هستید.",
   "collection-updated-success-title": "مجموعه با موفقیت به‌روزرسانی شد!",
   "collection-updated-success-description": "این مجموعه به درستی به‌روزرسانی شد.",
   "update-collection-error-description": "در به‌روزرسانی این مجموعه مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "collection-added-success-title": "مجموعه با موفقیت افزوده شد!",
   "collection-added-success-description": "این مجموعه ایجاد شد و به پایگاه داده شما افزوده شد.",
   "add-collection-error-description": "در افزودن این مجموعه مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "edit-collection-title": "ویرایش مجموعه",
   "add-new-collection-title": "افزودن مجموعه جدید",
   "new-collection-button-label": "مجموعه جدید",
   "name-collection-label": "نام مجموعه",
   "enter-collection-name-placeholder": "نام مجموعه را وارد کنید",
   "enter-collection-description-placeholder": "توضیحات مجموعه را وارد کنید",
   "select-the-assessment-label": "ارزیابی را انتخاب کنید",
   "select-resources-collection-placeholder": "منابع مرتبط با این مجموعه را انتخاب کنید",
   "see-more-text": "بیشتر ببینید",
   "make-collection-public-label": "این مجموعه را عمومی و برای همه قابل مشاهده کنید",
   "add-collection-button": "افزودن مجموعه",
   "global-status": "عمومی",
   "owner-colon-label": "مالک:",
   "resources-colon-label": "منابع:",
   "resource-added-collection-success-title": "منبع به مجموعه افزوده شد!",
   "resource-added-collection-success-description": "این منبع با موفقیت به مجموعه افزوده شد.",
   "add-resource-collection-error-description":
      "در افزودن این منبع به مجموعه مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "add-to-collection-title": "افزودن به مجموعه",
   "resource-updated-success-title": "منبع با موفقیت به‌روزرسانی شد!",
   "resource-updated-success-description": "این منبع به درستی به‌روزرسانی شد. یک نسخه جدید ایجاد شد",
   "update-resource-error-description": "در به‌روزرسانی این منبع مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "resource-added-success-title": "منبع با موفقیت افزوده شد!",
   "resource-added-success-description": "این منبع ایجاد شد و به پایگاه داده شما افزوده شد.",
   "add-resource-error-description": "در افزودن این منبع مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "edit-resource-title": "ویرایش منبع",
   "select-resource-type-label": "نوع منبع را انتخاب کنید",
   "select-resource-type-required-validation": "لطفاً نوع منبع را انتخاب کنید",
   "video-placeholder-text": "ویدیو",
   "select-type-before-upload-text": "قبل از بار کردن یک منبع باید نوع آن را انتخاب کنید",
   "enter-resource-link-label": "لطفاً لینک منبع را اینجا وارد کنید",
   "valid-url-required-validation": "لطفاً یک آدرس معتبر وارد کنید",
   "enter-resource-link-placeholder": "لینک منبع خود را وارد کنید",
   "select-a-file-required-validation": "لطفاً یک فایل را انتخاب کنید",
   "click-to-select-files-text": "برای انتخاب فایل‌ها کلیک کنید",
   "resource-version-colon-label": "نسخه منبع:",
   "make-resource-private-label": "این منبع را خصوصی کنید",
   "resource-name-label": "نام منبع",
   "enter-resource-name-placeholder": "نام منبع را وارد کنید",
   "tags-label": "برچسب‌ها",
   "enter-resource-tags-placeholder": "موضوعاتی که این منبع می‌تواند با آن‌ها مرتبط باشد را وارد کنید",
   "select-module-label": "ماژول را انتخاب کنید",
   "select-section-label": "بخش را انتخاب کنید",
   "upload-consent-text":
      "هر منبعی که بار می‌کنید، طبق سطح دیدی که انتخاب می‌کنید، در مخزن KAPorg ذخیره خواهد شد و برای مخاطبان انتخاب شده در دسترس قرار می‌گیرد. با ادامه دادن، تایید می‌کنید که حقوق و اجازه‌های لازم برای بار کردن این مواد را دارید.",
   "add-resource-button": "افزودن منبع",
   "file-label": "فایل",
   "views-suffix": "بازدید",
   "rating-suffix": "امتیاز",
   "owner-label": "مالک",
   "visibility-label": "دید",
   "linked-to-label": "مرتبط با",
   "last-update-date-label": "تاریخ آخرین به‌روزرسانی",
   "resource-version-label": "نسخه منبع",
   "targets-updated-success-title": "اهداف با موفقیت به‌روزرسانی شد!",
   "targets-updated-success-description": "همه تغییرات با موفقیت ذخیره شد.",
   "save-targets-error-description": "در ذخیره کردن همه تغییرات مشکلی پیش آمد، لطفاً دوباره کوشش کنید.",
   "current-target-label": "هدف فعلی:",
   "no-active-rounds-text": "هیچ دور فعالی وجود ندارد",
   "no-target-set-yet-text": "هنوز هدفی تعیین نشده است",
   "no-assessments-found-text": "هیچ ارزیابی یافت نشد",
   "no-modules-yet-title": "هنوز ماژولی وجود ندارد",
   "no-modules-assigned-description":
      "این ارزیابی هیچ ماژول اختصاص یافته ندارد. به محض افزودن، اینجا نمایش داده خواهند شد.",
   "enter-target-placeholder": "هدف را وارد کنید",
   "ticket-history-title": "تاریخچه تکت‌ها",
   "help-desk-title": "میز مساعدت",
   "delete-selected-rows-text": "حذف ردیف‌های انتخاب شده",
   "add-new-ticket-text": "تکت جدید",
   "subject-column": "موضوع",
   "creation-date-column": "تاریخ ایجاد",
   "organization-column": "سازمان",
   "last-response-column": "آخرین پاسخ",
   "ticket-preview-title": "پیش‌نمایش تکت",
   "ticket-status-closed": "بسته شده",
   "ticket-summary-title": "خلاصه تکت",
   "user-email-label": "ایمیل کاربر",
   "ticket-subject-label": "موضوع تکت",
   "mark-as-resolved-button": "بستن تکت",
   "mark-ticket-resolved-title": "این تکت بسته شود؟",
   "mark-ticket-resolved-confirm-text": "آیا مطمین هستید که می‌خواهید این تکت را ببندید؟ سازمان در صورت نیاز به مرسته بیشتر هنوز هم می‌تواند پاسخ بدهد.",
   "ticket-resolved-success-title": "تکت بسته شد",
   "ticket-resolved-success-description": "این تکت بسته شد.",
   "resolve-ticket-error-description": "در جریان بستن تکت یک خطا رخ داد. لطفاً دوباره کوشش کنید.",
   "type-your-message-placeholder": "پیام خود را اینجا بنویسید...",
   "filter-tickets-by-type-placeholder": "فیلتر بر اساس نوع",
   "filter-tickets-by-status-placeholder": "فیلتر بر اساس وضعیت",
   "summary-results-title": "خلاصه نتایج",
   "graphs-view-tab": "نمایش نمودارها",
   "table-view-tab": "نمایش جدول",
   "expert-insights-tab": "بینش‌های کارشناسان",
   "no-dashboard-results-yet-title": "این داشبورد هنوز نتیجه‌ای ندارد",
   "results-appear-here-description":
      "به محض این‌که معلومات موجود شود، نتایج شما اینجا نمایش داده خواهد شد.",
   "submission-round-column": "دور ارسال",
   "submission-label-column": "برچسب ارسال",
   "select-module-first-text": "لطفاً ابتدا یک ماژول را انتخاب کنید.",
   "select-at-least-one-submission-round-text": "لطفاً حداقل یک دور ارسال را انتخاب کنید.",
   "unable-detect-organization-text": "تشخیص سازمان شما ممکن نشد. لطفاً دوباره وارد شوید.",
   "download-table-label": "دانلود جدول",
   "score-overview-title": "نمای کلی امتیاز",
   "toggle-score-overview-aria-label": "نمایش/عدم نمایش نمای کلی امتیاز",
   "visualizations-title": "بصری‌سازی‌ها",
   "search-a-graph-placeholder": "جستجوی یک نمودار",
   "select-view-placeholder": "نمایش را انتخاب کنید",
   "save-view-button": "ذخیره نمایش",
   "save-dashboard-button": "ذخیره داشبورد",
   "edit-dashboard-button": "ویرایش داشبورد",
   "download-dashboard-label": "دانلود داشبورد",
   "round-label": "دور",
   "manager-label": "مدیر",
   "select-an-organization-placeholder": "یک سازمان را انتخاب کنید",
   "select-all-option": "انتخاب همه",
   "all-placeholder": "همه",
   "score-percent-label": "امتیاز (%)",
   "task-completion-percent-label": "تکمیل وظایف (%)",
   "task-status-percent-label": "وضعیت وظایف (%)",
   "value-label": "ارزش",
   "first-round-label": "دور اول",
   "second-round-label": "دور دوم",
   "improvement-percent-label": "بهبود %",
   "result-label": "نتیجه",
   "current-label": "فعلی",
   "target-word": "هدف",
   "overall-score-label": "امتیاز کلی",
   "of-tasks-completed-label": "از وظایف تکمیل شده",
   "leading-label": "پیشتاز",
   "developing-label": "در حال توسعه",
   "lagging-label": "عقب‌مانده",
   "section-word": "بخش",
   "task-completion-label": "تکمیل وظایف",
   "indicator-word": "شاخص",
   "progress-word": "پیشرفت",
   "current-round-label": "دور فعلی:",
   "change-label": "تغییر:",
   "improvement-label": "بهبود",
   "task-count-label": "تعداد وظایف",
   "assessment-results-per-module-title": "نتایج ارزیابی به تفکیک ماژول",
   "assessment-results-per-section-title": "نتایج ارزیابی به تفکیک بخش",
   "performance-map-title": "نقشه عملکرد",
   "assessment-results-per-organization-title": "نتایج ارزیابی به تفکیک سازمان",
   "module-results-per-organization-title": "نتایج ماژول به تفکیک سازمان",
   "section-results-per-organization-title": "نتایج بخش به تفکیک سازمان",
   "assessment-targets-per-organization-title": "اهداف ارزیابی به تفکیک سازمان",
   "module-targets-per-organization-title": "اهداف ماژول به تفکیک سازمان",
   "section-targets-per-organization-title": "اهداف بخش به تفکیک سازمان",
   "improvement-tracker-per-organization-title": "پیگیری بهبود به تفکیک سازمان",
   "target-score-task-progress-per-organization-title": "هدف، امتیاز و پیشرفت وظایف به تفکیک سازمان",
   "assessment-results-per-round-title": "نتایج ارزیابی به تفکیک دور",
   "module-results-per-round-title": "نتایج ماژول به تفکیک دور",
   "section-results-per-round-title": "نتایج بخش به تفکیک دور",
   "assessment-targets-per-round-title": "اهداف ارزیابی به تفکیک دور",
   "module-targets-per-round-title": "اهداف ماژول به تفکیک دور",
   "section-targets-per-round-title": "اهداف بخش به تفکیک دور",
   "improvement-tracker-per-assessment-title": "پیگیری بهبود به تفکیک ارزیابی",
   "target-score-task-progress-per-assessment-title": "هدف، امتیاز و پیشرفت وظایف به تفکیک ارزیابی",
   "radar-chart-type-label": "نمودار راداری",
   "tier-list-type-label": "فهرست سطوح",
   "score-progress-across-rounds-title": "پیشرفت نمره در جریان دورها",
   "module-score-progress-across-rounds-title": "پیشرفت نمره ماژول‌ها در جریان دورها",
   "bar-chart-type-label": "نمودار ستونی",
   "table-type-label": "جدول",
   "modules-word": "ماژول‌ها",
   "sections-word": "بخش‌ها",
   "task-status-per-assessment-title": "وضعیت وظایف به تفکیک ارزیابی",
   "module-task-completion-title": "تکمیل وظایف ماژول",
   "section-task-completion-title": "تکمیل وظایف بخش",
   "task-completion-per-organization-title": "تکمیل وظایف به تفکیک سازمان",
   "improvement-tracker-title": "پیگیری بهبود",
   "donut-chart-type-label": "نمودار حلقه‌ای",
   "task-updated-success-message": "وظیفه با موفقیت به‌روزرسانی شد.",
   "task-added-success-message": "وظیفه با موفقیت اضافه شد.",
   "export-tasks-error-message": "در صادر کردن وظایف مشکلی رخ داد، لطفاً دوباره تلاش کنید.",
   "tasks-copied-success-title": "وظایف با موفقیت کاپی شد!",
   "tasks-copied-success-description": "تمام وظایف از دور قبلی به دور فعلی کاپی شدند.",
   "results-not-yet-approved-title": "نتایج هنوز تأیید نشده است!",
   "results-not-yet-approved-description": "وظایف تنها زمانی قابل کاپی شدن است که تمام ماژول‌های این ارزیابی دارای ارسال‌های تأیید شده باشند. لطفاً پیش از کاپی وظایف، ارسال‌های خود را تأیید کنید.",
   "tasks-already-copied-title": "وظایف قبلاً برای این دور کاپی شده است",
   "tasks-already-copied-description": "وظایف تنها یک بار در هر دور قابل کاپی شدن است. اگر وظایفی کم دارید، لطفاً با مدیر خود تماس بگیرید.",
   "copy-tasks-error-title": "اوه! مشکلی رخ داد!",
   "copy-tasks-error-description": "در کاپی کردن وظایف از دور قبلی مشکلی رخ داد، لطفاً دوباره تلاش کنید.",
   "resource-label-colon": "منبع:",
   "edit-module-alt-text": "ویرایش ماژول",
   "delete-module-alt-text": "حذف ماژول",
   "task-status-updated-message": "وضعیت وظیفه به‌روزرسانی شد.",
   "failed-update-task-status-message": "به‌روزرسانی وضعیت وظیفه ناکام شد.",
   "plan-summary-title": "خلاصه پلان",
   "select-organization-to-view-plan-text": "یک سازمان را در بالا انتخاب کنید تا خلاصه پلان آن را ببینید.",
   "select-organization-placeholder": "انتخاب سازمان",
   "previous-round-readonly-notice-text": "این یک دور قبلی است و فقط قابل مشاهده است تا اطلاعات آن حفظ شود. شما فقط می‌توانید در دور فعلی تغییرات ایجاد کنید.",
   "viewing-previous-round-button": "شما در حال مشاهده دور قبلی هستید",
   "go-to-current-round-button": "رفتن به دور فعلی",
   "staff-member-label": "عضو کارمند",
   "export-plan-button": "صدور پلان",
   "task-column-header": "وظیفه",
   "responsible-column-header": "مسئول",
   "due-date-column-header": "تاریخ سررسید",
   "see-less-link": "کمتر ببینید",
   "see-all-link": "همه را ببینید",
   "no-linked-questions-text": "هیچ سوال مرتبطی وجود ندارد",
   "resources-label-colon": "منابع:",
   "no-tasks-for-staff-member-text": "هیچ وظیفه‌ای برای عضو کارمند انتخاب شده یافت نشد",
   "add-tasks-improve-score-text": "برای بهبود امتیاز خود، وظایف را به این شاخص اضافه کنید",
   "result-label-colon": "نتیجه:",
   "target-label-colon": "هدف:",
   "review-note-added-success-description": "یادداشت بازبینی با موفقیت اضافه شد.",
   "reminder-set-title": "یادآوری تعیین شد",
   "reminder-scheduled-success-description": "یادآوری شما با موفقیت زمان‌بندی شد.",
   "review-notes-title": "یادداشت‌های بازبینی",
   "set-reminder-button": "تعیین یادآوری",
   "print-summary-button": "چاپ خلاصه",
   "export-notes-button": "صدور یادداشت‌ها",
   "note-word": "یادداشت",
   "no-note-created-yet-text": "هنوز هیچ یادداشتی ایجاد نشده است.",
   "no-review-notes-available-text": "هیچ یادداشت بازبینی موجود نیست.",
   "no-score-selected-text": "هیچ امتیازی انتخاب نشده است",
   "filters-colon-label": "فلترها:",
   "none-word": "هیچ",
   "graph-word": "نمودار",
   "no-chart-content-text": "هیچ محتوای نمودار وجود ندارد",
   "filter-colon-label": "فلتر:",
   "action-plan-word": "پلان عملی",
   "results-word": "نتایج",
   "no-charts-available-title": "هیچ نموداری موجود نیست",
   "no-charts-data-export-text": "هیچ نموداری با داده‌های قابل صدور موجود نیست.",
   "summary-action-plan-dashboard-title": "خلاصه داشبورد پلان عملی",
   "summary-results-dashboard-title": "خلاصه داشبورد نتایج",
   "assessment-colon-label": "ارزیابی:",
   "assessment-word": "ارزیابی",
   "download-svg-action": "دانلود SVG",
   "download-png-action": "دانلود PNG",
   "included-in-report-tooltip-text": "هنگام تولید گزارش شامل می‌شود",
   "no-visualization-selected-text": "هیچ نمایش بصری انتخاب نشده است",
   "drop-visualization-here-text": "نمایش بصری را اینجا رها کنید",
   "add-graph-button": "افزودن نمودار",
   "delete-block-tooltip-text": "حذف بلاک",
   "no-filters-selected-text": "هیچ فلتری انتخاب نشده است",
   "filters-word": "فلترها",
   "untitled-graph-text": "نمودار بدون عنوان",
   "graph-preview-unavailable-text": "پیش‌نمایش نمودار در دسترس نیست",
   "filter-word": "فلتر",
   "global-suffix-label": "(سراسری)",
   "organization-word": "سازمان",
   "staff-word": "کارمندان",
   "generic-problem-occurred-title": "اوه! مشکلی رخ داد",
   "view-saved-success-title": "نمایش با موفقیت ذخیره شد!",
   "view-saved-success-description": "نمایش داشبورد شما با موفقیت ذخیره شد.",
   "problem-saving-view-description": "در ذخیره این نمایش مشکلی رخ داد، لطفاً دوباره تلاش کنید.",
   "select-view-before-rename-text": "پیش از تغییر نام، یک نمایش را انتخاب کنید.",
   "select-view-before-delete-text": "پیش از حذف، یک نمایش را انتخاب کنید.",
   "view-deleted-success-title": "نمایش با موفقیت حذف شد!",
   "view-deleted-success-description": "نمایش انتخاب شده از داشبورد شما حذف شد.",
   "problem-deleting-view-description": "در حذف این نمایش مشکلی رخ داد، لطفاً دوباره تلاش کنید.",
   "view-renamed-success-title": "نام نمایش با موفقیت تغییر یافت!",
   "view-renamed-success-description": "نام نمایش انتخاب شده با موفقیت به‌روزرسانی شد.",
   "problem-renaming-view-description": "در تغییر نام این نمایش مشکلی رخ داد، لطفاً دوباره تلاش کنید.",
   "view-word": "نمایش",
   "compare-with-self-assessment-label": "مقایسه با خودارزیابی",
   "comparison-limited-one-org-text": "این مقایسه در هر بار به یک سازمان محدود است",
   "assessment-not-linked-self-text": "این ارزیابی به یک خودارزیابی وصل نیست",
   "dashboard-word": "داشبورد",
   "self-assessments-menu-item": "خودارزیابی‌ها",
   "guided-assessments-menu-item": "ارزیابی‌های هدایت‌شده",
   "module-request-menu-item": "درخواست ماژول",
   "action-plan-menu-item": "پلان عملی",
   "my-performance-menu-item": "عملکرد من",
   "task-management-menu-item": "مدیریت وظایف",
   "resources-menu-item": "منابع",
   "organization-management-menu-item": "مدیریت سازمان",
   "quick-search-tooltip-text": "جستجوی سریع",
   "notifications-tooltip-text": "اطلاعیه‌ها",
   "help-desk-word": "میز مساعدت",
   "go-back-previous-menu-text": "بازگشت به منوی قبلی",
   "go-back-to-action-plan-link": "بازگشت به پلان عملی",
   "go-back-to-module-list-link": "بازگشت به فهرست ماژول‌ها",
   "go-back-to-modules-list-link": "بازگشت به فهرست ماژول‌ها",
   "go-back-to-templates-list-link": "بازگشت به فهرست الگوها",
   "go-back-to-action-plan-section-link": "بازگشت به بخش پلان عملی",
   "go-back-to-assessment-link": "بازگشت به ارزیابی",
   "go-back-to-assessments-link": "بازگشت به ارزیابی‌ها",
   "go-back-to-assigned-modules-list-link": "بازگشت به فهرست ماژول‌های اختصاص‌یافته",
   "go-back-to-approved-modules-list-link": "بازگشت به فهرست ماژول‌های تأییدشده",
   "go-back-to-pending-modules-list-link": "بازگشت به فهرست ماژول‌های در انتظار",
   "go-back-to-guided-assessment-link": "بازگشت به ارزیابی هدایت‌شده",
   "go-back-to-guided-assessment-list-link": "بازگشت به فهرست ارزیابی‌های هدایت‌شده",
   "go-back-to-workspaces-link": "بازگشت به فضاهای کاری",
   "profile-preview-alt-text": "پیش‌نمایش پروفایل",
   "org-role-abbreviation": "سازمان",
   "role-super-admin-label": "مدیر ارشد",
   "role-consultant-label": "مشاور",
   "role-donor-label": "اهداکننده",
   "role-national-organization-label": "سازمان ملی",
   "role-international-organization-label": "سازمان بین‌المللی",
   "male-label": "مرد",
   "female-label": "زن",
   "no-self-assessments-here-text": "هیچ خودارزیابی در اینجا وجود ندارد",
   "no-guided-assessments-here-text": "هیچ ارزیابی هدایت‌شده در اینجا وجود ندارد",
   "self-assessment-panel-title": "خودارزیابی",
   "guided-assessment-panel-title": "ارزیابی هدایت‌شده",
   "sort-progress-by-label": "مرتب‌سازی پیشرفت بر اساس:",
   "highest-to-lowest-option": "از بیشترین به کمترین",
   "lowest-to-highest-option": "از کمترین به بیشترین",
   "modules-count-suffix": "ماژول",
   "answer-pending-status": "در انتظار پاسخ",
   "unlock-assessment-text": "باز کردن قفل ارزیابی",
   "select-assessment-see-results-text": "یک ارزیابی را انتخاب کنید تا نتایج آن را به‌طور مفصل ببینید.",
   "linked-badge-label": "پیوند شده",
   "no-assessments-available-title": "هیچ ارزیابی موجود نیست.",
   "start-adding-view-results-text": "با اضافه کردن یک مورد شروع کنید تا نتایج جمع‌آوری شده را ببینید.",
   "assessment-selected-suffix": "ارزیابی انتخاب شده",
   "action-plan-panel-description-text": "در اینجا یک پلان عملی بر اساس نتایج شما در هر ارزیابی خواهید یافت.",
   "select-one-see-plan-detail-text": "یکی را انتخاب کنید تا پلان را به‌طور مفصل ببینید.",
   "search-for-assessment-placeholder": "جستجوی یک ارزیابی",
   "areas-to-improve-label": "ماژول‌های قابل بهبود:",
   "no-assessments-here-text": "هیچ ارزیابی در اینجا وجود ندارد!",
   "selected-assessment-title": "ارزیابی انتخاب‌شده",
   "no-assessment-selected-text": "هیچ ارزیابی انتخاب نشده است",
   "number-of-resources-label": "تعداد منابع:",
   "areas-in-label": "بخش‌ها:",
   "indicators-to-improve-label": "شاخص‌های قابل بهبود:",
   "no-data-available-to-display-text": "هیچ داده‌ای برای نمایش موجود نیست.",
   "self-evaluate-screen-description-text": "این صفحه به شما امکان می‌دهد بر اساس پرسشنامه‌هایی که تکمیل کرده‌اید خود را ارزیابی کنید",
   "maximum-organizations-warning-text": "حداکثر ۵ سازمان!",
   "search-organization-placeholder": "جستجوی سازمان",
   "sort-order-tooltip-text": "ترتیب",
   "get-results-tooltip-text": "دریافت نتایج",
   "report-word": "گزارش",
   "capacity-gaps-title": "خلاهای ظرفیت",
   "capacity-gaps-description-text": "کدام ماژول‌ها و بخش‌ها قوی و کدام ضعیف هستند، و چگونه در برابر اهداف خود عملکرد دارند.",
   "performance-overview-title": "نمای کلی عملکرد",
   "performance-overview-description-text": "وضعیت گروه در این دور: امتیازات سازمان‌ها، چگونگی توزیع آن‌ها در دسته‌های امتیاز ارزیابی، و مقایسه آن با هدف دور.",
   "progress-across-rounds-title": "پیشرفت در طول دورها",
   "progress-across-rounds-description-text": "جایگاه گروه در این دور در سطح بخش، و چگونگی تغییر هر سازمان از دور قبلی — کدام بهبود یافته، کدام کاهش یافته، و به چه میزان.",
   "action-plan-status-title": "وضعیت پلان عملی",
   "action-plan-status-description-text": "تکمیل وظایف برای هر سازمان در دور انتخاب‌شده، و ارتباط آن با دستیابی به هدف.",
   "score-band-deficient": "ضعیف",
   "score-band-insufficient": "ناکافی",
   "score-band-satisfactory": "قابل قبول",
   "score-band-very-good": "بسیار خوب",
   "score-band-excellent": "عالی",
   "module-rejected-success-description": "ماژول با موفقیت رد شد",
   "failed-reject-module-description": "رد این ماژول ناکام شد",
   "module-accepted-success-description": "ماژول با موفقیت پذیرفته شد",
   "failed-accept-module-description": "پذیرفتن این ماژول ناکام شد",
   "module-requests-title": "درخواست‌های ماژول",
   "pending-modules-review-description-text": "این فهرست ماژول‌هایی است که منتظر بررسی شما هستند. برای ادامه، لطفاً روی هر ماژول کلیک کنید تا بتوانید آن را بپذیرید یا رد کنید.",

   // Login / Registration pages
   "welcome-back-title": "بازگشت شما خوش آمدید!",
   "login-into-account-subtitle": "به حساب خود وارد شوید",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "رمز عبور",
   "toggle-password-visibility-label": "نمایش/پنهان کردن رمز عبور",
   "remember-me-label": "مرا به یاد داشته باش؟",
   "log-in-button": "ورود",
   "no-account-yet-text": "حساب کاربری ندارید؟",
   "sign-up-link": "ثبت‌نام",
   "max-16-symbols-validation": "حداکثر 16 حرف",
   "go-back-icon-alt": "بازگشت",
   "go-back-to-login-link": "بازگشت به صفحه ورود",
   "welcome-to-kaporg-title": "به KAPorg خوش آمدید!",
   "which-profile-title": "کدام مشخصات شما را بهتر توصیف می‌کند؟",
   "profile-organization-label": "سازمان",
   "profile-donors-label": "کمک‌کنندگان",
   "profile-expert-label": "متخصص",
   "signup-role-title": "چگونه از KAPorg استفاده خواهید کرد؟",
   "signup-role-subtitle": "نقشی را انتخاب کنید که با مسئولیت‌های شما بیشتر مطابقت دارد.",
   "profile-donor-label": "تمویل‌کننده",
   "signup-role-organization-description": "ایجاد ظرفیت پایدار سازمانی",
   "signup-role-donor-description": "نظارت بر عملکرد سبد نهادی",
   "signup-role-expert-description": "ارائه رهنمود استراتژیک مستقل",
   "signup-create-account-as-an": "ایجاد حساب به عنوان",
   "signup-create-account-as-a": "ایجاد حساب به عنوان",
   "showcase-login-headline": "ما سازمان‌ها را برای رهبری [[توسعه ظرفیت]] توانمند می‌سازیم",
   "showcase-organization-headline": "توانایی‌های خود را ارزیابی کنید و [[مأموریت خود را تقویت کنید]]",
   "showcase-donor-headline": "بر عملکرد سبد نظارت کنید و [[نتایج قابل اندازه‌گیری به دست آورید]]",
   "showcase-expert-headline": "رهنمود استراتژیک ارائه دهید و [[ظرفیت نهادی را ارتقا دهید]]",
   "signup-step-profile": "پروفایل",
   "signup-step-expertise": "تخصص",
   "profile-details-title": "جزئیات پروفایل",
   "upload-photo-text": "بارگذاری عکس",
   "adjust-your-photo-title": "عکس خود را تنظیم کنید",
   "change-photo-text": "تغییر عکس",
   "signup-step-account": "حساب",
   "signup-step-contact": "تماس",
   "enter-organization-email-placeholder": "ایمیل سازمان را وارد کنید",
   "code-must-have-6-digits-validation": "کد باید ۶ رقم باشد",
   "code-incorrect-text": "کد نادرست است",
   "confirmation-email-shortly-text": "به‌زودی یک ایمیل تأیید دریافت خواهید کرد",
   "go-to-homepage-button": "رفتن به صفحه اصلی",
   "didnt-get-email-text": "ایمیل را دریافت نکردید؟ پوشه هرزنامه را بررسی کنید یا به این آدرس بنویسید:",
   "language-selector-label": "انتخاب زبان",
   "auth-tagline-transforming-title": "دگرگون‌سازی ظرفیت‌سازی",
   "auth-tagline-transforming-description": "برای عصر دیجیتال",
   "auth-tagline-elevate-title": "سازمان خود را ارتقا دهید",
   "auth-tagline-elevate-description": "با ارزیابی هدفمند!",
   "auth-tagline-changemakers-title": "با تغییرآفرینانی ارتباط برقرار کنید",
   "auth-tagline-changemakers-description": "که بیشتر به شما نیاز دارند.",
   "auth-tagline-miss-you-title": "دلتنگ شما خواهیم شد،",
   "auth-tagline-miss-you-description": "امیدواریم به‌زودی بازگردید.",
   "auth-tagline-collaborations-title": "وارد دنیایی از",
   "auth-tagline-collaborations-description": "همکاری‌های تأثیرگذار شوید!",
   "auth-tagline-expertise-title": "تخصص شما",
   "auth-tagline-expertise-description": "و بینش‌های شما پیشرفت را تقویت می‌کند!",

   // National organization registration form
   "go-back-to-profile-selection-link": "بازگشت به انتخاب مشخصات",
   "create-account-title": "ایجاد حساب کاربری",
   "as-an-org-label": "به عنوان سازمان",
   "login-details-title": "مشخصات ورود",
   "confirm-password-label": "تأیید رمز عبور",
   "type-description-placeholder": "توضیحات را بنویسید",
   "working-sectors-label": "بخش‌های فعالیت",
   "enter-organization-name-placeholder": "نام سازمان را وارد کنید",
   "enter-organization-address-placeholder": "آدرس سازمان را وارد کنید",
   "enter-organization-zip-code-placeholder": "کد پستی سازمان را وارد کنید",
   "terms-agreement-prefix-text": "من مطالعه کردم و موافقت می‌کنم با",
   "terms-of-service-privacy-policy-link": "شرایط خدمات، خط‌مشی حریم خصوصی",
   "and-conjunction-text": "و",
   "cookie-policy-link": "خط‌مشی کوکی‌ها.",
   "invalid-email-address-validation": "ایمیل نامعتبر است",
   "password-min-length-validation": "رمز عبور باید حداقل ۸ حرف داشته باشد",
   "password-complexity-validation": "رمز عبور باید حداقل یک حرف بزرگ، یک عدد و یکی از نمادهای مشخص‌شده !، @، #، $، %، ^، &، * را داشته باشد",
   "password-required-validation": "رمز عبور الزامی است",
   "passwords-must-match-validation": "رمزهای عبور باید یکسان باشند",
   "confirm-password-required-validation": "تأیید رمز عبور الزامی است",
   "organization-name-required-validation": "نام سازمان بین‌المللی الزامی است",
   "foundation-year-required-validation": "سال تأسیس الزامی است",
   "sectors-min-validation": "حداقل یک بخش باید انتخاب شود",
   "sectors-required-validation": "بخش‌ها الزامی است",
   "organization-address-required-validation": "آدرس سازمان الزامی است",
   "invalid-organization-email-validation": "ایمیل سازمان نامعتبر است",
   "organization-email-required-validation": "ایمیل سازمان الزامی است",
   "accept-terms-required-validation": "باید شرایط و ضوابط را بپذیرید",

   // Donor registration form
   "as-an-international-donor-label": "به عنوان کمک‌کننده بین‌المللی",
   "donor-organization-name-required-validation": "نام سازمان الزامی است",
   "invitation-code-label": "کد دعوت",
   "enter-invitation-code-placeholder": "کد دعوت خود را وارد کنید",
   "invitation-code-min-length-validation": "کد دعوت باید حداقل ۱۲ حرف داشته باشد",
   "invitation-code-required-validation": "کد دعوت الزامی است",
   "invalid-invitation-code-format-validation": "فورمت کد دعوت نامعتبر است",
   "no-invitation-code-help-text": "اگر کد دعوت ندارید، لطفاً به این ایمیل برای ما پیام بفرستید:",

   // Terms/Conditions modal
   "close-icon-alt": "بستن",
   "terms-of-service-tab-label": "شرایط خدمات",
   "privacy-policy-tab-label": "خط‌مشی حریم خصوصی",
   "cookie-policy-tab-label": "خط‌مشی کوکی‌ها",
   "got-it-button": "متوجه شدم!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "حساب با موفقیت ایجاد شد.",
   "unexpected-error-description": "یک خطای غیرمنتظره رخ داد. لطفاً دوباره تلاش کنید.",
   "verification-code-sent-description": "یک کد تأیید به ایمیل شما ارسال شد.",
   "expert-user-created-success-description": "کاربر متخصص با موفقیت ایجاد شد",

   // Expert registration step one
   "as-an-expert-label": "به عنوان متخصص",

   // Expert registration step three
   "lets-start-profile-info-title": "بیایید با معلومات پروفایل شما آغاز کنیم",
   "enter-full-name-placeholder": "نام کامل خود را وارد کنید",
   "personal-statement-label": "بیانیه شخصی/انگیزه",
   "enter-personal-statement-placeholder": "بیانیه شخصی خود را وارد کنید",
   "select-nationality-placeholder": "ملیت خود را انتخاب کنید",
   "select-country-of-residence-placeholder": "کشور اقامت خود را انتخاب کنید",
   "operating-countries-label": "کشورهای فعالیت",
   "enter-linkedin-profile-placeholder": "پروفایل لینکدین خود را وارد کنید",
   "full-name-required-validation": "نام کامل الزامی است",
   "nationality-required-validation": "ملیت الزامی است",
   "country-of-residence-required-validation": "کشور اقامت الزامی است",

   // Expert registration step four
   "now-your-professional-details-title": "اکنون جزئیات حرفه‌ای شما",
   "profile-picture-label": "عکس پروفایل",
   "education-section-title": "تحصیلات",
   "select-highest-degree-placeholder": "بالاترین مدرک تحصیلی خود را انتخاب کنید",
   "enter-fields-of-study-placeholder": "رشته‌های تحصیلی را وارد کنید",
   "enter-educational-institution-placeholder": "مؤسسه تحصیلی خود را وارد کنید",
   "area-label": "ساحه",
   "enter-area-placeholder": "ساحه را وارد کنید",
   "add-another-area-button": "افزودن ساحه دیگر",
   "level-label": "سطح",
   "select-level-placeholder": "سطح را انتخاب کنید",
   "add-another-language-button": "افزودن زبان دیگر",
   "upload-cv-label": "رزیومه خود را بارگذاری کنید",
   "upload-certificate-label": "یک گواهینامه یا آموزش خاص را بارگذاری کنید",
   "remove-button": "حذف",
   "image-file-type-badge": "JPG یا PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "بالاترین مدرک تحصیلی الزامی است",
   "area-required-validation": "ساحه الزامی است",
   "years-of-experience-required-validation": "سال‌های تجربه الزامی است",
   "years-of-experience-number-validation": "سال‌های تجربه باید یک عدد باشد",
   "profile-picture-required-validation": "عکس پروفایل الزامی است",
   "invalid-image-file-type-validation": "نوع فایل نامعتبر است. فقط PNG یا JPEG مجاز است.",
   "file-size-too-large-validation": "حجم فایل خیلی زیاد است. حداکثر حجم ۲۰ مگابایت است.",
   "invalid-pdf-file-type-validation": "نوع فایل نامعتبر است. فقط PDF مجاز است.",
   "level-required-validation": "سطح الزامی است",
   "level-number-validation": "سطح باید یک عدد باشد",
   "go-back-to-profile-details-link": "بازگشت به جزئیات پروفایل",
   "uploaded-file-icon-alt": "فایل",
   "add-icon-alt": "افزودن",

   // Confirm-code page
   "verification-code-title": "کد تأیید",
   "verification-code-sent-to-text": "لطفاً کد تأییدی را که به این آدرس فرستادیم وارد کنید",
   "verify-code-button": "تأیید کد",
   "didnt-receive-code-text": "اگر کد تأیید را دریافت نکردید،",
   "resend-code-link": "برای ارسال دوباره اینجا کلیک کنید",
   "or-send-email-at-text": "یا برای ما به این ایمیل پیام بفرستید",
   "verification-code-required-validation": "کد تأیید الزامی است",
   "code-verified-success-description": "کد با موفقیت تأیید شد",

   // Account on review page
   "account-on-review-icon-alt": "حساب در حال بررسی",
   "got-your-application-title": "درخواست شما دریافت شد!",
   "application-review-description-text": "به محض تأیید درخواست شما توسط یک مسئول، یک ایمیل تأییدی دریافت خواهید کرد.",
   "in-the-meantime-prefix-text": "در این ضمن، سر بزنید به",
   "in-the-meantime-suffix-text": "برای معلومات بیشتر.",
   "thank-you-for-interest-text": "از علاقه شما به KAPorg سپاسگزاریم!",

   // Resources library
   "resources-library-tab-label": "کتابخانه منابع",
   "resource-type-all-label": "تمام منابع",
   "resource-type-documents-label": "اسناد",
   "resource-type-videos-label": "ویدیوها",
   "resource-type-links-label": "لینک‌ها",
   "resource-type-presentations-label": "ارائه‌ها",
   "no-resources-available-text": "هیچ منبعی موجود نیست",
   "no-collections-available-text": "هیچ مجموعه‌ای موجود نیست",
   "which-resource-looking-for-label": "به دنبال چه چیزی هستید؟",
   "search-ellipsis-placeholder": "جستجو...",
   "assessments-placeholder": "ارزیابی‌ها",
   "modules-label": "ماژول‌ها",
   "section-label": "بخش",
   "sections-placeholder": "بخش‌ها",
   "resource-icon-alt": "منابع",
   "copy-link-action": "کاپی کردن لینک",
   "edit-resource-icon-alt": "ویرایش منبع",
   "rate-this-resource-action": "امتیازدهی به این منبع",
   "delete-resource-icon-alt": "حذف منبع",
   "more-suffix-text": "بیشتر",
   "rate-this-resource-title": "امتیازدهی به این منبع",
   "resource-word": "منبع",
   "your-rating-label": "امتیاز شما:",
   "save-rating-button": "ذخیره امتیاز",
   "all-tab-label": "همه",
   "my-collections-label": "مجموعه‌ها",
   "my-collection-toggle-label": "مجموعه من",
   "all-collections-label": "مجموعه‌ها",
   "edit-collection-icon-alt": "ویرایش مجموعه",
   "delete-collection-icon-alt": "حذف مجموعه",
   "preview-colon-label": "پیش‌نمایش:",
   "resources-word": "منابع",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "خلاصه حساب",
   "account-summary-label": "خلاصه حساب",
   "account-summary-upgrade-message":
      "شما به حد بسته خود نزدیک می‌شوید. آن را ارتقا دهید تا فضای بیشتر داشته باشید و بدون محدودیت ایجاد کنید.",
   "upgrade-package-button": "ارتقای بسته",
   "modules-available-label": "ماژول‌های موجود",
   "modules-created-label": "ماژول‌های ایجاد شده",
   "assessments-available-label": "ارزیابی‌های موجود",
   "assessments-created-label": "ارزیابی‌های ایجاد شده",
   "workspaces-available-label": "فضاهای کاری موجود",
   "workspaces-created-label": "فضاهای کاری ایجاد شده",
   "including-humanitarian-experts-created-label": "شامل متخصصین بشردوستانه ایجاد شده",
   "amount-of-storage-label": "میزان ذخیره‌سازی",
   "data-usage-label": "استفاده از داده",
   "usage-statistics-label": "آمار استفاده",
   "available-label": "موجود",
   "used-label": "استفاده شده",
   "profile-info-icon-alt": "معلومات نمایه",
   "profile-information-label": "معلومات نمایه",
   "login-info-icon-alt": "معلومات ورود",
   "login-information-label": "معلومات ورود",
   "payment-info-icon-alt": "معلومات پرداخت",
   "payment-information-label": "معلومات پرداخت",
   "log-out-icon-alt": "خروج از حساب",
   "log-out-button": "خروج از حساب",
   "account-menu-toggle-alt": "منوی حساب",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "منو",
   "logo-alt-text": "لوگو",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "علامت‌گذاری همه به عنوان خوانده‌شده",
   "unread-tab-label": "نخوانده",
   "no-notifications-title-text": "هیچ اطلاعیه‌ای در اینجا نیست!",
   "up-to-date-description-text": "همه چیز به‌روز است!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "این شرایط خدمات آخرین بار به تاریخ ۴ مارچ ۲۰۲۴ به‌روزرسانی شده است.",
   "terms-intro-websites-prefix-text": "این شرایط خدمات، استفاده شما از وبسایت‌های ما که در آدرس‌های ذیل قرار دارند را تنظیم می‌کند",
   "terms-intro-websites-suffix-text": "، و همچنان هرگونه خدمات مرتبط ارائه شده توسط International Advisory, Products and Systems Ltd را نیز شامل می‌شود. با دسترسی به وبسایت‌های ما، شما موافقت می‌کنید که این شرایط خدمات را رعایت نموده و از تمامی قوانین و مقررات قابل‌تطبیق پیروی کنید. در صورتی که با این شرایط خدمات موافق نباشید، استفاده یا دسترسی به آن وبسایت‌ها یا استفاده از هرگونه خدمات دیگر ارائه شده توسط International Advisory, Products and Systems Ltd برای شما ممنوع است. ما، International Advisory, Products and Systems Ltd، حق بازنگری و اصلاح هر بخشی از این شرایط خدمات را به صلاحدید انحصاری خویش محفوظ می‌داریم. پس از انجام چنین کاری، ما این صفحه را به‌روزرسانی خواهیم کرد. هرگونه تغییر در این شرایط خدمات بلافاصله از تاریخ نشر آن نافذ خواهد بود.",
   "overview-of-services-title": "مرور کلی خدمات",
   "overview-of-services-description-text": "International Advisory, Products and Systems Ltd. (i-APS)، همراه با نهادهای وابسته به آن، شامل اما نه محدود به KAPsurvey، KAPorg، KAPinsights و KAPcourse (که من‌بعد به صورت مجموعی «KAPtech Group» نامیده می‌شوند)، خدمات مشورتی تخنیکی، راه‌حل‌های تکنالوژیکی نوآورانه و ابزارهای جامع جمع‌آوری و تحلیل معلومات را ارائه می‌دهد. خدمات KAPtech Group به هدف حمایت از اجرا و مدیریت پروژه‌های تخصصی و انکشافی طراحی شده‌اند. این خدمات از تکنالوژی پیشرفته استفاده نموده و از تجارب گسترده محلی بهره می‌برند تا سازمان‌ها و جوامع همکار را در پاسخگویی مؤثر و غلبه بر چالش‌ها در بخش‌های کمک‌های تخصصی و انکشافی یاری رسانند. با استفاده از خدمات ارائه شده توسط KAPtech Group، از جمله دسترسی به وبسایت‌های ما، شما موافقت می‌کنید که با شرایط و ضوابط مندرج در این موافقتنامه مطابقت نموده و به آن پابند باشید. خدمات ارائه شده تابع شرایط ذکر شده در اینجا، همراه با هرگونه رهنمودها یا مقررات اضافی قابل‌تطبیق بر خدمات یا ویژگی‌های خاص خدمات، می‌باشند.",
   "limitations-of-use-title": "محدودیت‌های استفاده",
   "limitations-of-use-intro-text": "با استفاده از وبسایت‌های ما، شما از جانب خود، کاربران‌تان، و سایر طرف‌هایی که نمایندگی می‌کنید، تضمین می‌کنید که موارد ذیل را انجام نخواهید داد:",
   "limitation-modify-content-text": "اصلاح، کاپی، تهیه آثار مشتق‌شده، دیکمپایل، یا مهندسی معکوس هرگونه مواد و نرم‌افزار موجود در آن وبسایت‌ها؛",
   "limitation-remove-notices-text": "حذف هرگونه نشان حق چاپ یا سایر نشان‌های مالکیتی از هرگونه مواد و نرم‌افزار موجود در آن وبسایت‌ها؛",
   "limitation-transfer-materials-text": "انتقال مواد به شخص دیگر یا «آینه‌سازی» مواد بر روی هر سرور دیگر؛",
   "limitation-abuse-networks-text": "استفاده آگاهانه یا ناشی از سهل‌انگاری از آن وبسایت‌ها یا هرگونه خدمات مرتبط به آن‌ها به شیوه‌ای که شبکه‌های ما یا هرگونه خدمات دیگر ارائه شده توسط International Advisory, Products and Systems Ltd را مورد سوءاستفاده قرار داده یا مختل سازد؛",
   "limitation-unlawful-material-text": "استفاده از آن وبسایت‌ها یا خدمات مرتبط به آن‌ها جهت انتقال یا نشر هرگونه مطالب مزاحمت‌آمیز، ناشایست، مستهجن، متقلبانه، یا غیرقانونی؛",
   "limitation-violate-laws-text": "استفاده از آن وبسایت‌ها یا خدمات مرتبط به آن‌ها مغایر با هرگونه قوانین یا مقررات قابل‌تطبیق؛",
   "limitation-spam-text": "استفاده از آن وبسایت‌ها در ارتباط با ارسال تبلیغات غیرمجاز یا اسپم؛",
   "limitation-harvest-data-text": "برداشت، جمع‌آوری، یا گردآوری معلومات کاربران بدون رضایت کاربر؛ یا",
   "limitation-infringe-rights-text": "استفاده از آن وبسایت‌ها یا خدمات مرتبط به آن‌ها به شیوه‌ای که ممکن است حریم خصوصی، حقوق مالکیت معنوی، یا سایر حقوق اشخاص ثالث را نقض نماید",
   "intellectual-property-title": "مالکیت معنوی",
   "intellectual-property-description-text": "مالکیت معنوی مواد موجود در آن وبسایت‌ها متعلق به International Advisory, Products and Systems Ltd بوده یا به آن جواز داده شده است و تحت حمایت قوانین قابل‌تطبیق حق چاپ و علامت تجارتی قرار دارد. ما به کاربران خویش اجازه می‌دهیم تا یک نسخه از مواد را جهت استفاده شخصی، غیرتجارتی و موقت دانلود نمایند. این امر به معنای اعطای یک جواز است، نه انتقال مالکیت. این جواز در صورت نقض هر یک از این محدودیت‌ها یا شرایط خدمات، به صورت خودکار فسخ می‌گردد و می‌تواند در هر زمانی توسط International Advisory, Products and Systems Ltd فسخ گردد.",
   "user-generated-content-title": "محتوای تولید شده توسط کاربر",
   "terms-user-generated-content-description-text": "شما حقوق مالکیت معنوی خویش را بر محتوایی که جهت نشر در وبسایت‌های ما به ما ارسال می‌کنید، حفظ می‌نمایید. ما هرگز مدعی مالکیت محتوای شما نخواهیم شد، اما جهت استفاده از آن به یک جواز از جانب شما نیاز داریم. هنگامی که از وبسایت‌های ما یا خدمات مرتبط به آن‌ها جهت پست، آپلود، به‌اشتراک‌گذاری، یا انتقال محتوای تحت حمایت حقوق مالکیت معنوی استفاده می‌کنید، شما به ما یک جواز غیرانحصاری، بدون حق امتیاز، قابل‌انتقال، قابل‌واگذاری به اشخاص ثالث و جهانی جهت استفاده، توزیع، اصلاح، اجرا، کاپی، نمایش عمومی، ترجمه، یا ایجاد آثار مشتق‌شده از محتوای شما به شیوه‌ای که مطابق با ترجیحات حریم خصوصی شما و پالیسی محرمیت ما باشد، اعطا می‌کنید. جوازی که شما به ما اعطا می‌کنید، می‌تواند در هر زمانی با حذف محتوا یا حساب کاربری‌تان فسخ گردد. با این حال، تا آنجایی که ما (یا شرکای ما) از محتوای شما در ارتباط با محتوای تجارتی یا حمایت‌شده استفاده کرده باشیم، جواز مذکور تا زمانی که تبلیغ یا پست مربوطه توسط ما متوقف گردد، ادامه خواهد داشت. شما به ما اجازه می‌دهید تا از نام کاربری و سایر معلومات شناسایی‌کننده مرتبط با حساب کاربری‌تان به شیوه‌ای که مطابق با ترجیحات حریم خصوصی شما و پالیسی محرمیت ما باشد، استفاده نماییم.",
   "registration-and-payments-title": "ثبت‌نام و پرداخت‌ها",
   "registration-and-payments-description-text": "جهت استفاده از هر یک از خدمات ما، شما نیاز دارید تا یک حساب کاربری ایجاد نمایید. هرگونه معلومات ارائه شده باید دقیق بوده و در صورت لزوم به‌روزرسانی گردد. مشتریان مسئول نگهداری حساب‌های کاربری خویش بوده و به صورت کامل مسئول تمامی فعالیت‌هایی می‌باشند که تحت حساب‌های‌شان صورت می‌گیرد. در صورتی که کسی به حساب کاربری شما دسترسی غیرمجاز پیدا نماید، شما باید بلافاصله به ما اطلاع دهید. International Advisory, Products and Systems Ltd مسئول هرگونه ضرر یا خساره ناشی از عدم حفظ محرمیت حساب کاربری شما نمی‌باشد. هنگام ایجاد حساب کاربری، شما ملزم به ارائه معلومات مالی مرتبط با شیوه پرداخت انتخابی خویش می‌باشید. در برخی موارد، ممکن است از شما خواسته شود تا جزئیات کارت اعتباری خویش را ارائه نمایید. لطفاً توجه داشته باشید که هرگونه پرداخت صورت گرفته در پلتفورم ما توسط PayPal، Stripe، Square، Google Payments، یا Apple Pay پردازش خواهد شد. به همین دلیل، ما مسئول پردازش یا نگهداری هیچ‌یک از معلومات مالی شما نخواهیم بود. PayPal، Stripe، Square، Google Payments، یا Apple Pay تمامی معلومات مالی شما را مطابق با شرایط خدمات مربوطه خویش مدیریت خواهند نمود، و شما موافقت می‌کنید که از چنین شرایط خدماتی پیروی نمایید.",
   "disclaimer-and-limitations-title": "سلب مسئولیت و محدودیت‌های مسئولیت",
   "disclaimer-websites-prefix-text": "وبسایت‌ها و مواد ارائه شده توسط International Advisory, Products and Systems Ltd.، شامل اما نه محدود به",
   "disclaimer-as-is-description-text": "، به کاربران به اساس «همان‌گونه که است» در دسترس قرار داده می‌شوند. International Advisory, Products and Systems Ltd تمامی ضمانت‌ها، اعم از صریح یا ضمنی، را تا حدی که قانون اجازه می‌دهد، رد می‌نماید. این شامل، اما نه محدود به، ضمانت‌های قابلیت فروش، مناسبت برای یک هدف خاص، یا عدم نقض حقوق مالکیت معنوی می‌باشد. علاوه بر آن، هیچ‌گونه مشوره یا معلوماتی، خواه شفاهی یا کتبی، که شما از International Advisory, Products and Systems Ltd یا از طریق خدمات به‌دست می‌آورید، هیچ‌گونه ضمانتی را که به صورت صریح در این شرایط ذکر نشده باشد، ایجاد نخواهد کرد. International Advisory, Products and Systems Ltd و تهیه‌کنندگان آن مسئول هیچ‌گونه خسارات مستقیم، غیرمستقیم، تصادفی، خاص، تبعی، یا تنبیهی نمی‌باشند، شامل اما نه محدود به خسارات ناشی از فقدان منفعت، شهرت تجارتی، استفاده، معلومات، یا سایر ضررهای غیرملموس (حتی اگر International Advisory, Products and Systems Ltd از احتمال وقوع چنین خساراتی مطلع شده باشد)، که ناشی از استفاده یا عدم توانایی استفاده از خدمات یا هرگونه موضوع دیگر مرتبط با خدمات باشد. این محدودیت مسئولیت، صرف‌نظر از اینکه ادعای مسئولیت مبتنی بر قرارداد، ضرر و زیان مدنی، سهل‌انگاری، مسئولیت مطلق، یا هر مبنای دیگری باشد، اعمال می‌گردد، حتی اگر International Advisory, Products and Systems Ltd از احتمال وقوع چنین خسارتی مطلع شده باشد. با در نظرداشت ماهیت خدمات ارائه شده توسط International Advisory, Products and Systems Ltd، به ویژه در چارچوب بخش‌های تخصصی و انکشافی، کاربران خطرات ذاتی مرتبط با جمع‌آوری معلومات و استفاده از راه‌حل‌های مبتنی بر تکنالوژی را می‌پذیرند. کاربران به تنهایی مسئول اطمینان از رعایت تمامی قوانین و مقررات قابل‌تطبیق، شامل اما نه محدود به قوانین محافظت از معلومات و حریم خصوصی، می‌باشند. مسئولیت کسب رضایت‌ها و اجازه‌های لازم جهت جمع‌آوری معلومات، به ویژه در مواردی که مربوط به اطفال یا معلومات حساس باشد، بر عهده کاربر می‌باشد. مسئولیت International Advisory, Products and Systems Ltd و شرکت‌های وابسته، مدیران، مسئولان، کارمندان، نمایندگان، تهیه‌کنندگان، و جوازدهندگان آن تا حداکثر حدی که قانون اجازه می‌دهد، محدود می‌باشد. در صورتی که شما از هر بخشی از خدمات یا از هر یک از این شرایط ناراضی باشید، تنها و منحصربه‌فرد راه‌حل شما، توقف استفاده از خدمات می‌باشد. برخی حوزه‌های قضایی اجازه استثنای برخی ضمانت‌ها یا محدودیت یا استثنای مسئولیت برای خسارات تصادفی یا تبعی را نمی‌دهند، بنابراین برخی از محدودیت‌های فوق ممکن است در مورد شما قابل‌تطبیق نباشد.",
   "accuracy-of-materials-title": "دقت مواد",
   "accuracy-of-materials-description-text": "مواد ظاهر شده در وبسایت‌های ما جامع نبوده و صرفاً جهت اهداف معلوماتی عمومی می‌باشند. International Advisory, Products and Systems Ltd هیچ‌گونه ضمانت یا اظهاریه‌ای در مورد دقت، نتایج احتمالی، یا قابلیت اعتماد استفاده از مواد موجود در آن وبسایت‌ها، یا به هر نحو دیگری مرتبط با چنین موادی یا هرگونه منابع لینک‌شده به آن وبسایت‌ها، نمی‌نماید. شما نباید صرفاً به مواد یادشده جهت اتخاذ تصمیمات اتکا نمایید، ما به شما توصیه می‌کنیم که با منابع دیگر و جامع‌تر معلومات مشوره نمایید. شما به تنهایی مسئول اتکای دقیق به مواد نشر شده در وبسایت‌های ما می‌باشید. ما حق داریم معلومات موجود در وبسایت‌های خویش را بدون اطلاع قبلی تغییر دهیم و کاربران مسئول نظارت بر تغییرات یادشده می‌باشند.",
   "additional-tools-title": "ابزارهای اضافی",
   "additional-tools-description-text": "لطفاً توجه داشته باشید که وبسایت‌های ما ممکن است شامل ابزارهای اشخاص ثالث باشند که خارج از کنترول ما قرار دارند. دسترسی به ابزارهای یادشده به اساس «همان‌گونه که است» و بدون هیچ‌گونه ضمانت، اعم از صریح یا ضمنی، و بدون هرگونه تأیید ارائه می‌گردد. ما مسئول استفاده از ابزارهای اشخاص ثالث ارائه شده در وبسایت‌های خویش نمی‌باشیم. شما به تنهایی مسئول هرگونه خطر مرتبط با استفاده از ابزارهای یادشده می‌باشید، ما توصیه می‌کنیم که شرایط خدمات تهیه‌کننده مربوطه شخص ثالث را مطالعه نمایید. International Advisory, Products and Systems Ltd حق دارد در آینده ابزارهای جدید اشخاص ثالث را ارائه نماید",
   "links-title": "لینک‌ها",
   "links-description-text": "International Advisory, Products and Systems Ltd تمامی سایت‌های لینک‌شده به وبسایت‌های خویش را بررسی ننموده و مسئول محتوای هیچ‌یک از چنین سایت‌های لینک‌شده نمی‌باشد. درج هرگونه لینک به معنای تأیید، پذیرش، یا کنترول آن سایت توسط International Advisory, Products and Systems Ltd نمی‌باشد. استفاده از هرگونه سایت لینک‌شده به مسئولیت خودتان صورت می‌گیرد، و ما شدیداً توصیه می‌کنیم که تحقیقات خودتان را در رابطه به مناسبت آن سایت‌ها انجام دهید.",
   "inaccuracies-and-mistakes-title": "عدم دقت و اشتباهات",
   "inaccuracies-and-mistakes-description-text": "لطفاً توجه داشته باشید که هرگونه محتوای موجود در وبسایت‌های ما ممکن است حاوی اشتباهات تایپی، عدم دقت، یا اشتباهاتی مرتبط با توضیحات خدمات، قیمت‌گذاری، تبلیغات، و موجودیت باشد. ما حق داریم هرگونه خدمات موجود را در صورتی که هرگونه معلومات ارائه شده توسط ما نادرست ثابت گردد، لغو یا به‌روزرسانی نماییم. معلومات یادشده می‌تواند در هر زمانی بدون اطلاع قبلی اصلاح گردد. لطفاً توجه داشته باشید که ما مکلف نیستیم هیچ‌یک از معلومات مرتبط با وبسایت‌ها و خدمات خویش، شامل معلومات قیمت‌گذاری، را روشن سازیم، مگر آنکه قانون چنین امری را ایجاب نماید.",
   "indemnification-title": "جبران خساره",
   "indemnification-description-text": "شما موافقت می‌کنید که از ما، شامل شرکت‌های فرعی، وابسته، و تمامی مسئولان، نمایندگان، شرکا، و کارمندان مربوطه ما، دفاع نموده، آن‌ها را جبران خساره نموده و از هرگونه ضرر، خساره، مسئولیت، ادعا، یا مطالبه، شامل حق‌الوکاله معقول و مصارف مربوطه، که توسط هر شخص ثالث ناشی از یا به سبب موارد ذیل مطرح گردد، مصئون نگهدارید: (۱) مشارکت‌های شما؛ (۲) استفاده از وبسایت‌ها؛ (۳) نقض این شرایط خدمات؛ (۴) هرگونه نقض اظهاریه‌ها و ضمانت‌های شما مندرج در این شرایط خدمات؛ (۵) نقض حقوق شخص ثالث توسط شما، شامل اما نه محدود به حقوق مالکیت معنوی؛ یا (۶) هرگونه عمل آشکار زیان‌بار در برابر هر کاربر دیگر وبسایت‌ها که شما از طریق وبسایت‌ها با وی ارتباط برقرار نموده‌اید.",
   "indemnification-defense-text": "با وجود موارد فوق، ما حق داریم، به مصرف شما، دفاع انحصاری و کنترول هر موضوعی را که شما ملزم به جبران خساره ما در قبال آن هستید، به عهده بگیریم، و شما موافقت می‌کنید که، به مصرف خودتان، با دفاع ما در برابر چنین ادعاهایی همکاری نمایید. ما تلاش‌های معقولی را جهت اطلاع‌رسانی به شما در مورد هرگونه چنین ادعا، اقدام، یا دعوی حقوقی که مشمول این جبران خساره می‌باشد، به محض آگاهی از آن، به عمل خواهیم آورد.",
   "right-to-terminate-title": "حق فسخ",
   "right-to-terminate-description-text": "ما می‌توانیم حق استفاده شما از وبسایت‌های خویش را معلق یا فسخ نموده و این شرایط خدمات را بلافاصله پس از اطلاعیه کتبی به شما، در صورت نقض این شرایط خدمات، فسخ نماییم.",
   "severance-title": "تفکیک‌پذیری",
   "severance-description-text": "هرگونه شرط از این شرایط خدمات که به صورت کامل یا جزئی باطل یا غیرقابل‌اجرا باشد، تا حدی که باطل یا غیرقابل‌اجرا است، تفکیک می‌گردد. اعتبار سایر بخش‌های این شرایط خدمات تحت تأثیر قرار نمی‌گیرد.",
   "entire-agreement-title": "موافقتنامه کامل",
   "entire-agreement-description-text": "این شرایط خدمات و هرگونه پالیسی یا مقررات عملیاتی نشر شده توسط ما در وبسایت‌ها یا در رابطه به وبسایت‌ها، موافقتنامه و تفاهم کامل میان شما و ما را تشکیل می‌دهد. عدم اعمال یا اجرای هر حق یا حکمی از این شرایط خدمات توسط ما، به معنای انصراف از آن حق یا حکم نمی‌باشد. این شرایط خدمات تا حداکثر حدی که قانون اجازه می‌دهد، نافذ می‌باشد. ما می‌توانیم هر یک یا تمامی حقوق و تعهدات خویش را در هر زمانی به دیگران واگذار نماییم. ما مسئول یا متعهد به هیچ‌گونه ضرر، خساره، تأخیر، یا عدم اقدامی که ناشی از هر علتی خارج از کنترول معقول ما باشد، نمی‌باشیم. در صورتی که هر حکم یا بخشی از یک حکم از این شرایط خدمات، غیرقانونی، باطل، یا غیرقابل‌اجرا تشخیص داده شود، آن حکم یا بخش آن حکم از این شرایط خدمات قابل‌تفکیک تلقی گردیده و تأثیری بر اعتبار و قابلیت اجرای سایر احکام باقی‌مانده ندارد. هیچ‌گونه رابطه سرمایه‌گذاری مشترک، شراکت، استخدام، یا نمایندگی میان شما و ما در نتیجه این شرایط خدمات یا استفاده از وبسایت‌ها ایجاد نمی‌گردد. شما موافقت می‌کنید که این شرایط خدمات به دلیل تهیه آن توسط ما، علیه ما تفسیر نخواهد شد. شما بدینوسیله از هرگونه و تمامی دفاعیاتی که ممکن است بر اساس شکل الکترونیکی این شرایط خدمات و عدم امضای طرفین جهت اجرای این شرایط خدمات داشته باشید، صرف نظر می‌نمایید.",
   "governing-law-title": "قانون حاکم",
   "governing-law-description-text": "این شرایط خدمات تابع قوانین Virginia بوده و مطابق با آن تفسیر می‌گردد. شما به صورت غیرقابل‌فسخ به صلاحیت انحصاری محاکم آن ایالت یا موقعیت تن در می‌دهید.",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "این شرایط خدمات آخرین بار به تاریخ ۴ مارچ ۲۰۲۴ به‌روزرسانی شده است.",
   "cookie-intro-websites-prefix-text": "ما از کوکی‌ها استفاده می‌کنیم تا به بهبود تجربهٔ شما از ویب‌سایت‌های ما کمک کنیم، در",
   "cookie-intro-websites-suffix-text": ". این پالیسی کوکی بخشی از پالیسی محرمیت International Advisory, Products and Systems Ltd می‌باشد. این پالیسی، استفاده از کوکی‌ها میان دستگاه شما و سایت‌های ما را تحت پوشش قرار می‌دهد.",
   "cookie-third-party-services-notice-text": "همچنان، ما معلومات اساسی در مورد خدمات اشخاص ثالث که ممکن است از آن‌ها استفاده کنیم، ارائه می‌دهیم؛ این اشخاص نیز ممکن است به عنوان بخشی از خدمات شان از کوکی‌ها استفاده کنند. این پالیسی، کوکی‌های آن‌ها را تحت پوشش قرار نمی‌دهد.",
   "cookie-refuse-prefix-text": "اگر نمی‌خواهید کوکی‌های ما را بپذیرید، باید به براوزر خود دستور دهید تا کوکی‌ها را رد کند، از",
   "cookie-refuse-suffix-text": ". در چنین حالتی، ممکن است نتوانیم بخشی از محتوا و خدمات مورد نظر شما را ارائه کنیم.",
   "what-is-a-cookie-title": "کوکی چیست؟",
   "cookie-definition-text": "کوکی یک قطعه کوچک از معلومات است که یک ویب‌سایت هنگام بازدید شما، آن را روی دستگاه شما ذخیره می‌کند. این معلومات معمولاً شامل اطلاعاتی در مورد خود ویب‌سایت، یک شناسه یکتا که به سایت امکان می‌دهد براوزر شما را هنگام بازگشت دوباره بشناسد، معلومات اضافی که هدف کوکی را برآورده می‌سازد، و مدت زمان اعتبار خود کوکی می‌باشد.",
   "cookie-usage-examples-text": "کوکی‌ها برای فعال‌سازی برخی ویژگی‌ها (مانند ورود به سیستم)، ردیابی میزان استفاده از سایت (مانند تحلیل‌ها)، ذخیره تنظیمات کاربری شما (مانند ساعت زمانی، ترجیحات اطلاعیه‌ها)، و شخصی‌سازی محتوای شما (مانند تبلیغات، زبان) استفاده می‌شوند.",
   "first-party-cookies-definition-text": "کوکی‌هایی که توسط ویب‌سایتی که از آن بازدید می‌کنید تنظیم می‌شوند، معمولاً کوکی‌های طرف اول نامیده می‌شوند. این کوکی‌ها معمولاً فقط فعالیت شما را در همان سایت مشخص ردیابی می‌کنند.",
   "third-party-cookies-definition-text": "کوکی‌هایی که توسط سایت‌ها و شرکت‌های دیگر (یعنی اشخاص ثالث) تنظیم می‌شوند، کوکی‌های شخص ثالث نامیده می‌شوند. این کوکی‌ها می‌توانند برای ردیابی شما در سایر ویب‌سایت‌هایی که از همان خدمات شخص ثالث استفاده می‌کنند، به کار روند.",
   "cookie-types-title": "انواع کوکی‌ها و نحوه استفاده ما از آن‌ها",
   "essential-cookies-definition-text": "کوکی‌های ضروری برای تجربه شما از یک ویب‌سایت حیاتی هستند و ویژگی‌های اساسی مانند ورود کاربران، مدیریت حساب کاربری، سبد خرید، و پردازش پرداخت‌ها را فعال می‌سازند.",
   "essential-cookies-usage-text": "ما از کوکی‌های ضروری برای فعال‌سازی برخی وظایف در ویب‌سایت‌های خود استفاده می‌کنیم.",
   "performance-cookies-title": "کوکی‌های کارایی",
   "performance-cookies-definition-text": "کوکی‌های کارایی نحوه استفاده شما از یک ویب‌سایت را در جریان بازدیدتان ردیابی می‌کنند. این معلومات معمولاً ناشناس و تجمیع‌شده است و در سطح تمام کاربران سایت جمع‌آوری می‌شود. این کوکی‌ها به شرکت‌ها کمک می‌کنند تا الگوهای استفاده بازدیدکنندگان را درک کنند، مشکلات یا خطاهایی را که ممکن است کاربران شان با آن مواجه شوند شناسایی و رفع کنند، و تصمیمات استراتژیک بهتری برای بهبود تجربه کلی مخاطبان خود از ویب‌سایت اتخاذ نمایند. این کوکی‌ها ممکن است توسط ویب‌سایتی که از آن بازدید می‌کنید (طرف اول) یا توسط خدمات اشخاص ثالث تنظیم شوند. این کوکی‌ها معلومات شخصی در مورد شما جمع‌آوری نمی‌کنند.",
   "performance-cookies-usage-text": "ما از کوکی‌های کارایی در سایت‌های خود استفاده می‌کنیم.",
   "functionality-cookies-title": "کوکی‌های عملکردی",
   "functionality-cookies-definition-text": "کوکی‌های عملکردی برای جمع‌آوری معلومات در مورد دستگاه شما و هرگونه تنظیماتی که ممکن است در ویب‌سایتی که از آن بازدید می‌کنید انجام دهید (مانند تنظیمات زبان و ساعت زمانی) استفاده می‌شوند. با استفاده از این معلومات، ویب‌سایت‌ها می‌توانند محتوا و خدمات سفارشی‌شده، بهبودیافته یا بهینه‌شده را در اختیار شما قرار دهند. این کوکی‌ها ممکن است توسط ویب‌سایتی که از آن بازدید می‌کنید (طرف اول) یا توسط خدمات اشخاص ثالث تنظیم شوند.",
   "functionality-cookies-usage-text": "ما از کوکی‌های عملکردی برای برخی ویژگی‌های منتخب در سایت‌های خود استفاده می‌کنیم.",
   "targeting-advertising-cookies-title": "کوکی‌های هدف‌گیری/تبلیغاتی",
   "targeting-advertising-cookies-definition-text": "کوکی‌های هدف‌گیری/تبلیغاتی کمک می‌کنند تا مشخص شود کدام محتوای تبلیغاتی برای شما و علایق تان مرتبط‌تر و مناسب‌تر است. ویب‌سایت‌ها ممکن است از این کوکی‌ها برای ارائه تبلیغات هدفمند یا محدود کردن تعداد دفعاتی که یک تبلیغ را می‌بینید، استفاده کنند. این امر به شرکت‌ها کمک می‌کند تا اثربخشی کمپاین‌های خود و کیفیت محتوایی را که به شما ارائه می‌شود، بهبود بخشند. این کوکی‌ها ممکن است توسط ویب‌سایتی که از آن بازدید می‌کنید (طرف اول) یا توسط خدمات اشخاص ثالث تنظیم شوند. کوکی‌های هدف‌گیری/تبلیغاتی که توسط اشخاص ثالث تنظیم می‌شوند، ممکن است برای ردیابی شما در سایر ویب‌سایت‌هایی که از همان خدمات شخص ثالث استفاده می‌کنند، به کار روند.",
   "targeting-advertising-cookies-usage-text": "ما از کوکی‌های هدف‌گیری/تبلیغاتی در سایت‌های خود استفاده می‌کنیم.",
   "control-cookies-title": "چگونه می‌توانید استفاده ویب‌سایت ما از کوکی‌ها را کنترول کنید؟",
   "cookie-consent-manager-description-text": "شما این حق را دارید که تصمیم بگیرید آیا کوکی‌ها را در ویب‌سایت‌های ما بپذیرید یا رد کنید. شما می‌توانید ترجیحات کوکی خود را در Cookie Consent Manager ما مدیریت کنید. Cookie Consent Manager به شما امکان می‌دهد تا مشخص کنید کدام دسته‌های کوکی را می‌پذیرید یا رد می‌کنید. کوکی‌های ضروری را نمی‌توان رد کرد، زیرا این کوکی‌ها کاملاً برای ارائه خدمات به شما در ویب‌سایت‌های ما ضروری هستند.",
   "browser-settings-cookie-control-text": "شما همچنان می‌توانید ترجیحات کوکی خود را از طریق مدیریت تنظیمات براوزر ویب خود، تنظیم یا تغییر دهید. از آنجایی که هر براوزر ویب متفاوت است، لطفاً به دستورالعمل‌های ارائه‌شده توسط براوزر ویب خود مراجعه کنید (معمولاً در بخش «کمک»). اگر تصمیم بگیرید کوکی‌ها را رد کنید یا غیرفعال سازید، همچنان می‌توانید از ویب‌سایت‌های ما استفاده کنید، هرچند برخی از قابلیت‌های آن‌ها ممکن است برای شما در دسترس نباشد.",
   "cookie-policy-update-frequency-title": "ما چند وقت یک‌بار این پالیسی کوکی را به‌روزرسانی می‌کنیم؟",
   "cookie-policy-update-reason-text": "ما ممکن است این پالیسی کوکی را گاه‌گاهی به‌روزرسانی کنیم تا هرگونه تغییر در کوکی‌ها و تکنالوژی‌های مرتبطی که استفاده می‌کنیم را منعکس سازد، یا به دلایل دیگر عملیاتی، حقوقی یا مقرراتی.",
   "cookie-policy-version-notice-text": "هر بار که از ویب‌سایت‌های ما استفاده می‌کنید، نسخه فعلی پالیسی کوکی قابل اجرا خواهد بود. هنگام استفاده از ویب‌سایت‌های ما، باید تاریخ این پالیسی کوکی (که در بالای این سند درج شده است) را بررسی کرده و هرگونه تغییر نسبت به نسخه قبلی را مرور کنید.",
   "cookie-policy-further-info-title": "از کجا می‌توانید معلومات بیشتر بدست آورید؟",
   "cookie-policy-contact-us-description-text": "برای هرگونه سوال یا نگرانی در مورد پالیسی کوکی ما، می‌توانید از طریق معلومات ذیل با ما تماس بگیرید:",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "این شرایط خدمات آخرین بار در تاریخ ۴ مارچ ۲۰۲۴ به‌روزرسانی شده است.",
   "privacy-intro-websites-prefix-text": "حریم خصوصی شما برای ما اهمیت دارد. سیاست International Advisory, Products and Systems Ltd این است که به حریم خصوصی شما احترام بگذارد و با هرگونه قانون و مقررۀ قابل‌اجرا در ارتباط با هرگونه معلومات شخصی که ممکن است در مورد شما جمع‌آوری نماییم، مطابقت داشته باشد، از جمله در سراسر ویب‌سایت‌های ما،",
   "privacy-intro-websites-suffix-text": "، و سایر سایت‌هایی که مالک آن‌ها هستیم و آن‌ها را اداره می‌کنیم.",
   "personal-information-definition-text": "معلومات شخصی عبارت از هرگونه معلوماتی در مورد شما است که می‌تواند برای شناسایی شما مورد استفاده قرار گیرد. این شامل معلومات در مورد شما به‌عنوان یک شخص (مانند نام، آدرس، و تاریخ تولد)، دستگاه‌های شما، جزئیات پرداخت، و حتی معلومات در مورد نحوهٔ استفاده شما از یک ویب‌سایت یا خدمات آنلاین می‌باشد.",
   "third-party-sites-disclaimer-text": "در صورتی‌که سایت‌های ما حاوی لینک‌هایی به سایت‌ها و خدمات اشخاص ثالث باشد، لطفاً توجه داشته باشید که آن سایت‌ها و خدمات دارای سیاست‌های حفظ حریم خصوصی مربوط به خود می‌باشند. پس از پیروی از یک لینک به هرگونه محتوای شخص ثالث، شما باید معلومات سیاست حفظ حریم خصوصی نشرشدهٔ آن‌ها را در مورد نحوهٔ جمع‌آوری و استفاده از معلومات شخصی مطالعه نمایید. این سیاست حفظ حریم خصوصی شامل هیچ‌یک از فعالیت‌های شما پس از ترک یکی از سایت‌های ما نمی‌شود.",
   "information-we-collect-title": "معلوماتی که جمع‌آوری می‌کنیم",
   "information-categories-intro-text": "معلوماتی که ما جمع‌آوری می‌کنیم به یکی از دو دسته تقسیم می‌شود: معلومات «به‌صورت داوطلبانه ارائه‌شده» و معلومات «به‌صورت خودکار جمع‌آوری‌شده»",
   "voluntarily-provided-info-description-text": "معلومات «به‌صورت داوطلبانه ارائه‌شده» به هرگونه معلوماتی اطلاق می‌شود که شما آگاهانه و به‌طور فعال، هنگام استفاده یا اشتراک در هر یک از خدمات و تبلیغات ما، به ما ارائه می‌نمایید.",
   "automatically-collected-info-description-text": "معلومات «به‌صورت خودکار جمع‌آوری‌شده» به هرگونه معلوماتی اطلاق می‌شود که به‌طور خودکار توسط دستگاه‌های شما، در جریان دسترسی به محصولات و خدمات ما، ارسال می‌گردد.",
   "log-data-title": "داده‌های ثبت",
   "log-data-description-text": "هنگامی که شما از یکی از ویب‌سایت‌های ما بازدید می‌کنید، سرورهای ما ممکن است به‌صورت خودکار داده‌های معیاری را که توسط براوزر ویب شما ارائه می‌شود، ثبت نمایند. این داده‌ها ممکن است شامل آدرس پروتوکول انترنتی (IP) دستگاه شما، نوع و نسخه براوزر شما، صفحاتی که بازدید می‌کنید، زمان و تاریخ بازدید شما، مدت‌زمان سپری‌شده در هر صفحه، و سایر جزئیات مربوط به بازدید شما باشد.",
   "log-data-errors-description-text": "علاوه بر این، اگر شما هنگام استفاده از سایت‌های ما با برخی خطاها مواجه شوید، ممکن است ما به‌صورت خودکار داده‌های مربوط به آن خطا و شرایط پیرامون وقوع آن را جمع‌آوری نماییم. این داده‌ها ممکن است شامل جزئیات تخنیکی در مورد دستگاه شما، آنچه شما در زمان وقوع خطا قصد انجام آن را داشتید، و سایر معلومات تخنیکی مرتبط به آن مشکل باشد. ممکن است شما در مورد چنین خطاهایی اطلاع دریافت کنید یا نکنید، حتی در همان لحظه‌ای که رخ می‌دهند، اینکه آیا اصلاً رخ داده‌اند، یا ماهیت آن خطا چه بوده است.",
   "device-data-intro-text": "هنگامی که شما از ویب‌سایت‌های ما دیدن می‌کنید یا با خدمات ما تعامل می‌نمایید، ممکن است به صورت خودکار معلوماتی را در مورد دستگاه شما جمع‌آوری نماییم، از قبیل:",
   "device-data-title": "معلومات دستگاه",
   "device-type-label": "نوع دستگاه",
   "log-data-combination-warning-text": "لطفاً توجه داشته باشید که هرچند این معلومات ممکن است به تنهایی هویت شخصی را افشا نسازد، اما امکان دارد آن با سایر معلومات ترکیب گردیده و جهت شناسایی اشخاص به صورت شخصی مورد استفاده قرار گیرد.",
   "operating-system-label": "سیستم عامل",
   "unique-device-identifiers-label": "شناسه‌های منحصر به فرد دستگاه",
   "date-of-birth-label": "تاریخ تولد",
   "device-data-settings-note-text": "معلوماتی که ما جمع‌آوری می‌کنیم، ممکن است به تنظیمات خاص دستگاه و نرم‌افزار شما بستگی داشته باشد. ما پیشنهاد می‌کنیم پالیسی‌های تولیدکننده دستگاه یا ارائه‌دهنده نرم‌افزار خود را بررسی نمایید تا بدانید که آن‌ها چه معلوماتی را در اختیار ما قرار می‌دهند.",
   "geo-location-data-label": "معلومات موقعیت جغرافیایی",
   "personal-information-intro-text": "ما ممکن است معلومات شخصی را درخواست نماییم — به عنوان مثال، هنگامی که شما در خبرنامه ما ثبت‌نام می‌کنید یا زمانی که با ما تماس می‌گیرید — که ممکن است شامل یک یا چند مورد ذیل باشد:",
   "personal-information-title": "معلومات شخصی",
   "social-media-profiles-label": "پروفایل‌های رسانه‌های اجتماعی",
   "phone-mobile-number-label": "شماره تلفن/موبایل",
   "home-mailing-address-label": "آدرس منزل/مکاتباتی",
   "work-related-information-label": "معلومات مرتبط به کار",
   "company-name-label": "نام شرکت",
   "title-field-label": "عنوان",
   "sensitive-information-title": "معلومات حساس",
   "sensitive-information-definition-text": "«معلومات حساس» یا «طبقات ویژه معلومات» زیرمجموعه‌ای از معلومات شخصی است که سطح بالاتری از حفاظت به آن داده می‌شود. نمونه‌های معلومات حساس شامل معلومات مربوط به نژاد یا اصلیت قومی، عقاید سیاسی، دین، اتحادیه‌های صنفی یا سایر انجمن‌ها یا عضویت‌های حرفه‌ای، باورهای فلسفی، گرایش جنسی، رفتارهای جنسی یا زندگی جنسی، سوابق جزایی، معلومات صحی، یا معلومات بیومتریک می‌باشد.",
   "sensitive-information-types-intro-text": "انواع معلومات حساسی که ممکن است در مورد شما جمع‌آوری نماییم شامل موارد ذیل است:",
   "sensitive-information-consent-text": "ما معلومات حساس شما را بدون کسب رضایت قبلی شما جمع‌آوری نمی‌کنیم، و معلومات حساس شما را تنها مطابق با آنچه قانون اجازه می‌دهد، ایجاب می‌کند، یا مجاز می‌شمارد، مورد استفاده یا افشا قرار خواهیم داد.",
   "privacy-user-generated-content-description-text": "ما «محتوای تولیدشده توسط کاربر» را موادی (محتوای متنی، تصویری و/یا ویدیویی) می‌دانیم که به صورت داوطلبانه توسط کاربران ما به منظور نشر، پردازش، یا استفاده در پلتفورم ما، به ما ارائه می‌شود. تمامی محتوای تولیدشده توسط کاربر با حساب کاربری یا آدرس ایمیلی که برای ارسال مواد استفاده شده است، مرتبط می‌باشد.",
   "user-generated-content-publication-notice-text": "لطفاً توجه داشته باشید که هرگونه محتوایی که شما به منظور نشر ارسال می‌نمایید، پس از نشر (و روند بررسی یا ارزیابی متعاقب آن) به صورت عمومی در دسترس خواهد بود. پس از نشر، ممکن است این محتوا برای اشخاص ثالثی که تحت پوشش این پالیسی محرمیت قرار ندارند نیز قابل دسترسی باشد.",
   "transaction-data-title": "معلومات معامله",
   "transaction-data-description-text": "معلومات معامله به معلوماتی اطلاق می‌گردد که در جریان روند عادی فعالیت در پلتفورم ما انباشته می‌شود. این معلومات ممکن است شامل سوابق معاملات، فایل‌های ذخیره‌شده، پروفایل‌های کاربران، معلومات تحلیلی و سایر معیارها، و همچنان سایر انواع معلومات باشد که در جریان تعامل کاربران با خدمات ما ایجاد یا تولید می‌گردد.",
   "legitimate-reasons-title": "دلایل مشروع برای پردازش معلومات شخصی شما",
   "legitimate-reasons-description-text": "ما معلومات شخصی شما را تنها در صورتی جمع‌آوری و استفاده می‌کنیم که دلیل مشروعی برای انجام آن داشته باشیم. در چنین حالتی، ما تنها معلوماتی شخصی را جمع‌آوری می‌کنیم که برای ارائه خدمات خود به شما، به‌صورت معقول ضروری باشد.",
   "collection-and-use-title": "جمع‌آوری و استفاده از معلومات",
   "collection-and-use-intro-text": "ما ممکن است معلومات شخصی شما را زمانی جمع‌آوری کنیم که شما هر یک از موارد ذیل را در وبسایت‌های ما انجام دهید:",
   "collect-register-account-text": "ثبت نام برای ایجاد حساب کاربری",
   "collect-purchase-subscription-text": "خریداری اشتراک",
   "collect-signup-updates-text": "ثبت نام برای دریافت به‌روزرسانی‌ها از ما از طریق ایمیل یا کانال‌های رسانه‌های اجتماعی",
   "collect-mobile-browser-text": "استفاده از یک دستگاه موبایل یا مرورگر وب برای دسترسی به محتوای ما",
   "collect-contact-us-text": "تماس با ما از طریق ایمیل، رسانه‌های اجتماعی، یا هر تکنالوژی مشابه دیگر",
   "collect-social-media-mention-text": "هنگامی که شما از ما در رسانه‌های اجتماعی نام می‌برید",
   "collection-purposes-intro-text": "ما ممکن است معلومات را به اهداف ذیل جمع‌آوری، نگهداری، استفاده و افشا نماییم، و معلومات شخصی به شیوه‌یی که با این اهداف مطابقت نداشته باشد، بیشتر پردازش نخواهد شد:",
   "purpose-core-features-text": "جهت ارائه ویژگی‌ها و خدمات اساسی پلتفورم ما به شما",
   "purpose-customize-experience-text": "جهت فراهم آوردن امکان تنظیم یا شخصی‌سازی تجربه شما از ویب‌سایت‌های ما",
   "purpose-deliver-products-text": "جهت ارائه محصولات و/یا خدمات به شما",
   "purpose-contact-communicate-text": "جهت تماس و ارتباط با شما",
   "purpose-analytics-research-text": "جهت تحلیل‌ها، تحقیقات بازار و توسعه کسب‌وکار، شامل راه‌اندازی و بهبود ویب‌سایت‌ها، اپلیکیشن‌های مرتبط و پلتفورم‌های رسانه‌های اجتماعی مرتبط ما",
   "purpose-advertising-marketing-text": "به منظور تبلیغات و بازاریابی، از جمله ارسال معلومات تبلیغاتی به شما در مورد محصولات و خدمات ما و معلومات مربوط به اشخاص ثالث که به نظر ما ممکن است مورد علاقه شما باشد",
   "purpose-enable-access-text": "به منظور فراهم نمودن امکان دسترسی و استفاده شما از ویب‌سایت‌های ما، اپلیکیشن‌های مرتبط، و پلتفرم‌های رسانه‌های اجتماعی مرتبط",
   "purpose-record-keeping-text": "به منظور نگهداری سوابق داخلی و مقاصد اداری",
   "purpose-legal-compliance-text": "به منظور رعایت تعهدات قانونی ما و حل و فصل هرگونه اختلافی که ممکن است داشته باشیم",
   "purpose-attribute-content-text": "به منظور نسبت دادن هرگونه محتوا (به طور مثال پست‌ها و نظرات) که شما ارائه می‌نمایید و ما آن را در ویب‌سایت‌های خود نشر می‌نماییم",
   "purpose-security-fraud-text": "به منظور تأمین امنیت و جلوگیری از تقلب، و اطمینان از این‌که سایت‌ها و اپلیکیشن‌های ما ایمن، محفوظ، و مطابق با شرایط استفاده ما مورد استفاده قرار می‌گیرند",
   "purpose-technical-assessment-text": "برای ارزیابی تخنیکی، شامل بهره‌برداری و بهبود اپلیکیشن ما، اپلیکیشن‌های مرتبط، و پلتفارم‌های رسانه‌های اجتماعی مرتبط",
   "collection-combine-sources-text": "ما ممکن است معلومات شخصی داوطلبانه ارائه شده و معلوماتی را که به صورت خودکار جمع‌آوری می‌گردد، با معلومات عمومی یا داده‌های تحقیقاتی که از سایر منابع معتبر دریافت می‌نماییم، ترکیب نماییم. به عنوان مثال، اگر شما موقعیت مکانی خود را با ما شریک سازید، ممکن است این معلومات را با معلومات عمومی در مورد پول رایج و زبان ترکیب نماییم تا تجربه بهتری از سایت‌ها و خدمات ما برای شما فراهم گردد.",
   "security-of-information-title": "امنیت معلومات شخصی شما",
   "security-measures-description-text": "هنگامی که ما معلومات شخصی را جمع‌آوری و پردازش می‌نماییم، و در جریان مدتی که این معلومات را نگهداری می‌کنیم، آن را در حدود امکانات قابل قبول تجارتی حفاظت خواهیم کرد تا از فقدان و سرقت آن، و همچنان دسترسی، افشا، کاپی کردن، استفاده یا تغییر غیرمجاز آن جلوگیری به عمل آید.",
   "security-no-guarantee-text": "اگرچه ما تمام تلاش خود را برای حفاظت از معلومات شخصی که شما به ما ارائه می‌نمایید انجام خواهیم داد، اما یادآور می‌شویم که هیچ روش انتقال یا ذخیره‌سازی الکترونیکی صد در صد مصئون نیست و هیچ کسی نمی‌تواند امنیت مطلق داده‌ها را تضمین نماید.",
   "security-password-responsibility-text": "شما مسئول انتخاب هرگونه رمز عبور و میزان قوت امنیتی کلی آن هستید و باید در محدوده خدمات ما، امنیت معلومات خود را تضمین نمایید. به عنوان مثال، اطمینان حاصل نمایید که هرگونه رمز عبور مرتبط با دسترسی به معلومات شخصی و حساب‌های شما، مصئون و محرم باقی بماند.",
   "retention-period-title": "مدت زمان نگهداری معلومات شخصی شما",
   "retention-period-description-text": "ما معلومات شخصی شما را تنها تا زمانی که به آن نیاز داشته باشیم، نگه می‌داریم. این مدت زمان ممکن است بسته به اینکه معلومات شما را برای چه هدفی استفاده می‌کنیم، مطابق با این پالیسی محرمیت، متفاوت باشد. به‌طور مثال، اگر شما معلومات شخصی خود را به عنوان بخشی از ایجاد یک حساب کاربری نزد ما ارائه کرده باشید، ممکن است این معلومات را تا زمانی که حساب کاربری شما در سیستم ما وجود داشته باشد، نگه‌داری کنیم. اگر معلومات شخصی شما دیگر برای این هدف مورد نیاز نباشد، ما آن را حذف می‌کنیم یا با حذف تمامی جزئیاتی که هویت شما را مشخص می‌سازد، آن را ناشناس می‌سازیم.",
   "retention-legal-obligation-text": "با این حال، در صورت لزوم، ممکن است معلومات شخصی شما را به منظور رعایت یک الزام قانونی، حسابداری یا گزارش‌دهی، یا به منظور اهداف آرشیف در راستای منافع عامه، تحقیقات علمی یا تاریخی، یا اهداف احصائیوی نگه‌داری کنیم.",
   "childrens-privacy-title": "محرمیت اطفال",
   "childrens-privacy-description-text": "هیچ‌یک از محصولات یا خدمات ما به‌طور مستقیم متوجه اطفال زیر سن ۱۳ سال نیست و ما به‌طور آگاهانه معلومات شخصی اطفال زیر سن ۱۳ سال را جمع‌آوری نمی‌کنیم.",
   "disclosure-to-third-parties-title": "افشای معلومات شخصی به اشخاص ثالث",
   "disclosure-intro-text": "ما ممکن است معلومات شخصی را به موارد ذیل افشا نماییم:",
   "disclose-affiliate-text": "شرکت مادر، فرعی یا وابسته به شرکت ما",
   "disclose-service-providers-text": "ارائه‌دهندگان خدمات شخص ثالث به منظور فراهم نمودن امکان ارائه خدمات‌شان، شامل (بدون محدودیت) ارائه‌دهندگان خدمات تکنالوژی معلوماتی، ارائه‌دهندگان خدمات ذخیره‌سازی معلومات، میزبانی و سرور، شبکه‌های تبلیغاتی، ارائه‌دهندگان خدمات تحلیلی، ثبت‌کنندگان خطاها، جمع‌آوری‌کنندگان قروض، ارائه‌دهندگان خدمات نگهداری یا حل مشکلات، ارائه‌دهندگان خدمات بازاریابی یا تبلیغاتی، مشاورین حرفه‌یی، و اپراتورهای سیستم‌های پرداخت",
   "disclose-employees-text": "کارمندان ما، قراردادی‌های ما، و/یا نهادهای مرتبط با ما",
   "disclose-business-partners-text": "نمایندگان یا شرکای تجارتی فعلی یا احتمالی ما",
   "disclose-credit-agencies-text": "ادارات گزارش‌دهی اعتباری، محاکم، دادگاه‌ها، و مقامات تنظیم‌کننده، در صورتی‌که شما در پرداخت بهای اجناس یا خدماتی که ما به شما ارائه نموده‌ایم ناکام شوید",
   "disclose-law-enforcement-text": "دادگاه‌ها، هیئت‌های داوری، مراجع نظارتی، و مأمورین تطبیق قانون، به گونه‌ای که قانون ایجاب می‌نماید، در ارتباط با هرگونه دعوای حقوقی جاری یا احتمالی، یا به منظور اثبات، اعمال و یا دفاع از حقوق قانونی خویش",
   "disclose-agents-subcontractors-text": "اشخاص ثالث، شامل نمایندگان یا پیمانکاران فرعی که ما را در ارائه معلومات، محصولات، خدمات، یا بازاریابی مستقیم به شما یاری می‌رسانند",
   "disclose-collect-process-text": "اشخاص ثالث به منظور جمع‌آوری و پردازش معلومات",
   "disclose-business-transfer-text": "نهادی که تمام یا بخش عمده دارایی‌ها و فعالیت تجارتی ما را خریداری می‌نماید، یا نهادی که ما تمام یا بخش عمده دارایی‌ها و فعالیت تجارتی خویش را به آن انتقال می‌دهیم",
   "third-parties-currently-used-text": "اشخاص ثالثی که ما در حال حاضر از خدمات آن‌ها استفاده می‌کنیم، شامل موارد ذیل می‌باشد:",
   "international-transfers-title": "انتقالات بین‌المللی معلومات شخصی",
   "international-transfers-description-text": "معلومات شخصی که ما جمع‌آوری می‌کنیم، در ایالات متحده ذخیره و/یا پردازش می‌گردد، یا در جایی که ما یا شرکا، وابسته‌ها و ارائه‌دهندگان شخص ثالث ما دارای تسهیلات می‌باشند.",
   "international-transfers-legal-note-text": "کشورهایی که ما معلومات شخصی شما را در آن‌ها ذخیره، پردازش یا انتقال می‌دهیم، ممکن است قوانین حفاظت از معلومات مشابه قوانین کشوری را که شما ابتدا معلومات را در آن ارائه کرده‌اید، نداشته باشند. اگر ما معلومات شخصی شما را به اشخاص ثالث در کشورهای دیگر انتقال دهیم: (i) ما این انتقالات را مطابق با الزامات قانون قابل تطبیق انجام خواهیم داد؛ و (ii) ما معلومات شخصی انتقال‌یافته را مطابق با این پالیسی محرمیت محافظت خواهیم کرد.",
   "your-rights-title": "حقوق شما و کنترل معلومات شخصی شما",
   "your-choice-description-text": "انتخاب شما: با ارائه معلومات شخصی به ما، شما درک می‌کنید که ما معلومات شخصی شما را مطابق با این پالیسی محرمیت جمع‌آوری، نگهداری، استفاده و افشا خواهیم کرد. شما مکلف به ارائه معلومات شخصی به ما نیستید، اما در صورتی که چنین نکنید، ممکن است بر استفاده شما از ویب‌سایت‌های ما یا محصولات و/یا خدماتی که در آن‌ها یا از طریق آن‌ها ارائه می‌شوند، تأثیر بگذارد.",
   "info-from-third-parties-text": "معلومات از اشخاص ثالث: اگر ما معلومات شخصی درباره شما را از یک شخص ثالث دریافت کنیم، آن را مطابق با آنچه در این پالیسی محرمیت بیان شده است، محافظت خواهیم کرد. اگر شما یک شخص ثالث هستید که معلومات شخصی درباره شخص دیگری ارائه می‌کنید، شما اقرار و تضمین می‌نمایید که رضایت آن شخص را برای ارائه معلومات شخصی به ما دارید.",
   "marketing-permission-text": "اجازه بازاریابی: اگر شما قبلاً موافقت کرده‌اید که ما از معلومات شخصی شما برای اهداف بازاریابی مستقیم استفاده کنیم، می‌توانید در هر زمانی با تماس گرفتن با ما از طریق معلومات ذکرشده در ذیل، نظر خود را تغییر دهید.",
   "access-rights-text": "دسترسی: شما می‌توانید جزئیات معلومات شخصی را که ما در مورد شما نگهداری می‌کنیم، درخواست نمایید",
   "correction-rights-text": "اصلاح: اگر باور دارید که هرگونه معلوماتی که ما در مورد شما نگهداری می‌کنیم نادرست، منسوخ، ناقص، نامرتبط یا گمراه‌کننده است، لطفاً از طریق معلومات ارائه‌شده در این پالیسی محرمیت با ما تماس بگیرید. ما اقدامات معقول را برای اصلاح هرگونه معلوماتی که نادرست، ناقص، گمراه‌کننده یا منسوخ تشخیص داده شود، انجام خواهیم داد.",
   "non-discrimination-text": "عدم تبعیض: ما در برابر شما به دلیل استفاده از هر یک از حقوق‌تان در مورد معلومات شخصی‌تان تبعیض قایل نخواهیم شد. مگر اینکه معلومات شخصی شما برای ارائه یک خدمت یا پیشنهاد خاص لازم باشد (به‌طور مثال پردازش معلومات معامله)، ما شما را از کالاها یا خدمات محروم نخواهیم کرد و/یا قیمت‌ها یا نرخ‌های متفاوتی برای کالاها یا خدمات از شما اخذ نخواهیم کرد، از جمله از طریق اعطای تخفیف‌ها یا سایر مزایا، یا وضع جریمه‌ها، یا ارائه سطح یا کیفیت متفاوت کالاها یا خدمات به شما.",
   "download-personal-info-text": "دانلود معلومات شخصی: ما وسیله‌ای را برای شما فراهم می‌کنیم تا معلومات شخصی را که از طریق سایت‌های ما شریک ساخته‌اید، دانلود نمایید. لطفاً برای معلومات بیشتر با ما تماس بگیرید.",
   "data-breach-notification-text": "اطلاع‌رسانی در مورد نقض معلومات: ما در رابطه با هرگونه نقض معلومات، قوانین قابل تطبیق بر خود را رعایت خواهیم کرد.",
   "complaints-rights-text": "شکایات: اگر باور دارید که ما قانون مربوط به حفاظت از معلومات را نقض کرده‌ایم و می‌خواهید شکایتی ارائه نمایید، لطفاً از طریق معلومات ذیل با ما تماس بگیرید و جزئیات کامل نقض ادعاشده را به ما ارائه کنید. ما بی‌درنگ به شکایت شما رسیدگی نموده و به‌صورت کتبی به شما پاسخ خواهیم داد که در آن نتیجهٔ بررسی ما و اقداماتی که برای رسیدگی به شکایت شما انجام خواهیم داد، مشخص می‌گردد. شما همچنین حق دارید در ارتباط با شکایت‌تان با یک نهاد نظارتی یا مرجع حفاظت از معلومات تماس بگیرید.",
   "unsubscribe-rights-text": "لغو اشتراک: برای لغو اشتراک از پایگاه داده ایمیل ما یا انصراف از دریافت مکاتبات (شامل مکاتبات بازاریابی)، لطفاً از طریق معلومات ارائه‌شده در این پالیسی محرمیت با ما تماس بگیرید، یا با استفاده از امکانات انصراف که در خود مکاتبه فراهم شده است، انصراف دهید. ممکن است لازم باشد معلومات مشخصی را از شما درخواست کنیم تا به ما در تأیید هویت‌تان کمک کند.",
   "use-of-cookies-title": "استفاده از کوکی‌ها",
   "use-of-cookies-description-text": "ما از «کوکی‌ها» برای جمع‌آوری معلومات در مورد شما و فعالیت شما در سراسر سایت‌های ما استفاده می‌کنیم. کوکی یک بخش کوچک از داده‌ها است که ویب‌سایت‌های ما آن را در کمپیوتر شما ذخیره می‌کنند و در هر بار مراجعه شما به آن دسترسی پیدا می‌کنند، تا ما بتوانیم درک کنیم که چگونه از سایت‌های ما استفاده می‌کنید. این به ما کمک می‌کند تا محتوا را بر اساس ترجیحاتی که شما مشخص کرده‌اید، به شما ارائه کنیم.",
   "refer-to-cookie-policy-text": "لطفاً برای معلومات بیشتر به پالیسی کوکی ما مراجعه کنید.",
   "business-transfers-title": "انتقال‌های تجارتی",
   "business-transfers-description-text": "در صورتی که ما یا دارایی‌های ما تصاحب شوند، یا در صورت وقوع احتمال بعید توقف فعالیت تجارتی یا ورشکستگی ما، داده‌ها، شامل معلومات شخصی شما، در جمله دارایی‌های منتقل‌شده به هر طرفی که ما را تصاحب می‌کند، شامل خواهد شد. شما تأیید می‌کنید که چنین انتقال‌هایی ممکن است رخ دهد، و اینکه هر طرفی که ما را تصاحب می‌کند می‌تواند، تا حدی که قانون قابل‌اجرا اجازه می‌دهد، به استفاده از معلومات شخصی شما مطابق با این پالیسی ادامه دهد، که آن‌ها ملزم خواهند بود آن را بپذیرند، زیرا این پالیسی اساس هرگونه حقوق مالکیت یا استفاده‌ای است که ما بر چنین معلوماتی داریم.",
   "limits-of-policy-title": "محدودیت‌های پالیسی ما",
   "limits-of-policy-description-text": "وب‌سایت‌های ما ممکن است به سایت‌های خارجی که توسط ما اداره نمی‌شوند، لینک داشته باشند. لطفاً توجه داشته باشید که ما هیچ کنترلی بر محتوا و پالیسی‌های آن سایت‌ها نداریم و نمی‌توانیم مسئولیت یا مسئولیت قانونی مربوط به شیوه‌های حفظ حریم خصوصی آن‌ها را بپذیریم.",
   "changes-to-policy-title": "تغییرات در این پالیسی",
   "changes-to-policy-description-text": "بر اساس صلاحدید خود، ما می‌توانیم پالیسی حفظ حریم خصوصی خود را تغییر دهیم تا انعکاس‌دهنده به‌روزرسانی‌های فرایندهای تجاری ما، شیوه‌های قابل قبول فعلی، یا تغییرات قانونی یا مقرراتی باشد. در صورتی که تصمیم بگیریم این پالیسی حفظ حریم خصوصی را تغییر دهیم، تغییرات را در همین‌جا، در همان لینکی که شما از طریق آن به این پالیسی حفظ حریم خصوصی دسترسی پیدا می‌کنید، نشر خواهیم کرد.",
   "changes-significant-notice-text": "اگر تغییرات قابل ملاحظه باشند، یا اگر قانون قابل تطبیق آن را ایجاب کند، ما با شما (بر اساس ترجیحات انتخابی شما برای ارتباطات از جانب ما) و تمام کاربران ثبت‌شده خود، با جزئیات جدید و لینک‌های مربوط به پالیسی به‌روزشده یا تغییریافته، تماس خواهیم گرفت.",
   "changes-permission-text": "در صورتی که قانون آن را ایجاب کند، ما اجازه شما را اخذ خواهیم کرد یا به شما این فرصت را خواهیم داد تا، بر حسب مورد، برای هرگونه استفاده جدید از معلومات شخصی‌تان رضایت دهید یا از آن انصراف دهید.",
   "au-privacy-act-title": "افشاسازی‌های اضافی برای مطابقت با قانون محرمیت استرالیا (AU)",
   "au-privacy-act-description-text": "در مواردی که افشای معلومات شخصی شما صرفاً تابع قوانین محرمیت استرالیا باشد، شما تصدیق می‌نمایید که ممکن است برخی از اشخاص ثالث تحت نظارت قانون محرمیت و اصول محرمیت استرالیا مندرج در قانون محرمیت قرار نداشته باشند. شما تصدیق می‌نمایید که هرگاه هر یک از این اشخاص ثالث مرتکب هرگونه عمل یا رویه‌ای گردد که ناقض اصول محرمیت استرالیا باشد، آن شخص ثالث تحت قانون محرمیت مسئول شناخته نخواهد شد و شما نخواهید توانست تحت قانون محرمیت جبران خساره مطالبه نمایید.",
   "gdpr-compliance-title": "افشاسازی‌های اضافی برای مطابقت با مقررات عمومی حفاظت از معلومات (GDPR) (اتحادیه اروپا)",
   "data-controller-processor-title": "کنترل‌کننده معلومات / پردازش‌کننده معلومات",
   "data-controller-processor-description-text": "مقررات GDPR میان مؤسساتی که معلومات شخصی را برای اهداف خود پردازش می‌نمایند (که به عنوان «کنترل‌کننده‌های معلومات» شناخته می‌شوند) و مؤسساتی که معلومات شخصی را از جانب مؤسسات دیگر پردازش می‌نمایند (که به عنوان «پردازش‌کننده‌های معلومات» شناخته می‌شوند) تفاوت قایل می‌شود. ما، International Advisory, Products and Systems Ltd، که در آدرس ارائه‌شده در بخش تماس با ما موقعیت داریم، در رابطه با معلومات شخصی‌ای که شما به ما ارائه می‌نمایید، به‌عنوان کنترل‌کننده معلومات و/یا پردازش‌کننده معلومات ایفای نقش می‌نماییم.",
   "legal-bases-title": "مبانی حقوقی برای پردازش معلومات شخصی شما",
   "legal-bases-description-text": "ما معلومات شخصی شما را تنها زمانی جمع‌آوری و استفاده می‌کنیم که حق قانونی برای انجام آن را داشته باشیم. در چنین حالتی، ما معلومات شخصی شما را به‌گونه‌ی قانونی، منصفانه و به شیوه‌ی شفاف جمع‌آوری و استفاده خواهیم کرد. اگر برای پردازش معلومات شخصی شما رضایت شما را جویا شویم و شما کمتر از ۱۶ سال عمر داشته باشید، ما رضایت والدین یا سرپرست قانونی شما را برای پردازش معلومات شخصی‌تان جهت آن هدف مشخص جویا خواهیم شد.",
   "legal-bases-grounds-text": "مبانی قانونی ما بستگی به خدماتی دارد که شما از آن‌ها استفاده می‌کنید و طرز استفاده‌ی شما از آن‌ها. این بدان معنی است که ما معلومات شما را تنها بر اساس دلایل زیر جمع‌آوری و استفاده می‌کنیم:",
   "consent-from-you-title": "رضایت شما",
   "consent-from-you-description-text": "در مواردی که شما به ما رضایت می‌دهید تا معلومات شخصی‌تان را برای یک هدف مشخص جمع‌آوری و استفاده کنیم. شما می‌توانید رضایت خود را در هر زمانی با استفاده از امکاناتی که ما فراهم می‌کنیم، پس بگیرید؛ با این حال، این کار بر هرگونه استفاده‌ای از معلومات شما که قبلاً صورت گرفته است، تأثیری نخواهد داشت. شما می‌توانید برای دریافت ایمیل‌های تبلیغاتی از سوی ما، رضایت خود را برای ارائه‌ی آدرس ایمیل‌تان اعلام کنید. اگرچه شما می‌توانید در هر زمانی اشتراک خود را لغو کنید، اما ما نمی‌توانیم هیچ ایمیلی را که قبلاً ارسال کرده‌ایم، بازپس بگیریم. اگر در مورد چگونگی پس گرفتن رضایت خود پرسش دیگری دارید، لطفاً با استفاده از معلومات ارائه‌شده در بخش تماس با ما در این پالیسی محرمیت، با ما در تماس شوید.",
   "performance-of-contract-title": "اجرای یک قرارداد یا معامله",
   "performance-of-contract-description-text": "در مواردی که شما با ما وارد یک قرارداد یا معامله شده‌اید، یا به‌منظور برداشتن گام‌های مقدماتی پیش از انعقاد قرارداد یا معامله میان ما و شما. به‌طور مثال، اگر شما یک محصول، خدمت یا اشتراک را از ما خریداری کنید، ممکن است ما نیاز داشته باشیم تا از معلومات شخصی و معلومات پرداخت شما به‌منظور پردازش و تحویل سفارش‌تان استفاده کنیم.",
   "legitimate-interests-title": "منافع مشروع ما",
   "legitimate-interests-description-text": "در مواردی که ما ارزیابی می‌کنیم که این کار برای منافع مشروع ما ضروری است، مانند ارائه، بهره‌برداری، بهبود و برقراری ارتباط در رابطه با خدمات ما. ما منافع مشروع خود را شامل تحقیق و توسعه، درک مخاطبان خود، بازاریابی و تبلیغ خدمات خود، اقداماتی که به منظور بهره‌برداری کارآمد از خدمات خود انجام می‌شود، تحلیل بازاریابی، و اقداماتی که به منظور حفاظت از حقوق و منافع قانونی خود انجام می‌شود، می‌دانیم.",
   "compliance-with-law-title": "انطباق با قانون",
   "compliance-with-law-description-text": "در برخی موارد، ممکن است ما تعهد قانونی برای استفاده یا نگهداری معلومات شخصی شما داشته باشیم. چنین مواردی می‌تواند شامل (اما نه محدود به) احکام محاکم، تحقیقات جنایی، درخواست‌های دولتی، و تعهدات مقرراتی باشد. اگر در مورد چگونگی نگهداری معلومات شخصی توسط ما به منظور رعایت قانون سوالات بیشتری دارید، لطفاً با استفاده از معلومات ارائه‌شده در بخش تماس با ما در این پالیسی محرمیت با ما در تماس شوید.",
   "eea-transfers-title": "انتقالات بین‌المللی به خارج از ساحه اقتصادی اروپا (EEA)",
   "eea-transfers-description-text": "ما اطمینان حاصل خواهیم کرد که هرگونه انتقال معلومات شخصی از کشورهای عضو ساحه اقتصادی اروپا (EEA) به کشورهای خارج از EEA، توسط تدابیر حفاظتی مناسب محافظت شود، به طور مثال با استفاده از بندهای معیاری حفاظت از معلومات که توسط کمیسیون اروپا تأیید شده است، یا استفاده از مقررات الزام‌آور شرکتی و یا سایر وسایل قانونی پذیرفته‌شده.",
   "data-portability-text": "قابلیت انتقال معلومات: شما ممکن است این حق را داشته باشید که یک کاپی از معلومات شخصی‌یی را که ما در مورد شما نگهداری می‌کنیم، درخواست نمایید. در صورت امکان، این معلومات را به شکل CSV یا سایر فرمت‌های ماشینی به آسانی قابل خواندن، برای شما فراهم خواهیم کرد. همچنان شما ممکن است این حق را داشته باشید که از ما بخواهید این معلومات شخصی را به یک طرف ثالث انتقال دهیم.",
   "deletion-rights-text": "حذف: شما ممکن است این حق را داشته باشید که در هر زمان از ما بخواهید معلومات شخصی‌یی را که در مورد شما نگهداری می‌کنیم، حذف نماییم، و ما اقدامات معقول را برای حذف معلومات شخصی شما از سوابق فعلی خویش انجام خواهیم داد. اگر از ما بخواهید معلومات شخصی‌تان را حذف کنیم، به شما اطلاع خواهیم داد که این حذف چگونه بر استفاده شما از ویب‌سایت‌ها یا محصولات و خدمات ما تأثیر می‌گذارد. ممکن است به دلایل حقوقی خاص، استثناهایی برای این حق وجود داشته باشد که در صورت وجود، آن‌ها را در پاسخ به درخواست شما برای‌تان بیان خواهیم کرد. اگر حساب کاربری خود را ختم یا حذف نمایید، ما معلومات شخصی شما را در ظرف ۴۵ روز پس از حذف حساب کاربری‌تان حذف خواهیم کرد. لطفاً توجه داشته باشید که موتورهای جستجو و اشخاص ثالث مشابه ممکن است هنوزهم کاپی‌هایی از معلومات شخصی شما را که حداقل یک‌بار به صورت علنی افشا شده است، مانند برخی معلومات پروفایل و نظرات همگانی، حتی پس از حذف معلومات از خدمات ما یا غیرفعال ساختن حساب‌تان، نگهداری نمایند.",
   "objecting-to-processing-text": "اعتراض به پردازش: شما این حق را دارید که به پردازش معلومات شخصی‌تان که مبتنی بر منافع مشروع ما یا منفعت عامه است، اعتراض نمایید. در صورتی که چنین اعتراضی صورت گیرد، ما باید دلایل مشروع و قانع‌کننده‌یی برای پردازش ارائه نماییم که بر منافع، حقوق و آزادی‌های شما برتری داشته باشد، تا بتوانیم به پردازش معلومات شخصی شما ادامه دهیم.",
   "restrict-processing-rights-text": "محدود ساختن: شما این حق را دارید که از ما بخواهید پردازش معلومات شخصی‌تان را محدود سازیم، در صورتی که (i) نسبت به دقت معلومات شخصی‌تان نگرانی داشته باشید؛ (ii) باور داشته باشید که معلومات شخصی‌تان به شکل غیرقانونی پردازش شده است؛ (iii) نیاز داشته باشید که ما معلومات شخصی را صرفاً به منظور یک ادعای حقوقی نگهداری کنیم؛ یا (iv) ما در حال بررسی اعتراض شما در ارتباط با پردازش مبتنی بر منافع مشروع باشیم.",
   "us-states-privacy-title": "افشاسازی‌های اضافی برای مطابقت با قوانین محرمیت ایالت‌های ایالات متحده امریکا.",
   "us-states-privacy-description-text": "بخش ذیل شامل احکامی است که با قوانین محرمیت این ایالت‌ها (California، Colorado، Delaware، Florida، Virginia و Utah) مطابقت دارد و صرفاً بر باشندگان همان ایالت‌ها قابل تطبیق است. اشاره‌های خاص به یک ایالت معین (در عنوان یا در متن) صرفاً اشاره به قانون همان ایالت بوده و تنها بر باشندگان همان ایالت قابل تطبیق است. عباراتی که به یک ایالت خاص اشاره نمی‌کنند، بر تمامی ایالت‌های فهرست‌شده در بالا قابل تطبیق‌اند.",
   "do-not-track-title": "پیگیری نکنید",
   "do-not-track-description-text": "برخی از مرورگرها دارای یک ویژگی «پیگیری نکنید» (Do Not Track) می‌باشند که به شما امکان می‌دهد به وب‌سایت‌ها اطلاع دهید که نمی‌خواهید فعالیت‌های آنلاین شما تعقیب و پیگیری شود. در حال حاضر، ما به سیگنال‌های «پیگیری نکنید» مرورگر پاسخ نمی‌دهیم.",
   "do-not-track-standards-text": "ما به معیارهای مندرج در این پالیسی محرمیت پابند هستیم و اطمینان می‌دهیم که معلومات شخصی را به گونه‌ی قانونی، منصفانه، شفاف و با دلایل مشروع و قانونی جمع‌آوری و پردازش می‌کنیم.",
   "cookies-and-pixels-title": "کوکی‌ها و پیکسل‌ها",
   "cookies-and-pixels-description-text": "شما در هر زمان می‌توانید، در صورتی که مرورگر شما اجازه دهد، کوکی‌های سایت‌های ما را رد کنید. اکثر مرورگرها به شما امکان می‌دهند تنظیماتی را در مرورگر خود فعال نمایید تا از تنظیم شدن همه یا برخی از کوکی‌ها جلوگیری شود. بر این اساس، توانایی شما برای محدود ساختن کوکی‌ها صرفاً بر اساس قابلیت‌های مرورگر شما است. لطفاً برای معلومات بیشتر به بخش کوکی‌ها در این پالیسی محرمیت مراجعه کنید.",
   "california-privacy-laws-title": "قوانین محرمیت California - CPPA",
   "california-privacy-financial-incentive-text": "مطابق بخش 1798.83 قانون مدنی California، اگر شما در California زندگی می‌کنید و رابطه تجارتی شما با ما عمدتاً به منظورهای شخصی، فامیلی یا خانگی باشد، شما می‌توانید در مورد معلوماتی که ما به سازمان‌های دیگر برای اهداف بازاریابی آن‌ها افشا می‌کنیم، از ما پرسان کنید. مطابق با حق شما مبنی بر عدم تبعیض، ما ممکن است برخی مشوق‌های مالی مجاز تحت قانون حریم خصوصی مصرف‌کننده California (California Consumer Privacy Act) و قانون حقوق حریم خصوصی California (California Privacy Rights Act) (که در مجموع CCPA نامیده می‌شوند) را به شما ارائه نماییم که می‌تواند منجر به قیمت‌ها، نرخ‌ها یا سطوح کیفیت متفاوت برای کالاها یا خدماتی شود که ما ارائه می‌دهیم. هر مشوق مالی مجاز تحت CCPA که ما ارائه می‌دهیم، به گونه معقول با ارزش معلومات شخصی شما ارتباط خواهد داشت، و ما شرایط کتبی را ارائه خواهیم کرد که ماهیت چنین پیشنهادی را به وضوح توضیح دهد. اشتراک در یک برنامه مشوق مالی مستلزم رضایت قبلی شما (opt-in) است که می‌توانید آن را در هر زمان لغو نمایید.",
   "california-privacy-request-info-text": "مطابق بخش 1798.83 قانون مدنی California، اگر شما در California زندگی می‌کنید و رابطه تجارتی شما با ما عمدتاً به منظورهای شخصی، فامیلی یا خانگی باشد، شما می‌توانید در مورد معلوماتی که ما به سازمان‌های دیگر برای اهداف بازاریابی آن‌ها افشا می‌کنیم، از ما پرسان کنید. برای ارائه چنین درخواستی، لطفاً با استفاده از معلومات ارائه شده در این پالیسی حریم خصوصی با ما به تماس شوید و در عنوان (subject line) پیام خود عبارت «درخواست برای معلومات حریم خصوصی California» را درج نمایید. شما می‌توانید این نوع درخواست را یک بار در هر سال تقویمی ارائه نمایید. ما یک فهرست از دسته‌بندی‌های معلومات شخصی را که در سال تقویمی گذشته به سازمان‌های دیگر برای اهداف بازاریابی آن‌ها افشا نموده‌ایم، همراه با نام‌ها و آدرس‌های آن سازمان‌ها، برای شما ایمیل خواهیم کرد. تمام معلومات شخصی که به این طریق شریک ساخته می‌شود، تحت پوشش بخش 1798.83 قانون مدنی California قرار نمی‌گیرد.",
   "california-notice-of-collection-title": "اطلاعیه جمع‌آوری معلومات California",
   "california-notice-of-collection-intro-text": "در 12 ماه گذشته، ما دسته‌بندی‌های ذیل معلومات شخصی را که در CCPA برشمرده شده است، جمع‌آوری نموده‌ایم:",
   "ccpa-identifiers-text": "شناسه‌ها، مانند نام، آدرس ایمیل، شماره تلفن، نام حساب کاربری، آدرس IP، و یک شناسه یا شماره تخصیص‌یافته به حساب کاربری شما.",
   "ccpa-customer-records-text": "سوابق مشتری، مانند آدرس صورت‌حساب و آدرس ارسال، و معلومات کارت اعتباری یا دبیت.",
   "ccpa-demographics-text": "معلومات دموگرافیک، مانند سن یا جنسیت شما. این دسته شامل معلوماتی می‌شود که ممکن است طبق سایر قوانین ایالتی California یا قوانین فدرال، به عنوان طبقه‌بندی‌های محافظت‌شده واجد شرایط شناخته شود.",
   "ccpa-commercial-info-text": "معلومات تجارتی، مانند سابقه محصولات یا خدمات و خریدهای انجام‌شده.",
   "ccpa-internet-activity-text": "فعالیت انترنتی، مانند تعاملات شما با خدمات ما.",
   "ccpa-audio-visual-text": "معلومات صوتی یا تصویری، مانند عکس‌ها یا ویدیوهایی که با ما شریک می‌سازید یا در خدمات نشر می‌کنید.",
   "ccpa-geolocation-text": "معلومات موقعیت جغرافیایی.",
   "ccpa-employment-education-text": "معلومات مربوط به استخدام و تحصیلات، مانند معلوماتی که هنگام درخواست شغل نزد ما ارائه می‌کنید.",
   "ccpa-inferences-text": "استنباط‌ها، مانند معلومات مربوط به علایق، ترجیحات و پسندهای شما.",
   "california-notice-of-collection-outro-text": "برای معلومات بیشتر در مورد معلوماتی که جمع‌آوری می‌کنیم، شامل منابعی که معلومات را از آن‌ها دریافت می‌کنیم، بخش «معلوماتی که جمع‌آوری می‌کنیم» را مطالعه نمایید. ما این دسته‌های معلومات شخصی را برای اهداف تجارتی شرح داده‌شده در بخش «جمع‌آوری و استفاده از معلومات»، شامل ارائه و مدیریت خدمت خویش، جمع‌آوری و استفاده می‌نماییم.",
   "right-to-know-delete-title": "حق آگاهی و حذف",
   "right-to-know-delete-intro-text": "شما این حق را دارید که معلومات شخصی خویش را که ما جمع‌آوری نموده‌ایم حذف نمایید و از معلومات معینی در مورد شیوه‌های ما در رابطه به معلومات طی ۱۲ ماه گذشته آگاه شوید. به‌طور مشخص، شما حق دارید موارد ذیل را از ما تقاضا نمایید:",
   "know-delete-categories-collected-text": "دسته‌های معلومات شخصی که در مورد شما جمع‌آوری نموده‌ایم؛",
   "know-delete-categories-sources-text": "دسته‌های منابعی که معلومات شخصی از آن‌ها جمع‌آوری شده است؛",
   "know-delete-categories-disclosed-text": "دسته‌های معلومات شخصی مربوط به شما که ما به منظور تجارتی افشا نموده‌ایم یا به فروش رسانیده‌ایم؛",
   "know-delete-third-parties-text": "دسته‌های اشخاص ثالثی که معلومات شخصی به آن‌ها به منظور تجارتی افشا شده یا فروخته شده است؛",
   "know-delete-business-purpose-text": "هدف تجارتی یا بازرگانی برای جمع‌آوری یا فروش معلومات شخصی؛ و",
   "know-delete-specific-pieces-text": "موارد مشخص معلومات شخصی که ما در مورد شما جمع‌آوری کرده‌ایم.",
   "right-to-know-delete-outro-text": "برای استفاده از هر یک از این حقوق، لطفاً از طریق معلومات تماسی که در این پالیسی محرمیت ارائه شده است، با ما تماس بگیرید.",
   "shine-the-light-title": "Shine the Light",
   "shine-the-light-description-text": "علاوه بر حقوق ذکرشده در بالا، شما حق دارید معلوماتی را در مورد شیوه‌ای که ما معلومات شخصی معین را - آن‌چنان که در قانون قابل‌تطبیق تعریف شده است - با اشخاص ثالث و شرکت‌های وابسته جهت اهداف بازاریابی مستقیم خودشان شریک می‌سازیم، از ما تقاضا نمایید.",
   "shine-the-light-request-text": "برای دریافت این معلومات، لطفاً با استفاده از معلومات تماس ارائه‌شده در این پالیسی محرمیت، درخواست خود را برای ما ارسال کنید. درخواست‌ها باید در سطر اول توضیحات عبارت «درخواست حقوق محرمیت» را شامل باشند و نام، آدرس، شهر، ایالت و کود پستی شما را نیز دربرداشته باشند.",
   "contact-us-title": "تماس با ما",
   "privacy-contact-us-description-text": "در صورت داشتن هرگونه سوال یا نگرانی در مورد محرمیت خویش، می‌توانید از طریق معلومات ذیل با ما در تماس شوید:",
   "customer-service-label": "خدمات مشتریان",

   // My Performance (Staff)
   "loading-ellipsis-text": "در حال بارگذاری...",
   "failed-to-load-modules-error": "بارگذاری ماژول‌ها ناکام شد",
   "failed-to-load-details-error": "بارگذاری جزئیات ناکام شد",
   "my-assessments-title": "ارزیابی‌های من",
   "my-assessments-description-text":
      "با انتخاب یک ارزیابی شروع کنید تا ماژول‌ها و بینش‌های عملکرد آن را ببینید.",
   "no-assessments-yet-title": "به نظر می‌رسد هنوز ارزیابی وجود ندارد!",
   "no-assessments-yet-description-text":
      "زمانی که ارزیابی‌ها نتیجه داشته باشند، اینجا نمایش داده می‌شوند تا آن‌ها را بررسی کنید.",
   "modules-in-assessment-label": "ماژول‌های این ارزیابی:",
   "choose-module-to-see-results-text": "یک ماژول را برای دیدن نتایج انتخاب کنید",
   "status-closed-label": "بسته شده",
   "select-module-alt-text": "انتخاب ماژول",
   "select-module-results-text": "یک ماژول را از لیست انتخاب کنید تا نتایج آن نمایش داده شود",
   "target-label": "هدف",
   "action-plan-label": "پلان عمل",
   "assessment-preview-title": "پیش‌نمایش ارزیابی",
   "no-data-for-assessment-text": "در حال حاضر معلوماتی برای این ارزیابی موجود نیست",
   "my-upcoming-tasks-title": "وظایف آینده من",
   "my-improvement-over-time-title": "پیشرفت من در طول زمان",
   "no-data-for-survey-text": "در حال حاضر معلوماتی برای این سروی موجود نیست",
   "your-score-label": "امتیاز شما",
   "target-score-label": "امتیاز هدف",
   "previous-label": "قبلی",
   "next-label": "بعدی",

   // Task Management (Staff)
   "task-management-title": "مدیریت وظایف",
   "tasks-tab-label": "وظایف",
   "assigned-modules-title": "ماژول‌های تخصیص داده شده",
   "collapse-all-button": "بستن همه",
   "expand-all-button": "باز کردن همه",
   "assigned-tasks-title": "وظایف تخصیص داده شده",
   "board-tab-label": "بورد",
   "timeline-tab-label": "جدول زمانی",
   "no-available-modules-text": "هیچ ماژولی برای این ارزیابی موجود نیست",
   "no-available-tasks-text": "هیچ وظیفه‌ای برای این ارزیابی موجود نیست",
   "go-alt-text": "برو",
   "view-alt-text": "مشاهده",
   "notes-alt-text": "یادداشت‌ها",
   "change-status-to-label": "تغییر وضعیت به:",
   "priority-low-label": "پایین",
   "priority-medium-label": "متوسط",
   "priority-high-label": "بالا",
   "priority-urgent-label": "فوری",
   "show-less-link": "نمایش کمتر",
   "monthly-toggle-label": "ماهانه",
   "quarterly-toggle-label": "ربع‌وار",
   "week-prefix-text": "هفته",
   "to-do-status": "انجام نشده",
   "tasks-column-header": "وظایف",
   "linked-questions-prefix-text": "سوالات مرتبط:",
   "assigned-status": "تخصیص داده شده",
   "action-plan-dashboard-title": "داشبورد پلان عملی",
   "action-plan-for-label": "پلان عملی برای",

   "role-vendor-label": "عرضه‌کننده",
   "switch-role-label": "تغییر نقش",
   "current-role-label": "نقش فعلی",
   "switch-role-error-description": "تغییر نقش شما ممکن نشد، لطفاً دوباره تلاش کنید.",
   "approver-role-added-to-existing-user-description":
      "این کاربر از قبل حساب داشت، بنابراین ایمیل دعوت فرستاده نشد. او با رمز عبور فعلی خود وارد می‌شود و به نقش تأییدکننده تغییر می‌دهد.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "متخصص",
   "expert-role-enabled-success-title": "نقش متخصص اضافه شد",
   "expert-role-enabled-success-description": "این تأییدکننده اکنون می‌تواند به عنوان متخصص نیز کار کند.",
   "expert-role-disabled-success-title": "نقش متخصص حذف شد",
   "expert-role-disabled-success-description": "این تأییدکننده دیگر نقش متخصص را ندارد.",
   "expert-role-toggle-error-description": "به‌روزرسانی نقش متخصص ممکن نشد، لطفاً دوباره کوشش کنید.",
   "expert-role-not-found-description": "این تأییدکننده دیگر وجود ندارد. لیست به‌روز شد.",
   "approver-role-column": "تأییدکننده",
   "approver-role-enabled-success-title": "نقش تأییدکننده اضافه شد",
   "approver-role-enabled-success-description": "این متخصص اکنون می‌تواند به عنوان تأییدکننده نیز کار کند.",
   "approver-role-disabled-success-title": "نقش تأییدکننده حذف شد",
   "approver-role-disabled-success-description": "این متخصص دیگر نقش تأییدکننده را ندارد.",
   "approver-role-toggle-error-description": "به‌روزرسانی نقش تأییدکننده ممکن نشد، لطفاً دوباره کوشش کنید.",
   "approver-role-not-found-description": "این متخصص دیگر وجود ندارد. لیست به‌روز شد.",
   "expert-exists-redirect-title": "از قبل متخصص است",
   "expert-exists-redirect-description":
      "این ایمیل از قبل به یک متخصص تعلق دارد. شما را به لیست متخصصین می‌بریم تا بتوانید نقش تأییدکننده را به او بدهید.",

   "linked-assessment-edit-notice":
      "این ارزیابی با ارزیابی دیگری پیوند دارد، بنابراین تنها می‌توان دورهای جدید اضافه کرد. هر دوری که اینجا اضافه کنید به ارزیابی پیوندخورده نیز افزوده می‌شود.",
   "start-date-in-past-validation": "تاریخ آغاز نمی‌تواند در گذشته باشد.",
   "end-date-must-be-future-validation": "تاریخ پایان باید در آینده باشد.",
   "round-overlaps-another-round-validation": "این دور با دور دیگری هم‌پوشانی دارد.",
   "view-all-notifications-button": "مشاهده همه اطلاعیه‌ها",
   "notifications-page-title": "اطلاعیه‌ها",
   "notifications-empty-title": "هنوز اطلاعیه‌ای وجود ندارد",
   "notifications-unread-empty-title": "اطلاعیهٔ نخوانده‌ای وجود ندارد",
   "notifications-empty-text": "همه را دیده‌اید. اطلاعیه‌های جدید اینجا نمایش داده می‌شوند.",
   "guided-assessment-completed-prefix-text": "ارزیابی رهنمایی‌شده شما",
   "guided-assessment-completed-suffix-text": "تکمیل شد.",
   "notification-title-org-signup": "ثبت‌نام سازمان جدید",
   "notification-title-expert-signup": "ثبت‌نام متخصص جدید",
   "notification-title-workspace-join-request": "درخواست سازمان برای پیوستن به فضای کاری",
   "notification-title-workspace-approved": "درخواست فضای کاری تأیید شد",
   "notification-title-workspace-rejected": "درخواست فضای کاری رد شد",
   "notification-title-guided-request": "درخواست ارزیابی رهنمایی‌شده",
   "notification-title-guided-approved": "درخواست ارزیابی رهنمایی‌شده تأیید شد",
   "notification-title-guided-rejected": "درخواست ارزیابی رهنمایی‌شده رد شد",
   "notification-title-guided-completed": "ارزیابی رهنمایی‌شده تکمیل شد",
   "notification-title-self-assigned": "خودارزیابی جدید تعیین شد",
   "notification-title-self-unassigned": "خودارزیابی لغو شد",
   "notification-title-expert-assigned": "به ارزیابی رهنمایی‌شده تعیین شدید",
   "notification-title-ticket-created": "تکت جدید ایجاد شد",
   "notification-title-ticket-updated": "تکت به‌روزرسانی شد",
   "notification-title-submission-review": "ارسال آمادهٔ بررسی است",
   "notification-title-submission-approved-by-approver": "ارسال توسط تأییدکننده تأیید شد",
   "notification-title-submission-rejected-by-approver": "ارسال توسط تأییدکننده رد شد",
   "notification-title-module-assigned": "ماژول جدید تعیین شد",
   "notification-title-module-unassigned": "ماژول لغو شد",
   "notification-title-submission-approved": "ارسال تأیید شد",
   "notification-title-submission-rejected": "ارسال رد شد",
   "notification-title-submission-approval": "ارسال آمادهٔ تأیید است",
   "mark-as-read-label": "علامت‌گذاری به عنوان خوانده‌شده",
   "notification-actions-label": "اقدامات اطلاعیه"
};
